// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Layout ─────────────────────────────────── */
.dashboard_root__7n11a {
  background: var(--surface-sunken);
  color: var(--text);
  font-family: 'DM Sans', sans-serif;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* ── Header ─────────────────────────────────── */
.dashboard_header__tJi3p {
  background: var(--surface);
  border-bottom: 1px solid var(--border);
  padding: 15px 26px;
  display: flex;
  align-items: center;
  gap: 22px;
  position: sticky;
  top: 0;
  z-index: 10;
}

.dashboard_logo__FiQHq {
  font-family: 'Bebas Neue', cursive;
  color: var(--accent);
  letter-spacing: 2px;
  margin-right: 10px;
}

.dashboard_logoImg__hY6SQ {
  width: 29px;
  height: 29px;
  object-fit: contain;
  display: block;
}

.dashboard_nav__NPHeG {
  display: flex;
  gap: 6px;
  margin-left: 4px;
  flex-grow: 1;
}

.dashboard_navBtn__8s-Hs {
  background: none;
  border: none;
  color: var(--text-muted-alt);
  font-family: 'DM Sans', sans-serif;
  font-size: var(--fs-11-5);
  font-weight: var(--fw-semibold);
  letter-spacing: 0.15em;
  text-transform: uppercase;
  padding: 10px 16px;
  border-radius: var(--radius-9);
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  white-space: nowrap;
}

.dashboard_navBtn__8s-Hs.dashboard_active__vzNoh {
  background: color-mix(in srgb, var(--accent) 13%, transparent);
  color: var(--accent);
}

/* Theme switch: icon only, so it reads as a control rather than a nav item. */
.dashboard_themeIconBtn__CuYtN {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  flex: none;
  border: var(--hairline);
  border-radius: var(--radius-8);
  background: none;
  color: var(--text-muted-alt);
  cursor: pointer;
  transition: all 0.15s;
}
.dashboard_themeIconBtn__CuYtN:hover { color: var(--accent); border-color: var(--accent); }

/* Before/after tax. One bordered group, the active half filled — a choice
   between two states, not two separate buttons. */
.dashboard_taxToggle__gbyYB {
  display: inline-flex;
  flex: none;
  border: var(--hairline);
  border-radius: var(--radius-8);
  padding: 2px;
  gap: 2px;
}
.dashboard_taxOpt__n41Wx {
  background: none;
  border: none;
  border-radius: var(--radius-6);
  padding: 6px 13px;
  font-family: 'DM Sans', sans-serif;
  font-size: var(--fs-10);
  font-weight: var(--fw-semibold);
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: var(--text-muted-alt);
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.15s;
}
.dashboard_taxOpt__n41Wx:hover:not(.dashboard_taxOptActive__aBGJN) { color: var(--text); }
.dashboard_taxOptActive__aBGJN {
  background: var(--surface-raised);
  color: var(--accent);
}

/* The exception list reads as a status badge, not another nav destination:
   the count leads, and the tint says whether anything is waiting. */
.dashboard_navPill__b6N0D {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 10px 16px;
  border: none;
  border-radius: var(--radius-9);
  font-family: 'DM Sans', sans-serif;
  font-size: var(--fs-10-5);
  font-weight: var(--fw-semibold);
  letter-spacing: 0.13em;
  text-transform: uppercase;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.15s;
}
.dashboard_navPillAlert__RP-3G { background: color-mix(in srgb, currentColor 14%, transparent);
  color: var(--danger-soft);
}
.dashboard_navPillAlert__RP-3G:hover,
.dashboard_navPillClear__4gJY7:hover { background: color-mix(in srgb, currentColor 22%, transparent); }
.dashboard_navPillClear__4gJY7 { background: color-mix(in srgb, currentColor 12%, transparent);
  color: var(--success-soft);
}
.dashboard_navPillActive__pjcK- { background: color-mix(in srgb, currentColor 16%, transparent); }
/* The clock, in the header. Bronze and solid while you are off, so it reads as
   the thing to press; a quiet green tint once you are on, because then it is a
   status that happens to be tappable rather than a call to action. */
.dashboard_hdrClock__mvPlV {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 9px 16px 9px 13px;
  border: none;
  border-radius: 999px;
  background: var(--ace-bronze-warm);
  color: var(--ace-paper);
  font-family: inherit;
  font-size: var(--fs-13-5);
  white-space: nowrap;
  cursor: pointer;
}
.dashboard_hdrClock__mvPlV:hover { background: var(--ace-bronze-warm-deep); }
.dashboard_hdrClock__mvPlV:disabled { opacity: 0.6; cursor: default; }
.dashboard_hdrClockOn__9pR1d,
.dashboard_hdrClockOn__9pR1d:hover {
  background: color-mix(in srgb, var(--ace-success) 13%, transparent);
  color: var(--ace-success);
  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--ace-success) 35%, transparent);
}
.dashboard_hdrClockDot__6PGGM {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: currentColor;
  flex: none;
}

.dashboard_navPillDot__eWB1v {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
  flex: none;
}

.dashboard_navBtn__8s-Hs:hover:not(.dashboard_active__vzNoh) {
  color: var(--text);
  background: rgba(255,255,255,0.04);
}

/* ── Grouped nav dropdowns ───────────────────── */
.dashboard_navGroup__sM3\\+P { position: relative; display: inline-flex; }

.dashboard_navCaret__00Jwi { font-size: var(--fs-9); line-height: 1; opacity: 0.55; }

.dashboard_navMenu__vEjGy {
  position: absolute;
  top: calc(100% + 7px);
  left: 0;
  min-width: 216px;
  background: var(--surface-high);
  border: none;
  border-radius: var(--radius-12);
  padding: 7px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  box-shadow: 0 20px 40px -18px rgba(20, 15, 10, 0.28),
              inset 0 0 0 1px var(--border);
  z-index: 30;
}

.dashboard_navMenuItem__3ggHt {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 12px;
  border-radius: var(--radius-8);
  font-size: var(--fs-13-5);
  letter-spacing: 0.3px;
  color: var(--text-muted-warm);
  text-decoration: none;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s, color 0.12s;
}

.dashboard_navMenuItem__3ggHt:not(.dashboard_navMenuItemDisabled__jA9tp):hover {
  background: rgba(255,255,255,0.05);
  color: var(--text);
}

.dashboard_navMenuItemActive__6aVTA {
  color: var(--accent);
  background: rgba(201,149,106,0.1);
}

.dashboard_navMenuItemDisabled__jA9tp { color: var(--text-dim); cursor: default; }

.dashboard_clock__ekbmx {
  font-size: var(--fs-11);
  color: var(--text-dim);
  letter-spacing: 1px;
  font-variant-numeric: tabular-nums;
}

/* ── Stats bar ──────────────────────────────── */
.dashboard_statsBar__HpGzu {
  background: var(--surface);
  border-bottom: 1px solid var(--border);
  padding: 10px 24px;
  display: flex;
  gap: 32px;
  align-items: center;
  overflow: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.dashboard_statsBar__HpGzu::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.dashboard_statPill__FgM1Z {
  display: flex;
  flex-direction: column;
  gap: 1px;
  align-items: center;
}

.dashboard_localPill__YzA0l {
  border: 1px solid #d4c8ba;
  padding: 10px 15px;
  border-radius: var(--radius-10);
  cursor: pointer;
  background-color: var(--surface);
}

.dashboard_localPill__YzA0l.dashboard_active__vzNoh {
  border-color: rgba(109,184,138,0.35);
  background: #3e3b35;
}

.dashboard_noLocations__64fM2 {
  color: var(--text-dim);
  font-size: var(--fs-12);
  padding: 20px 0;
  width: 100%;
  text-align: center;
}

.dashboard_statLabel__VIF4h {
  font-size: var(--fs-9);
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: var(--text-dim);
}

.dashboard_statValue__fLcAt {
  font-family: 'Bebas Neue', cursive;
  font-size: var(--fs-24);
  color: var(--accent);
  letter-spacing: 1px;
  line-height: 1;
}

.dashboard_statValue__fLcAt.dashboard_white__O4hUb { color: var(--text); }
.dashboard_statValue__fLcAt.dashboard_green__gcZzk { color: var(--success); }

.dashboard_liveTag__cyCch {
  margin-left: auto;
  font-size: var(--fs-10);
  color: var(--text-dim);
  letter-spacing: 1px;
}

/* ── Body grid ──────────────────────────────── */
.dashboard_body__BGH0z {
  display: grid;
  grid-template-columns: 1fr 230px;
  flex: 1 1;
}

.dashboard_main__vd7bF {
  padding: 20px 24px;
  border-right: 1px solid var(--border);
  overflow-y: auto;
}

.dashboard_sidebar__PJFLv {
  padding: 18px 16px;
  background: #0f0e0d;
  overflow-y: auto;
}

/* ── Section label ──────────────────────────── */
.dashboard_sectionLabel__GOGrU {
  font-size: var(--fs-9);
  letter-spacing: 2px;
  text-transform: uppercase;
  color: var(--text-dim);
  margin-bottom: 12px;
}

.dashboard_sidebarDivider__Ortfl {
  border: none;
  border-top: 1px solid var(--border);
  margin: 18px 0;
}

/* ── Filter bar ─────────────────────────────── */
.dashboard_filterBar__5eSUy {
  display: flex;
  gap: 6px;
  margin-bottom: 16px;
  align-items: center;
}

.dashboard_filterBtn__1NQCe {
  font-size: var(--fs-10);
  letter-spacing: 1px;
  text-transform: uppercase;
  padding: 4px 11px;
  border-radius: var(--radius-5);
  border: var(--hairline);
  background: none;
  color: var(--text-dim);
  cursor: pointer;
  font-family: 'DM Sans', sans-serif;
  transition: all 0.15s;
}

.dashboard_filterBtn__1NQCe.dashboard_active__vzNoh {
  background: rgba(201,149,106,0.13);
  color: var(--accent);
  border-color: transparent;
}

.dashboard_filterBtn__1NQCe:hover:not(.dashboard_active__vzNoh) {
  color: #a09080;
  border-color: var(--border-strong);
}

/* ── Appointment card ───────────────────────── */
/* The mockup's card: 14px radius, edge drawn as an inset ring so nothing
   competes with the location's left border — the one thing kept from before. */
.dashboard_apptCard__McZhz {
  background: var(--surface-card);
  /* \`border: none\` would kill the left border too: the inline width and colour
     the card sets have nothing to draw without a style. Only the left side
     keeps one. */
  border: 0 none;
  border-left-style: solid;
  border-radius: 14px;
  box-shadow: inset 0 0 0 1px var(--border);
  margin-bottom: 8px;
  overflow: hidden;
  transition: box-shadow 0.2s, opacity 0.3s;
}

.dashboard_apptCard__McZhz:hover { box-shadow: inset 0 0 0 1px var(--border-strong); }

.dashboard_apptCard__McZhz.dashboard_done__BAtuD { opacity: 0.38; }

.dashboard_apptCard__McZhz.dashboard_urgent__-zq6I { border-left-color: #c0392b; }
.dashboard_apptCard__McZhz.dashboard_high__bxk\\+i   { border-left-color: var(--accent); }
.dashboard_apptCard__McZhz.dashboard_medium__bLM8L { border-left-color: #4a8a6a; }

.dashboard_apptHeader__vAjmu { display: flex; align-items: center; justify-content: space-between; padding: 15px 17px 0; }

.dashboard_apptTime__haZ81 {
  font-family: 'DM Sans', sans-serif;
  font-weight: var(--fw-bold);
  font-size: 16px;
  letter-spacing: 0.03em;
  color: var(--ace-bronze-warm);
}

.dashboard_apptDue__atI4f {
  font-size: var(--fs-10);
  color: var(--text-muted-alt);
  letter-spacing: 0.5px;
}

.dashboard_apptDue__atI4f.dashboard_urgentText__C2t-b { color: #e05b4e; }

.dashboard_priorityBadge__1VLWz {
  font-size: var(--fs-8);
  letter-spacing: 1.5px;
  text-transform: uppercase;
  padding: 3px 8px;
  border-radius: var(--radius-4);
  font-weight: var(--fw-semibold);
}

.dashboard_priorityBadge__1VLWz.dashboard_urgent__-zq6I { background: rgba(192,57,43,0.13); color: #e05b4e; border: 1px solid rgba(192,57,43,0.27); }
.dashboard_priorityBadge__1VLWz.dashboard_high__bxk\\+i   { background: rgba(201,149,106,0.13); color: var(--accent); border: 1px solid rgba(201,149,106,0.27); }
.dashboard_priorityBadge__1VLWz.dashboard_medium__bLM8L { background: rgba(74,138,110,0.13); color: var(--success); border: 1px solid rgba(74,138,110,0.27); }

.dashboard_apptInfo__1kcBv {
  padding: 0 14px 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.dashboard_apptCar__yqv9e {
  font-size: var(--fs-15);
  font-weight: var(--fw-medium);
  color: var(--text);
  flex: 1 1;
  min-width: 120px;
}

.dashboard_apptCar__yqv9e.dashboard_crossed__YFmFd {
  text-decoration: line-through;
  color: var(--text-dim);
}

.dashboard_apptService__a6HSE {
  font-size: var(--fs-11);
  color: var(--text-muted-alt);
  font-style: italic;
  display: block;
  margin-top: 1px;
}

.dashboard_apptDetailer__3Nnev {
  font-size: var(--fs-10);
  background: var(--border);
  padding: 2px 9px;
  border-radius: var(--radius-4);
  color: #a09080;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.dashboard_apptBay__kVq1y {
  font-size: var(--fs-10);
  background: #1e2a24;
  padding: 2px 9px;
  border-radius: var(--radius-4);
  color: var(--success);
  letter-spacing: 0.5px;
}
/* ── Controller row ──────────────────────────── */
.dashboard_controllerRow__D7Ckf {
  display: flex;
  gap: 4px;
  padding: 8px 14px;
  justify-content: right;
}

.dashboard_nextStepBtn__5WnLX {
  border: 1px solid #1e2a24;
  background: var(--surface-sunken);
  color: #a09080;
  border-radius: var(--radius-4);
  padding: 4px 12px;
  cursor: pointer;
  font-size: var(--fs-10);
  letter-spacing: 1px;
  font-family: inherit;
  text-transform: uppercase;
}

/* ── Checklist row ──────────────────────────── */
.dashboard_checklistRow__YwBKJ {
  display: flex;
  gap: 6px;
  padding: 10px 0;
  margin: 0 14px;
  border-top: 1px solid var(--border);
}

/* Geometry and type taken from the Ace mockup's own step buttons: 6px/4px
   padding, a 7px radius, 9.5px at 0.1em, and a hairline drawn as an inset ring
   rather than a border so the button does not grow by 2px when selected. */
.dashboard_checkStep__ZDqjB {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9.5px;
  font-weight: var(--fw-bold);
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--ace-slate);
  cursor: pointer;
  padding: 6px 4px;
  border-radius: 7px;
  border: none;
  background: transparent;
  box-shadow: inset 0 0 0 1px rgba(11, 11, 11, 0.1);
  transition: all 0.15s;
  user-select: none;
  white-space: nowrap;
}

.dashboard_checkStep__ZDqjB:hover { box-shadow: inset 0 0 0 1px var(--ace-slate); color: var(--ace-ink); }

/* Selected: solid dark green. The mockup tints it at 12% with green text; a
   filled chip was asked for instead, so the colour is the mockup's own
   C.paid (#4f6b4c) rather than a brighter green invented here. */
.dashboard_checkStep__ZDqjB.dashboard_done__BAtuD,
.dashboard_checkStep__ZDqjB.dashboard_done__BAtuD:hover {
  color: var(--ace-paper);
  background: var(--ace-success);
  box-shadow: none;
}

.dashboard_checkDot__c1Kqw {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 1.5px solid currentColor;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--fs-9);
  font-weight: var(--fw-bold);
  line-height: 1;
}

.dashboard_checkStep__ZDqjB.dashboard_done__BAtuD .dashboard_checkDot__c1Kqw {
  background: rgba(255,255,255,0.25);
  border-color: rgba(255,255,255,0.5);
}

/* ── Sidebar — Staff ────────────────────────── */
.dashboard_staffItem__UBsUt {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.dashboard_staffAvatar__dqnL3 {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--border);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--fs-11);
  font-weight: var(--fw-semibold);
  color: var(--accent);
  flex-shrink: 0;
}

.dashboard_staffName__LhBYt {
  font-size: var(--fs-12);
  font-weight: var(--fw-medium);
  color: var(--border-light);
}

.dashboard_staffStatus__vDuwL {
  font-size: var(--fs-9);
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-top: 1px;
}

.dashboard_staffStatus__vDuwL.dashboard_available__LJp\\+Y { color: var(--success); }
.dashboard_staffStatus__vDuwL.dashboard_busy__BwOQv      { color: var(--accent); }
.dashboard_staffStatus__vDuwL.dashboard_break__NSqYU     { color: var(--text-muted-alt); }

.dashboard_staffDot__GTuem {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}

.dashboard_staffDot__GTuem.dashboard_available__LJp\\+Y { background: var(--success); }
.dashboard_staffDot__GTuem.dashboard_busy__BwOQv      { background: var(--accent); }
.dashboard_staffDot__GTuem.dashboard_break__NSqYU     { background: var(--text-faint); }

/* ── Sidebar — Bays ─────────────────────────── */
.dashboard_bayGrid__WkAwz {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
  margin-top: 8px;
}

.dashboard_bayCell__0pWgC {
  background: var(--surface-high);
  border: var(--hairline);
  border-radius: var(--radius-6);
  padding: 8px 4px;
  text-align: center;
  transition: all 0.2s;
}

.dashboard_bayCell__0pWgC.dashboard_active__vzNoh {
  border-color: rgba(201,149,106,0.27);
  background: rgba(201,149,106,0.07);
}

.dashboard_bayNum__z1\\+Ij {
  font-family: 'Bebas Neue', cursive;
  font-size: var(--fs-17);
  color: var(--text-dim);
}

.dashboard_bayCell__0pWgC.dashboard_active__vzNoh .dashboard_bayNum__z1\\+Ij { color: var(--accent); }

.dashboard_bayLabel__4qevV {
  font-size: var(--fs-7);
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--border-strong);
  margin-top: 1px;
}

.dashboard_bayCell__0pWgC.dashboard_active__vzNoh .dashboard_bayLabel__4qevV { color: #7a6e62; }

/* ── Sidebar — Rankings ─────────────────────── */
.dashboard_rankItem__P9gU9 {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 7px;
  padding: 6px 8px;
  background: var(--surface-high);
  border-radius: var(--radius-6);
  border: var(--hairline);
}

.dashboard_rankNum__UdyOd {
  font-family: 'Bebas Neue', cursive;
  font-size: var(--fs-14);
  color: var(--border-strong);
  width: 16px;
  text-align: center;
  flex-shrink: 0;
}

.dashboard_rankNum__UdyOd.dashboard_gold__JsivS { color: var(--accent); }

.dashboard_rankName__0MxB\\+ {
  font-size: var(--fs-11);
  font-weight: var(--fw-medium);
  color: var(--border-light);
  flex: 1 1;
}

.dashboard_rankPts__5VshC {
  font-size: var(--fs-11);
  color: var(--accent);
  font-weight: var(--fw-semibold);
}

/* ── Analytics tab ──────────────────────────── */
.dashboard_analyticsGrid__6VukR {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 20px;
}

.dashboard_analyticsCard__aJZaH {
  background: var(--surface-high);
  border: var(--hairline);
  border-radius: var(--radius-8);
  padding: 14px;
}

.dashboard_aLabel__777jO {
  font-size: var(--fs-9);
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: var(--text-dim);
  margin-bottom: 4px;
}

.dashboard_aValue__Dz\\+tc {
  font-family: 'Bebas Neue', cursive;
  font-size: var(--fs-30);
  color: var(--accent);
  letter-spacing: 1px;
  line-height: 1;
}

.dashboard_aValue__Dz\\+tc span {
  font-size: var(--fs-14);
  color: var(--text-muted-alt);
}

.dashboard_aSub__wHg9t {
  font-size: var(--fs-10);
  color: var(--success);
  margin-top: 3px;
}

.dashboard_aSub__wHg9t.dashboard_amber__iuMjC { color: var(--accent); }

/* ── Workload bars ───────────────────────────── */
.dashboard_effBarWrap__A0hOP { margin-top: 10px; }

.dashboard_effLabel__krjGs {
  display: flex;
  justify-content: space-between;
  font-size: var(--fs-9);
  color: var(--text-dim);
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.dashboard_effBarBg__OMCBa {
  background: var(--border);
  border-radius: var(--radius-4);
  height: 4px;
  overflow: hidden;
}

.dashboard_effBarFill__IwLuI {
  height: 100%;
  border-radius: var(--radius-4);
}

/* ── Full rankings list ─────────────────────── */
.dashboard_rankItemFull__gbkiY {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  padding: 10px 14px;
  background: var(--surface-high);
  border-radius: var(--radius-8);
  border: var(--hairline);
}

.dashboard_rankDelta__u878A {
  font-size: var(--fs-10);
}

.dashboard_rankDelta__u878A.dashboard_positive__Q-Qkl { color: var(--success); }
.dashboard_rankDelta__u878A.dashboard_negative__85QmB { color: #e05b4e; }

/* ── QR Modal ───────────────────────────────── */
.dashboard_qrOverlay__alteC {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.dashboard_qrPanel__wAWbW {
  background: var(--surface-high);
  border: var(--hairline);
  border-radius: var(--radius-16);
  padding: 28px;
  max-width: 340px;
  width: 90%;
  text-align: center;
}

.dashboard_qrEyebrow__cPt9- {
  font-size: var(--fs-10);
  letter-spacing: 2px;
  text-transform: uppercase;
  color: var(--text-dim);
  margin-bottom: 6px;
}

.dashboard_qrCarName__KFNVc {
  font-size: var(--fs-16);
  font-weight: var(--fw-semibold);
  color: var(--text);
  margin-bottom: 4px;
}

.dashboard_qrServiceName__rmPVZ {
  font-size: var(--fs-12);
  color: var(--text-muted-alt);
  margin-bottom: 20px;
}

.dashboard_qrCodeWrap__7hAE5 {
  display: inline-block;
  background: var(--surface-high);
  padding: 12px;
  border-radius: var(--radius-10);
  border: var(--hairline);
  margin-bottom: 16px;
}

.dashboard_qrHint__S28iP {
  font-size: var(--fs-13);
  color: var(--text-muted-alt);
  margin-bottom: 20px;
  line-height: 1.5;
}

.dashboard_qrUrlBox__B9PjK {
  background: var(--surface-sunken);
  border: var(--hairline);
  border-radius: var(--radius-8);
  padding: 8px 12px;
  font-size: var(--fs-10);
  color: var(--text-dim);
  word-break: break-all;
  margin-bottom: 16px;
  text-align: left;
}

.dashboard_qrCloseBtn__Hh5K2 {
  background: #c9956a22;
  border: 1px solid #c9956a44;
  color: var(--accent);
  border-radius: var(--radius-8);
  padding: 10px 24px;
  cursor: pointer;
  font-family: inherit;
  font-size: var(--fs-13);
  letter-spacing: 1px;
  text-transform: uppercase;
}

/* ── Photo strip ────────────────────────────── */
.dashboard_photoStripWrap__rONuW {
  margin: 0 14px 10px;
}

.dashboard_photoStripLabel__kFMTx {
  font-size: var(--fs-8);
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: var(--text-dim);
  margin-bottom: 6px;
}

.dashboard_photoStripRow__XbQ8t {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.dashboard_photoThumb__ZcVqh {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: var(--radius-6);
}

.dashboard_photoThumbBefore__4sDH7 { border: 2px solid #5b8fa866; }
.dashboard_photoThumbAfter__E5DK-  { border: 2px solid #6db88a66; }

/* ── Appointment card internals ─────────────── */
.dashboard_urgentBanner__yQRJW {
  background: rgba(180,30,30,0.85);
  padding: 4px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dashboard_urgentLabel__HhCW3 {
  font-family: 'Bebas Neue', cursive;
  font-size: var(--fs-28);
  color: #ffcccc;
  letter-spacing: 4px;
}

.dashboard_urgentChangeBtn__YZFwz {
  background: rgba(255,255,255,0.15);
  border: 1px solid rgba(255,200,200,0.3);
  color: #ffcccc;
  border-radius: var(--radius-4);
  padding: 2px 8px;
  cursor: pointer;
  font-size: var(--fs-9);
  letter-spacing: 1px;
  font-family: inherit;
  text-transform: uppercase;
}

.dashboard_cardAmountTag__Ued0H {
  font-size: var(--fs-12);
  color: var(--accent);
  font-weight: var(--fw-medium);
}

.dashboard_cameraBtn__roaIi {
  background: rgba(201,149,106,0.1);
  border: 1px solid rgba(201,149,106,0.25);
  color: var(--accent);
  border-radius: var(--radius-5);
  padding: 4px 8px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  font-size: var(--fs-13);
  line-height: 1;
}
.dashboard_cameraBtnDone__Zf96B  { background: rgba(109,184,138,0.15); border-color: rgba(109,184,138,0.35); color: var(--success); }
.dashboard_cameraBtnError__JMcV4 { background: rgba(224,48,48,0.13);   border-color: rgba(224,48,48,0.3);   color: #e05050; }



/* ── Photo Carousel Modal ───────────────────────────────────────────────────── */
.dashboard_carouselOverlay__9423d {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.92);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
}

.dashboard_carouselPanel__LzWbi {
  background: var(--surface-high);
  border: var(--hairline);
  border-radius: var(--radius-16);
  padding: 20px;
  width: min(92vw, 680px);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.dashboard_carouselHeader__uNdbg {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.dashboard_carouselCar__vtz\\+E {
  font-size: var(--fs-15);
  font-weight: var(--fw-semibold);
  color: var(--text);
}

.dashboard_carouselService__hs4Sy {
  font-size: var(--fs-11);
  color: var(--text-muted-alt);
  margin-top: 2px;
}

.dashboard_carouselClose__DJEh1 {
  background: none;
  border: var(--hairline);
  color: var(--text-muted-alt);
  border-radius: var(--radius-6);
  width: 28px;
  height: 28px;
  cursor: pointer;
  font-size: var(--fs-13);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.dashboard_carouselImgWrap__8WI\\+n {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--surface-sunken);
  border-radius: var(--radius-10);
  overflow: hidden;
  min-height: 300px;
}

.dashboard_carouselImg__i97QJ {
  max-width: 100%;
  max-height: 60vh;
  object-fit: contain;
  display: block;
}

.dashboard_carouselArrow__PHaH5 {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0,0,0,0.5);
  border: 1px solid rgba(255,255,255,0.1);
  color: var(--text);
  border-radius: 50%;
  width: 36px;
  height: 36px;
  font-size: var(--fs-22);
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}
.dashboard_carouselArrow__PHaH5:disabled { opacity: 0.2; cursor: default; }
.dashboard_carouselArrowLeft__t4nXQ  { left: 10px; }
.dashboard_carouselArrowRight__DOUYZ { right: 10px; }

.dashboard_carouselMeta__J7LEX {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dashboard_carouselPhase__eSqrg {
  font-size: var(--fs-9);
  letter-spacing: 2px;
  color: var(--info);
  background: rgba(122,158,201,0.1);
  border: 1px solid rgba(122,158,201,0.2);
  padding: 2px 8px;
  border-radius: var(--radius-4);
}

.dashboard_carouselCount__KVJE4 {
  font-size: var(--fs-11);
  color: var(--text-dim);
}

.dashboard_carouselDots__hLZFy {
  display: flex;
  gap: 6px;
  justify-content: center;
  flex-wrap: wrap;
}

.dashboard_carouselDot__5YYo7 {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--border);
  border: none;
  cursor: pointer;
  padding: 0;
}

.dashboard_carouselDotActive__QIvOn {
  background: var(--info);
}

.dashboard_carouselLoading__z-lgF {
  text-align: center;
  color: var(--text-dim);
  padding: 40px 0;
  font-size: var(--fs-13);
}

.dashboard_serviceList__2Ailh {
  margin: 0 14px 8px;
}

.dashboard_serviceRow__9iDUP {
  display: flex;
  align-items: flex-start;
  gap: 6px;
}

.dashboard_serviceBullet__kLemu {
  font-size: var(--fs-9);
  margin-top: 2px;
  flex-shrink: 0;
  opacity: 0.8;
}

.dashboard_serviceText__YnkRZ {
  font-size: var(--fs-11);
  color: #c8bfb4;
  line-height: 1.4;
}

.dashboard_serviceTextDone__IUfHy {
  color: var(--text-dim);
  text-decoration: line-through;
}

.dashboard_assignedRow__z-gHK {
  margin: 0 14px 8px;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.dashboard_assignedLabel__GJYO0 {
  font-size: var(--fs-8);
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: var(--text-dim);
}

.dashboard_assignedHint__dTMD3 {
  font-size: var(--fs-8);
  color: var(--border-strong);
}

.dashboard_dropTarget__7Lq8r {
  margin: 0 14px 8px;
  padding: 6px;
  border-radius: var(--radius-4);
  text-align: center;
  font-size: var(--fs-10);
  letter-spacing: 1px;
}

.dashboard_notesBox__ZcddT {
  margin: 0 14px 8px;
  padding: 6px 10px;
  background: var(--surface-sunken);
  border: var(--hairline);
  border-radius: var(--radius-4);
}

.dashboard_notesLabel__XmdSB {
  font-size: var(--fs-8);
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: var(--text-dim);
  margin-bottom: 3px;
}

.dashboard_notesText__NDeH\\+ {
  font-size: var(--fs-11);
  color: #a09080;
  line-height: 1.5;
  white-space: pre-wrap;
}

/* ── Booked-by line ─────────────────────────── */
.dashboard_bookedInfo__ckG30 {
  padding: 0 14px 10px;
  font-size: var(--fs-11);
  letter-spacing: 0.3px;
  margin-top: 6px;
  color: #8a7f74;
}
.dashboard_bookedInfoUrgent__p4SUz {
  color: #e08a8a;
}

/* ── Booked amount box ──────────────────────── */
.dashboard_bookedBox__M655a {
  margin: 8px 14px 12px;
  padding: 8px 12px;
  border: var(--hairline);
  border-radius: var(--radius-8);
  background: transparent;
}
.dashboard_bookedBoxLabel__JxyNs {
  font-size: var(--fs-8);
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: var(--text-dim);
  margin-bottom: 3px;
}
.dashboard_bookedBoxAmount__Gdv\\+Z {
  font-size: var(--fs-15);
  font-weight: var(--fw-bold);
  color: var(--text);
}

/* ── Location column ────────────────────────── */
.dashboard_locationCol__v72Xn {
  flex: 1 0 320px;
  min-width: 320px;
  max-width: 50%;
  border-right: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.dashboard_locationHeader__AJwkK {
  background: var(--surface);
  padding: 10px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}

/* The mockup sets these in the display face at 0.1em, not Bebas at 2px. */
.dashboard_locationName__vv67p {
  font-family: 'DM Sans', sans-serif;
  font-weight: var(--fw-heavy);
  font-size: 16px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.dashboard_locationMeta__Mx07W {
  margin-top: 5px;
  font-size: 10px;
  letter-spacing: 0.11em;
  text-transform: uppercase;
  color: var(--ace-slate);
}

.dashboard_locationUrgentCount__9u8OS {
  color: #e05050;
  margin-left: 6px;
}

.dashboard_locationCount__-vHeC {
  font-family: 'DM Sans', sans-serif;
  font-weight: var(--fw-bold);
  font-size: 18px;
}

.dashboard_locationBody__zHAjO {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 12px 10px;
}

.dashboard_locationLoading__hj5dL {
  font-size: var(--fs-12);
  padding: 20px 0;
  text-align: center;
  letter-spacing: 1px;
}

.dashboard_locationError__k4ypv {
  color: #e05b4e;
  font-size: var(--fs-11);
  padding: 20px 0;
  text-align: center;
}

.dashboard_locationEmpty__YD\\+CT {
  color: var(--text-dim);
  font-size: var(--fs-12);
  padding: 20px 0;
  text-align: center;
}

/* ── Staff member card ──────────────────────── */
.dashboard_staffCard__QfSbr {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
  padding: 6px 8px;
  background: var(--surface-high);
  border: var(--hairline);
  border-radius: var(--radius-7);
  cursor: grab;
  transition: border-color 0.15s;
}

.dashboard_staffCard__QfSbr:hover { border-color: var(--border-strong); }

.dashboard_staffDragHandle__OC04h {
  font-size: var(--fs-10);
  color: var(--border-strong);
  flex-shrink: 0;
}

.dashboard_staffInitialBubble__0Dast {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--border);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--fs-9);
  font-weight: var(--fw-semibold);
  color: var(--accent);
  flex-shrink: 0;
}

.dashboard_staffInfo__szU0J { flex: 1 1; min-width: 0; }

.dashboard_staffNameText__Eel1M {
  font-size: var(--fs-11);
  font-weight: var(--fw-medium);
  color: var(--border-light);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dashboard_staffStatusBtn__KIXGu {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 1px;
}

.dashboard_staffStatusDot__t3\\+jx {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.dashboard_staffStatusText__CPRoq {
  font-size: var(--fs-8);
  letter-spacing: 1.2px;
  text-transform: uppercase;
}

/* ── Sidebar ────────────────────────────────── */
.dashboard_sidebarPanel__T7jLN {
  width: 210px;
  flex-shrink: 0;
  background: #0f0e0d;
  border-left: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.dashboard_sidebarTopSection__UUaPQ {
  padding: 14px 16px 8px;
  flex-shrink: 0;
  border-bottom: 1px solid var(--border);
}

.dashboard_sidebarHint__f1eGc {
  font-size: var(--fs-8);
  color: var(--border-strong);
  letter-spacing: 1px;
  text-transform: uppercase;
}

.dashboard_sidebarStaffList__GpQvb {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 10px 12px;
  scrollbar-width: none;        /* Firefox */
  -ms-overflow-style: none;     /* IE / old Edge */
}
.dashboard_sidebarStaffList__GpQvb::-webkit-scrollbar { /* Chrome / Safari */
  display: none;
}

/* Collapsible STAFF panel */
.dashboard_sidebarHeaderRow__pPpOy {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.dashboard_sidebarToggle__3j-PG {
  background: transparent;
  border: var(--hairline);
  color: var(--text-muted-alt);
  border-radius: var(--radius-6);
  width: 22px;
  height: 22px;
  padding: 0;
  line-height: 1;
  font-size: var(--fs-13);
  cursor: pointer;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dashboard_sidebarToggle__3j-PG:hover { border-color: var(--accent); color: var(--accent); }

.dashboard_sidebarPanelMin__EHYrd { width: 44px; }
.dashboard_sidebarPanelMin__EHYrd .dashboard_sidebarTopSection__UUaPQ { padding: 12px 0; }
.dashboard_sidebarPanelMin__EHYrd .dashboard_sidebarHeaderRow__pPpOy { justify-content: center; }

.dashboard_lightRoot__FPAQ0 .dashboard_sidebarToggle__3j-PG {
  border-color: var(--border-light);
  color: var(--text-muted-on-light);
}
.dashboard_lightRoot__FPAQ0 .dashboard_sidebarToggle__3j-PG:hover { border-color: var(--accent-strong); color: var(--accent-strong); }

.dashboard_sidebarBottomSection__WRA87 {
  border-top: 1px solid var(--border);
  padding: 12px 16px;
  flex-shrink: 0;
}

/* ── Header controls ────────────────────────── */
.dashboard_headerRight__nzRg8 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 14px;
  margin-left: auto;
}

.dashboard_headerClockGroup__c6bbU {
  /* A little air before the status block, so the controls to its left read as
     one group rather than running into it. */
  margin-left: 6px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.dashboard_headerLiveLabel__9mSlr {
  font-size: var(--fs-10);
  color: var(--text-muted-alt);
  letter-spacing: 0.14em;
  text-transform: uppercase;
  line-height: 1.6;
}

.dashboard_headerSyncLabel__EJtL0 {
  font-size: var(--fs-10);
  color: var(--text-muted-alt);
  letter-spacing: 0.14em;
  text-transform: uppercase;
  line-height: 1.6;
  opacity: 0.62;
}

.dashboard_themeSwitchBtn__NzppN {
  background: none;
  border: none;
  box-shadow: inset 0 0 0 1px var(--border);
  color: var(--text-muted-alt);
  border-radius: var(--radius-9);
  padding: 9px 16px;
  cursor: pointer;
  font-family: inherit;
  font-size: var(--fs-10-5);
  letter-spacing: 0.13em;
  text-transform: uppercase;
}

/* Self-contained light theme for the shared Header, so it works on pages that
   don't wrap their content in \`.lightRoot\` (Transactions/Staff/Admin). */
.dashboard_headerLight__EZg\\+4 { background: var(--surface-light-background); border-bottom-color: var(--border-light); }
.dashboard_headerLight__EZg\\+4 .dashboard_logo__FiQHq { color: var(--accent-strong); }
.dashboard_headerLight__EZg\\+4 .dashboard_navBtn__8s-Hs { color: var(--text-muted-on-light); }
.dashboard_headerLight__EZg\\+4 .dashboard_navBtn__8s-Hs:hover:not(.dashboard_active__vzNoh) { color: var(--text-on-light); background: rgba(0,0,0,0.05); }
.dashboard_headerLight__EZg\\+4 .dashboard_themeIconBtn__CuYtN { border-color: var(--border-light); color: var(--text-muted-on-light); }
.dashboard_headerLight__EZg\\+4 .dashboard_themeIconBtn__CuYtN:hover { color: var(--accent-strong); border-color: var(--accent-strong); }
.dashboard_headerLight__EZg\\+4 .dashboard_taxToggle__gbyYB { border-color: var(--border-light); }
.dashboard_headerLight__EZg\\+4 .dashboard_taxOpt__n41Wx { color: var(--text-muted-on-light); }
.dashboard_headerLight__EZg\\+4 .dashboard_taxOpt__n41Wx:hover:not(.dashboard_taxOptActive__aBGJN) { color: var(--text-on-light); }
.dashboard_headerLight__EZg\\+4 .dashboard_taxOptActive__aBGJN { background: var(--accent-background); color: var(--accent-strong); }
.dashboard_headerLight__EZg\\+4 .dashboard_navPillAlert__RP-3G { background: color-mix(in srgb, var(--ace-error) 9%, transparent); color: var(--ace-error); }
.dashboard_headerLight__EZg\\+4 .dashboard_navPillClear__4gJY7 { background: color-mix(in srgb, var(--success-on-light) 10%, transparent); color: var(--success-on-light); }
/* The light scope sets the pill's colour at two-class specificity, so the hover
   and active tints have to be stated here too or they never win. */
.dashboard_headerLight__EZg\\+4 .dashboard_navPillAlert__RP-3G:hover,
.dashboard_headerLight__EZg\\+4 .dashboard_navPillClear__4gJY7:hover { background: color-mix(in srgb, currentColor 22%, transparent); }
.dashboard_headerLight__EZg\\+4 .dashboard_navPillActive__pjcK-      { background: color-mix(in srgb, currentColor 16%, transparent); }
.dashboard_headerLight__EZg\\+4 .dashboard_navBtn__8s-Hs.dashboard_active__vzNoh {
  background: var(--ace-tab-active);
  color: var(--ace-tab-ink);
}
.dashboard_headerLight__EZg\\+4 .dashboard_headerLiveLabel__9mSlr,
.dashboard_headerLight__EZg\\+4 .dashboard_headerSyncLabel__EJtL0 { color: var(--ace-slate); }
.dashboard_headerLight__EZg\\+4 .dashboard_themeSwitchBtn__NzppN {
  border: none;
  box-shadow: inset 0 0 0 1px var(--ace-stroke-ring);
  color: var(--ace-slate);
}

.dashboard_navMenuLight__orTLd {
  background: var(--surface-light-card);
  box-shadow: 0 20px 40px -18px rgba(20, 15, 10, 0.28),
              inset 0 0 0 1px var(--ace-stroke-hair);
}
.dashboard_navMenuLight__orTLd .dashboard_navMenuItem__3ggHt { color: #6a5c4e; }
.dashboard_navMenuLight__orTLd .dashboard_navMenuItem__3ggHt:not(.dashboard_navMenuItemDisabled__jA9tp):hover { background: rgba(0,0,0,0.05); color: var(--text-on-light); }
.dashboard_navMenuLight__orTLd .dashboard_navMenuItemActive__6aVTA { color: var(--ace-tab-ink); background: var(--ace-menu-item); }
.dashboard_navMenuLight__orTLd .dashboard_navMenuItemDisabled__jA9tp { color: #b0a394; }

/* ── Stats bar divider ──────────────────────── */
.dashboard_statsBarDivider__5Edvw {
  width: 1px;
  background: var(--border);
  margin: 0 8px;
  align-self: stretch;
}

/* ── Date nav ───────────────────────────────── */
.dashboard_dateNavBtn__a\\+qPH {
  background: none;
  border: var(--hairline);
  color: var(--text-muted-alt);
  border-radius: var(--radius-5);
  padding: 4px 10px;
  cursor: pointer;
  font-family: inherit;
  font-size: var(--fs-13);
}

.dashboard_dateNavDisplay__Nyie- {
  font-family: 'Bebas Neue', cursive;
  font-size: var(--fs-16);
  letter-spacing: 1.5px;
  padding: 4px 12px;
  border-radius: var(--radius-5);
  cursor: pointer;
  min-width: 100px;
  text-align: center;
}

.dashboard_dateNavDisplayToday__ezi\\+1 {
  color: var(--accent);
  border: 1px solid transparent;
  background: var(--accent-wash);
}

.dashboard_dateNavDisplayOther__-SRgU {
  border: var(--hairline);
  background: none;
}

.dashboard_dateNavHiddenInput__VbJdc {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.dashboard_dateNavTodayBtn__9FsMV {
  background: #c9956a22;
  border: 1px solid #c9956a44;
  color: var(--accent);
  border-radius: var(--radius-5);
  padding: 4px 10px;
  cursor: pointer;
  font-family: inherit;
  font-size: var(--fs-10);
  letter-spacing: 1px;
  text-transform: uppercase;
}

.dashboard_uploadPickerOverlay__KS7qw {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 1200;
}

.dashboard_uploadPickerPanel__CVGGP {
  width: min(420px, calc(100vw - 20px));
  background: var(--surface);
  border: var(--hairline);
  border-radius: 12px 12px 0 0;
  padding: 10px;
  margin-bottom: max(10px, env(safe-area-inset-bottom));
  box-shadow: 0 -8px 24px rgba(0,0,0,0.35);
}

.dashboard_uploadPickerItem__fPadF {
  width: 100%;
  border: var(--hairline);
  background: var(--surface-high);
  color: var(--text);
  border-radius: var(--radius-8);
  padding: 12px 14px;
  font-family: inherit;
  font-size: var(--fs-12);
  letter-spacing: 0.8px;
  cursor: pointer;
  margin-bottom: 8px;
}

.dashboard_uploadPickerItem__fPadF:last-child {
  margin-bottom: 0;
}

.dashboard_uploadPickerCancel__1Y820 {
  color: #b8a898;
}

/* No 1600px column here. The queue is a board — four garage lanes and the
   staff rail — and every pixel taken off its width comes out of the cards. */
.dashboard_mainContent__Ckbpb {
  display: flex;
  flex: 1 1;
  min-height: 0;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.dashboard_mainContent__Ckbpb::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.dashboard_locationsGrid__gYvxk {
  display: flex;
  flex: 1 1;
  min-width: 320px;
  overflow: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.dashboard_lightRoot__FPAQ0 {
  background: var(--surface-light-alt);
  color: var(--text-on-light);
}

.dashboard_lightRoot__FPAQ0 .dashboard_logo__FiQHq { color: var(--accent-strong); }
.dashboard_lightRoot__FPAQ0 .dashboard_clock__ekbmx { color: var(--text-muted-on-light); }

.dashboard_lightRoot__FPAQ0 .dashboard_navBtn__8s-Hs { color: var(--text-muted-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_navBtn__8s-Hs:hover:not(.dashboard_active__vzNoh) {
  color: var(--text-on-light);
  background: rgba(0,0,0,0.05);
}
.dashboard_lightRoot__FPAQ0 .dashboard_navBtn__8s-Hs.dashboard_active__vzNoh {
  background: rgba(176,120,64,0.12);
  color: var(--accent-strong);
  border-color: rgba(176,120,64,0.3);
}

.dashboard_lightRoot__FPAQ0 .dashboard_statsBar__HpGzu {
  background: var(--surface-light-background);
  border-bottom-color: var(--border-light);
}

.dashboard_lightRoot__FPAQ0 .dashboard_statLabel__VIF4h { color: var(--text-muted-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_statValue__fLcAt { color: var(--accent-strong); }
.dashboard_lightRoot__FPAQ0 .dashboard_statValue__fLcAt.dashboard_green__gcZzk { color: #3a8a5a; }
.dashboard_lightRoot__FPAQ0 .dashboard_liveTag__cyCch { color: var(--text-muted-on-light); }

.dashboard_lightRoot__FPAQ0 .dashboard_sectionLabel__GOGrU { color: var(--text-muted-on-light); }

/* The mockup's card: a 14px radius on #fcfaf6 with its edge drawn as an inset
   ring, so the coloured left border is the only real border on the element. */
.dashboard_lightRoot__FPAQ0 .dashboard_apptCard__McZhz {
  background: #fcfaf6;
  border-color: transparent;
  border-radius: 14px;
  box-shadow: inset 0 0 0 1px rgba(11, 11, 11, 0.08);
}
.dashboard_lightRoot__FPAQ0 .dashboard_apptCard__McZhz:hover { box-shadow: inset 0 0 0 1px rgba(11, 11, 11, 0.18); }
.dashboard_lightRoot__FPAQ0 .dashboard_apptCard__McZhz.dashboard_done__BAtuD { opacity: 0.45; }

.dashboard_lightRoot__FPAQ0 .dashboard_apptTime__haZ81 { color: var(--accent-strong); }
.dashboard_lightRoot__FPAQ0 .dashboard_apptDue__atI4f  { color: var(--text-muted-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_apptCar__yqv9e  { color: var(--text-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_apptCar__yqv9e.dashboard_crossed__YFmFd { color: var(--text-muted-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_apptDetailer__3Nnev {
  background: var(--text);
  color: #7a6e62;
}

.dashboard_lightRoot__FPAQ0 .dashboard_checklistRow__YwBKJ { border-top-color: var(--border-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_checkStep__ZDqjB { color: var(--ace-slate); background: transparent; }
.dashboard_lightRoot__FPAQ0 .dashboard_checkStep__ZDqjB:hover { box-shadow: inset 0 0 0 1px var(--ace-success); color: var(--ace-ink); }
.dashboard_lightRoot__FPAQ0 .dashboard_checkStep__ZDqjB.dashboard_done__BAtuD,
.dashboard_lightRoot__FPAQ0 .dashboard_checkStep__ZDqjB.dashboard_done__BAtuD:hover {
  color: var(--ace-paper);
  background: var(--ace-success);
  box-shadow: none;
}

.dashboard_lightRoot__FPAQ0 .dashboard_rankItem__P9gU9 {
  background: var(--surface-light);
  border-color: var(--border-light);
}
.dashboard_lightRoot__FPAQ0 .dashboard_rankNum__UdyOd      { color: #c4b4a4; }
.dashboard_lightRoot__FPAQ0 .dashboard_rankNum__UdyOd.dashboard_gold__JsivS { color: var(--accent-strong); }
.dashboard_lightRoot__FPAQ0 .dashboard_rankName__0MxB\\+     { color: var(--text-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_rankPts__5VshC      { color: var(--accent-strong); }

.dashboard_lightRoot__FPAQ0 .dashboard_analyticsCard__aJZaH {
  background: var(--surface-light);
  border-color: var(--border-light);
}
.dashboard_lightRoot__FPAQ0 .dashboard_aLabel__777jO { color: var(--text-muted-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_aValue__Dz\\+tc { color: var(--accent-strong); }
.dashboard_lightRoot__FPAQ0 .dashboard_aSub__wHg9t   { color: #3a8a5a; }

.dashboard_lightRoot__FPAQ0 .dashboard_rankItemFull__gbkiY {
  background: var(--surface-light);
  border-color: var(--border-light);
}

/* lightRoot — new classes */
.dashboard_lightRoot__FPAQ0 .dashboard_qrPanel__wAWbW {
  background: var(--surface-light);
  border-color: var(--border-light);
}
.dashboard_lightRoot__FPAQ0 .dashboard_qrEyebrow__cPt9-   { color: var(--text-muted-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_qrCarName__KFNVc   { color: var(--text-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_qrServiceName__rmPVZ { color: #7a6e62; }
.dashboard_lightRoot__FPAQ0 .dashboard_qrCodeWrap__7hAE5  { background: var(--surface-light); border-color: var(--border-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_qrHint__S28iP      { color: #7a6e62; }
.dashboard_lightRoot__FPAQ0 .dashboard_qrUrlBox__B9PjK    { background: var(--surface-light-background); border-color: var(--border-light); color: var(--text-muted-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_qrCloseBtn__Hh5K2  { background: rgba(176,120,64,0.1); border-color: rgba(176,120,64,0.3); color: var(--accent-strong); }

.dashboard_lightRoot__FPAQ0 .dashboard_photoStripLabel__kFMTx { color: var(--text-muted-on-light); }

.dashboard_lightRoot__FPAQ0 .dashboard_cardAmountTag__Ued0H { color: var(--accent-strong); }

.dashboard_lightRoot__FPAQ0 .dashboard_cameraBtn__roaIi      { background: rgba(176,120,64,0.08); border-color: rgba(176,120,64,0.25); color: var(--accent-strong); }
.dashboard_lightRoot__FPAQ0 .dashboard_cameraBtnDone__Zf96B  { background: rgba(58,138,90,0.12);  border-color: rgba(58,138,90,0.3);  color: #3a8a5a; }
.dashboard_lightRoot__FPAQ0 .dashboard_cameraBtnError__JMcV4 { background: rgba(200,40,40,0.1);   border-color: rgba(200,40,40,0.25); color: #c02020; }

.dashboard_lightRoot__FPAQ0 .dashboard_serviceText__YnkRZ      { color: #4a3a2a; }
.dashboard_lightRoot__FPAQ0 .dashboard_serviceTextDone__IUfHy  { color: var(--text-muted-on-light); }

.dashboard_lightRoot__FPAQ0 .dashboard_assignedLabel__GJYO0 { color: var(--text-muted-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_assignedHint__dTMD3  { color: #c4b4a4; }

.dashboard_lightRoot__FPAQ0 .dashboard_notesBox__ZcddT {
  background: var(--surface-light-raised);
  border-color: var(--border-light);
}
.dashboard_lightRoot__FPAQ0 .dashboard_notesLabel__XmdSB { color: var(--text-muted-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_notesText__NDeH\\+  { color: #6a5c4e; }

.dashboard_lightRoot__FPAQ0 .dashboard_bookedInfo__ckG30       { color: var(--text-muted-on-light); }  /* light mode, normal */
.dashboard_lightRoot__FPAQ0 .dashboard_bookedInfoUrgent__p4SUz { color: var(--danger); }  /* light mode, urgent */
.dashboard_lightRoot__FPAQ0 .dashboard_bookedBox__M655a        { background: transparent; border-color: var(--border-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_bookedBoxLabel__JxyNs   { color: var(--text-muted-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_bookedBoxAmount__Gdv\\+Z  { color: var(--text-on-light); }

.dashboard_lightRoot__FPAQ0 .dashboard_locationCol__v72Xn    { border-right-color: var(--border-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_locationHeader__AJwkK { background: var(--surface-light-background); }
.dashboard_lightRoot__FPAQ0 .dashboard_locationMeta__Mx07W   { color: var(--text-muted-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_locationBody__zHAjO   { background: var(--surface-light-background); }
.dashboard_lightRoot__FPAQ0 .dashboard_locationEmpty__YD\\+CT  { color: var(--text-muted-on-light); }

.dashboard_lightRoot__FPAQ0 .dashboard_staffCard__QfSbr {
  background: var(--surface-light);
  border-color: var(--border-light);
}
.dashboard_lightRoot__FPAQ0 .dashboard_staffCard__QfSbr:hover { border-color: var(--text-dim-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_staffDragHandle__OC04h    { color: #c4b4a4; }
.dashboard_lightRoot__FPAQ0 .dashboard_staffInitialBubble__0Dast { background: var(--text); color: var(--accent-strong); }
.dashboard_lightRoot__FPAQ0 .dashboard_staffNameText__Eel1M      { color: var(--text-on-light); }

.dashboard_lightRoot__FPAQ0 .dashboard_sidebarPanel__T7jLN {
  background: var(--surface-light-background);
  border-left-color: var(--border-light);
}
.dashboard_lightRoot__FPAQ0 .dashboard_sidebarTopSection__UUaPQ  { border-bottom-color: var(--border-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_sidebarHint__f1eGc        { color: #c4b4a4; }
.dashboard_lightRoot__FPAQ0 .dashboard_sidebarBottomSection__WRA87 { border-top-color: var(--border-light); }

.dashboard_lightRoot__FPAQ0 .dashboard_headerSyncLabel__EJtL0 { color: var(--text-muted-on-light); }

.dashboard_lightRoot__FPAQ0 .dashboard_themeSwitchBtn__NzppN {
  border-color: var(--border-light);
  color: #7a6e62;
}

.dashboard_lightRoot__FPAQ0 .dashboard_statsBarDivider__5Edvw { background: var(--border-light); }

.dashboard_lightRoot__FPAQ0 .dashboard_dateNavBtn__a\\+qPH {
  border-color: var(--border-light);
  color: #7a6e62;
}
.dashboard_lightRoot__FPAQ0 .dashboard_dateNavDisplayOther__-SRgU {
  color: var(--text-on-light);
  border-color: var(--border-light);
}
.dashboard_lightRoot__FPAQ0 .dashboard_dateNavTodayBtn__9FsMV {
  background: rgba(176,120,64,0.1);
  border-color: rgba(176,120,64,0.3);
  color: var(--accent-strong);
}

.dashboard_lightRoot__FPAQ0 .dashboard_uploadPickerPanel__CVGGP {
  background: var(--surface-light-background);
  border-color: var(--border-light);
}

.dashboard_lightRoot__FPAQ0 .dashboard_uploadPickerItem__fPadF {
  background: var(--surface-light);
  border-color: var(--border-light);
  color: var(--text-on-light);
}

.dashboard_lightRoot__FPAQ0 .dashboard_uploadPickerCancel__1Y820 {
  color: #7a6e62;
}

.dashboard_lightRoot__FPAQ0 .dashboard_localPill__YzA0l {
  background: var(--surface-light-background);
}

.dashboard_lightRoot__FPAQ0 .dashboard_localPill__YzA0l.dashboard_active__vzNoh {
  border-color: rgba(109,184,138,0.35);
  background: #f5f0eb;
}

/* ── Carousel — light mode ──────────────────── */
.dashboard_lightRoot__FPAQ0 .dashboard_carouselOverlay__9423d {
  background: rgba(0,0,0,0.65);
}

.dashboard_lightRoot__FPAQ0 .dashboard_carouselPanel__LzWbi {
  background: var(--surface-light);
  border-color: var(--border-light);
}

.dashboard_lightRoot__FPAQ0 .dashboard_carouselCar__vtz\\+E   { color: var(--text-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_carouselService__hs4Sy { color: #7a6e62; }

.dashboard_lightRoot__FPAQ0 .dashboard_carouselClose__DJEh1 {
  border-color: var(--border-light);
  color: var(--text-muted-on-light);
}
.dashboard_lightRoot__FPAQ0 .dashboard_carouselClose__DJEh1:hover {
  background: var(--surface-light-background);
}

.dashboard_lightRoot__FPAQ0 .dashboard_carouselImgWrap__8WI\\+n { background: var(--surface-light-background); }

.dashboard_lightRoot__FPAQ0 .dashboard_carouselArrow__PHaH5 {
  background: rgba(255,255,255,0.75);
  border-color: rgba(0,0,0,0.12);
  color: var(--text-on-light);
}

.dashboard_lightRoot__FPAQ0 .dashboard_carouselPhase__eSqrg {
  color: #5a7a9a;
  background: rgba(90,122,154,0.1);
  border-color: rgba(90,122,154,0.25);
}

.dashboard_lightRoot__FPAQ0 .dashboard_carouselCount__KVJE4 { color: var(--text-muted-on-light); }

.dashboard_lightRoot__FPAQ0 .dashboard_carouselDot__5YYo7 { background: var(--border-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_carouselDotActive__QIvOn { background: var(--info); }

.dashboard_lightRoot__FPAQ0 .dashboard_carouselLoading__z-lgF { color: var(--text-muted-on-light); }

.dashboard_lightRoot__FPAQ0 .dashboard_controllerRow__D7Ckf .dashboard_nextStepBtn__5WnLX {
  color: #1e2a24;
  background: var(--surface-light-raised);
}

/* ── Next Step modal ─────────────────────────── */
.dashboard_nextStepPanel__oPwsA {
  background: var(--surface-high);
  border: var(--hairline);
  border-radius: var(--radius-16);
  padding: 24px;
  max-width: 380px;
  width: 90%;
  text-align: left;
}

.dashboard_nextStepEyebrow__41YqY {
  font-size: var(--fs-10);
  letter-spacing: 2px;
  text-transform: uppercase;
  color: var(--accent);
  margin-bottom: 6px;
}

.dashboard_nextStepCar__T9cbx {
  font-size: var(--fs-16);
  font-weight: var(--fw-semibold);
  color: var(--text);
  margin-bottom: 10px;
}

.dashboard_nextStepPrompt__gGGEj {
  font-size: var(--fs-14);
  color: #a09080;
  line-height: 1.5;
  margin-bottom: 14px;
}

.dashboard_nextStepTextarea__vD2Q0 {
  width: 100%;
  box-sizing: border-box;
  background: var(--surface-sunken);
  border: var(--hairline);
  border-radius: var(--radius-8);
  padding: 10px;
  color: var(--text);
  font-family: inherit;
  font-size: var(--fs-13);
  resize: vertical;
  margin-bottom: 16px;
}

.dashboard_nextStepTextarea__vD2Q0:focus {
  outline: none;
  border-color: #c9956a66;
}

.dashboard_nextStepPhotoHead__1SXpw {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.dashboard_nextStepPhotoLabel__JqyAW {
  font-size: var(--fs-9);
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: var(--text-dim);
}

.dashboard_nextStepPhotoOk__LkMXL {
  font-size: var(--fs-11);
  font-weight: var(--fw-semibold);
  color: var(--success);
}

.dashboard_nextStepPhotoNeed__BaPfZ {
  font-size: var(--fs-11);
  font-weight: var(--fw-semibold);
  color: var(--accent);
}

.dashboard_nextStepThumbs__B9aWN {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.dashboard_nextStepThumbWrap__P\\+YGH {
  position: relative;
  width: 56px;
  height: 56px;
}

.dashboard_nextStepThumb__0mMY8 {
  width: 56px;
  height: 56px;
  object-fit: cover;
  border-radius: var(--radius-8);
  border: var(--hairline);
}

.dashboard_nextStepThumbX__0lJsZ {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: none;
  background: #a01e1e;
  color: #fff;
  font-size: var(--fs-10);
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dashboard_nextStepAddPhoto__zguQ3 {
  width: 56px;
  height: 56px;
  border-radius: var(--radius-8);
  border: 1px dashed var(--text-faint);
  background: var(--surface-sunken);
  color: #a09080;
  font-size: var(--fs-11);
  cursor: pointer;
  font-family: inherit;
}

.dashboard_nextStepAddPhoto__zguQ3:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.dashboard_nextStepError__XujqA {
  background: rgba(160,30,30,0.13);
  border: 1px solid rgba(160,30,30,0.4);
  color: #e03030;
  border-radius: var(--radius-8);
  padding: 8px 10px;
  font-size: var(--fs-12);
  margin-bottom: 12px;
}

.dashboard_nextStepActions__zr275 {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.dashboard_nextStepCancel__8nxIN {
  background: transparent;
  border: var(--hairline);
  color: var(--text-muted-alt);
  border-radius: var(--radius-8);
  padding: 10px 18px;
  cursor: pointer;
  font-family: inherit;
  font-size: var(--fs-13);
}

.dashboard_nextStepConfirm__aazNX {
  background: #c9956a22;
  border: 1px solid #c9956a44;
  color: var(--accent);
  border-radius: var(--radius-8);
  padding: 10px 22px;
  cursor: pointer;
  font-family: inherit;
  font-size: var(--fs-13);
  letter-spacing: 0.5px;
}

.dashboard_nextStepConfirm__aazNX:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.dashboard_nextStepHint__Hp08K {
  font-size: var(--fs-11);
  color: var(--text-dim);
  text-align: right;
  margin-top: 8px;
}

.dashboard_lightRoot__FPAQ0 .dashboard_nextStepPanel__oPwsA {
  background: #fff;
  border-color: #e8e0d4;
}

.dashboard_lightRoot__FPAQ0 .dashboard_nextStepCar__T9cbx { color: var(--text-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_nextStepPrompt__gGGEj { color: var(--text-dim); }
.dashboard_lightRoot__FPAQ0 .dashboard_nextStepTextarea__vD2Q0 {
  background: var(--surface-light-raised);
  border-color: #e8e0d4;
  color: var(--text-on-light);
}
.dashboard_lightRoot__FPAQ0 .dashboard_nextStepCancel__8nxIN { color: var(--text-muted-on-light); border-color: #e8e0d4; }
.dashboard_lightRoot__FPAQ0 .dashboard_nextStepConfirm__aazNX {
  background: rgba(176,120,64,0.1);
  border-color: rgba(176,120,64,0.3);
  color: var(--accent-strong);
}
.dashboard_lightRoot__FPAQ0 .dashboard_nextStepEyebrow__41YqY { color: var(--accent-strong); }
.dashboard_lightRoot__FPAQ0 .dashboard_nextStepAddPhoto__zguQ3 { background: var(--surface-light-raised); color: var(--text-dim); }

/* ── Payment summary on the appointment card ──────────────────────────────── */
/* Booked -> collected, shown inside the existing .bookedBox frame. */
.dashboard_payRow__RxLXi {
  display: flex;
  align-items: center;
  gap: 10px;
}
.dashboard_payCol__F7CI8 { min-width: 0; }
.dashboard_payArrow__09be- {
  color: var(--text-dim);
  font-size: var(--fs-13);
  flex-shrink: 0;
}
.dashboard_payCollected__q9\\+TE { color: var(--success-soft); }
.dashboard_payUnpaid__Bp7ON    { color: var(--accent-strong); }
.dashboard_payReceivable__upMOM{ color: var(--accent); }
.dashboard_payNoCharge__bSmZK  { color: var(--text-muted); }
.dashboard_payAction__C7yh0 {
  margin-left: auto;
  flex-shrink: 0;
  padding: 4px 12px;
  border: none;
  border-radius: var(--radius-6);
  background: var(--accent-deep);
  color: var(--accent-ink);
  font-size: var(--fs-10);
  font-weight: var(--fw-bold);
  letter-spacing: 0.4px;
  cursor: pointer;
}
.dashboard_payAction__C7yh0:hover { background: #9a6a35; }
.dashboard_payTip__wrQeX {
  margin-top: 6px;
  font-size: var(--fs-10);
  color: var(--text-muted);
}
.dashboard_payVariance__8z7We {
  margin-top: 5px;
  font-size: var(--fs-10);
  color: var(--danger-soft);
}
/* Method badge in the card header, e.g. PAID / INVOICED / HOTEL A/R. */
.dashboard_payBadge__CbGul {
  padding: 2px 7px;
  border-radius: var(--radius-5);
  font-size: var(--fs-8);
  font-weight: var(--fw-bold);
  letter-spacing: 1px;
  text-transform: uppercase;
  border: 1px solid currentColor;
  white-space: nowrap;
}

.dashboard_lightRoot__FPAQ0 .dashboard_payArrow__09be-      { color: var(--text-muted-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_payCollected__q9\\+TE  { color: var(--success-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_payUnpaid__Bp7ON     { color: var(--accent-strong); }
.dashboard_lightRoot__FPAQ0 .dashboard_payReceivable__upMOM { color: #a06a2a; }
.dashboard_lightRoot__FPAQ0 .dashboard_payNoCharge__bSmZK   { color: var(--text-muted-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_payTip__wrQeX        { color: var(--text-muted-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_payVariance__8z7We   { color: var(--danger); }

/* ── Appointment drawer ───────────────────────────────────────────────────── */
.dashboard_drawerScrim__BBfpI {
  position: fixed;
  inset: 0;
  background: var(--ace-scrim);
  z-index: 60;
}
.dashboard_drawer__UR5GR {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: min(452px, 100vw);
  background: var(--surface);
  border-left: none;
  box-shadow: var(--ace-drawer-shadow);
  z-index: 61;
  overflow: auto;
}
.dashboard_drawerHead__TPMqm {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 20px 22px;
  background: var(--surface-card);
  border-bottom: 1px solid var(--border);
}
.dashboard_drawerEyebrow__2FVKa {
  font-size: 9.5px;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: var(--text-muted);
}
.dashboard_drawerTitle__6wzgf {
  margin-top: 7px;
  font-size: 20px;
  font-weight: var(--fw-bold);
  color: var(--text);
}
.dashboard_drawerSub__9M2Rj {
  margin-top: 5px;
  font-size: 13px;
  color: var(--text-soft);
  line-height: 1.45;
}
.dashboard_drawerClose__Dk15n {
  margin-left: auto;
  flex: 0 0 auto;
  width: 30px;
  height: 30px;
  display: grid;
  place-items: center;
  border: none;
  border-radius: 8px;
  background: none;
  color: var(--text-muted);
  box-shadow: inset 0 0 0 1px var(--border);
  cursor: pointer;
  font-size: var(--fs-15);
  line-height: 1;
}
.dashboard_drawerClose__Dk15n:hover { color: var(--text); box-shadow: inset 0 0 0 1px var(--border-strong); }
.dashboard_drawerBody__8bgSm {
  padding: 18px 22px 24px;
  display: flex;
  flex-direction: column;
  gap: 13px;
}
.dashboard_drawerCard__mVhHE {
  padding: 16px 18px;
  border: none;
  border-radius: 12px;
  background: var(--surface-card);
  box-shadow: inset 0 0 0 1px var(--border);
}
.dashboard_drawerCardHead__EWzcf {
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin-bottom: 11px;
}
.dashboard_drawerCardLabel__iQv64 {
  font-size: 9.5px;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: var(--text-muted);
}
.dashboard_drawerCardValue__qvHka {
  margin-left: auto;
  font-size: 17px;
  font-weight: var(--fw-bold);
  color: var(--text);
}
.dashboard_drawerRow__QvO\\+z {
  display: flex;
  gap: 12px;
  padding: 0;
  font-size: 13px;
}
.dashboard_drawerRowKey__s4Rlg {
  width: 112px;
  flex: 0 0 112px;
  color: var(--text-muted);
}
.dashboard_drawerRowVal__cLlVk {
  flex: 1 1;
  color: var(--text);
  text-align: left;
}
.dashboard_drawerRowMuted__P5GLj { color: var(--text-dim); }

/* Costs logged against the booking. Sits inside the Appointment card, under a
   rule, so the money reads as one story: booked, collected, then what it cost. */
.dashboard_drawerCosts__DX6HL {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid var(--border);
}
.dashboard_drawerCosts__DX6HL .dashboard_drawerCardValue__qvHka {
  font-size: var(--fs-11);
  font-weight: var(--fw-medium);
  color: var(--text-muted);
}
.dashboard_drawerCost__fK5qx { padding: 7px 0; }
.dashboard_drawerCostTop__AoHcA {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
}
.dashboard_drawerCostName__IBa4F {
  font-size: var(--fs-13);
  font-weight: var(--fw-semibold);
  color: var(--text);
  min-width: 0;
}
.dashboard_drawerCostAmt__7r0Vk {
  font-size: var(--fs-13);
  font-weight: var(--fw-semibold);
  color: var(--text);
  white-space: nowrap;
}
.dashboard_drawerCostMeta__A9JSG {
  margin-top: 3px;
  font-size: var(--fs-11);
  color: var(--text-muted);
  line-height: 1.45;
}
.dashboard_drawerCostTotals__owk1D {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid var(--border);
}
.dashboard_drawerNote__G7FP5 {
  margin-top: 9px;
  font-size: var(--fs-13);
  color: var(--text-soft);
  line-height: 1.55;
}
.dashboard_drawerActions__5Ev3h { display: flex; flex-direction: column; gap: 9px; margin-top: 14px; }
/* The manual-entry block sits a shade below the cards around it and carries
   no ring, so the fields read as sunken into the drawer. */
.dashboard_drawerCardSunken__zn2YY { background: var(--surface-sunken); box-shadow: none; }
.dashboard_drawerPrimary__D\\+ujT {
  padding: 12px;
  border: none;
  border-radius: 9px;
  background: var(--ace-bronze-warm);
  color: var(--ace-paper);
  font-family: inherit;
  font-size: 13px;
  text-align: center;
  cursor: pointer;
}
.dashboard_drawerPrimary__D\\+ujT:hover { background: var(--ace-bronze-warm-deep); }
.dashboard_drawerSecondary__u5LIT {
  padding: 12px;
  border: none;
  border-radius: 9px;
  background: transparent;
  color: var(--text);
  box-shadow: inset 0 0 0 1px var(--border-strong);
  font-family: inherit;
  font-size: 13px;
  text-align: center;
  cursor: pointer;
}
.dashboard_drawerSecondary__u5LIT:hover { box-shadow: inset 0 0 0 1px var(--border-strong); }

.dashboard_lightRoot__FPAQ0 .dashboard_drawer__UR5GR          { background: var(--surface-light-background); }
.dashboard_lightRoot__FPAQ0 .dashboard_drawerHead__TPMqm      { background: var(--surface-light-card); border-bottom-color: var(--ace-stroke-hair); }
.dashboard_lightRoot__FPAQ0 .dashboard_drawerTitle__6wzgf     { color: var(--ace-ink); }
.dashboard_lightRoot__FPAQ0 .dashboard_drawerSub__9M2Rj       { color: var(--ace-body); }
.dashboard_lightRoot__FPAQ0 .dashboard_drawerEyebrow__2FVKa,
.dashboard_lightRoot__FPAQ0 .dashboard_drawerCardLabel__iQv64,
.dashboard_lightRoot__FPAQ0 .dashboard_drawerRowKey__s4Rlg    { color: var(--ace-slate); }
.dashboard_lightRoot__FPAQ0 .dashboard_drawerCard__mVhHE      { background: var(--surface-light-card); box-shadow: inset 0 0 0 1px var(--ace-stroke-hair); }
.dashboard_lightRoot__FPAQ0 .dashboard_drawerCardValue__qvHka,
.dashboard_lightRoot__FPAQ0 .dashboard_drawerRowVal__cLlVk    { color: var(--ace-ink); }
.dashboard_lightRoot__FPAQ0 .dashboard_drawerCosts__DX6HL,
.dashboard_lightRoot__FPAQ0 .dashboard_drawerCostTotals__owk1D { border-top-color: var(--ace-stroke-hair); }
.dashboard_lightRoot__FPAQ0 .dashboard_drawerCostName__IBa4F,
.dashboard_lightRoot__FPAQ0 .dashboard_drawerCostAmt__7r0Vk    { color: var(--ace-ink); }
.dashboard_lightRoot__FPAQ0 .dashboard_drawerCostMeta__A9JSG,
.dashboard_lightRoot__FPAQ0 .dashboard_drawerCosts__DX6HL .dashboard_drawerCardValue__qvHka { color: var(--ace-slate); }
.dashboard_lightRoot__FPAQ0 .dashboard_drawerRowMuted__P5GLj  { color: var(--text-dim-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_drawerNote__G7FP5      { color: var(--ace-body); }
.dashboard_lightRoot__FPAQ0 .dashboard_drawerClose__Dk15n     { color: var(--ace-slate); box-shadow: inset 0 0 0 1px var(--ace-stroke-ring); }
.dashboard_lightRoot__FPAQ0 .dashboard_drawerClose__Dk15n:hover { color: var(--ace-ink); box-shadow: inset 0 0 0 1px var(--ace-stroke-firm); }
.dashboard_lightRoot__FPAQ0 .dashboard_drawerSecondary__u5LIT { color: var(--ace-ink); box-shadow: inset 0 0 0 1px var(--ace-stroke-firm); }
.dashboard_lightRoot__FPAQ0 .dashboard_drawerSecondary__u5LIT:hover { box-shadow: inset 0 0 0 2px var(--ace-stroke-firm); }

/* ── Set payment method modal ─────────────────────────────────────────────── */
.dashboard_payMethodList__k-tQU { display: flex; flex-direction: column; gap: 7px; margin-top: 12px; }
.dashboard_payMethodOption__lZQ55 {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  text-align: left;
  padding: 12px 14px;
  border: none;
  border-radius: var(--radius-10);
  background: var(--surface-high);
  box-shadow: inset 0 0 0 1px var(--border);
  cursor: pointer;
}
.dashboard_payMethodOption__lZQ55:hover { background: #211d19; }
.dashboard_payMethodSelected__Vh6iT {
  background: var(--surface-card);
  box-shadow: inset 0 0 0 2px var(--accent-strong);
}
.dashboard_payMethodText__TC4TD { display: flex; flex-direction: column; gap: 3px; flex: 1 1; min-width: 0; }
.dashboard_payMethodTitle__BNG0Q { font-size: var(--fs-14); font-weight: var(--fw-semibold); color: var(--text); }
.dashboard_payMethodDesc__QFSxc  { font-size: var(--fs-12-5); color: var(--text-muted); line-height: 1.4; }
.dashboard_payMethodBadge__4CaCh {
  font-size: var(--fs-9);
  font-weight: var(--fw-bold);
  letter-spacing: 0.13em;
  text-transform: uppercase;
  white-space: nowrap;
  margin-top: 2px;
}
.dashboard_payMethodBadgeMuted__dhYBX { color: var(--text-muted); }
.dashboard_payMethodBadgeBlue__5T1SN  { color: var(--info); }
.dashboard_payMethodBadgeRed__YNnkk   { color: var(--danger-soft); }

.dashboard_payFieldRow__g0PCx { display: flex; gap: 12px; margin-bottom: 10px; }
.dashboard_payField__mceOv { flex: 1 1; display: flex; flex-direction: column; gap: 6px; min-width: 0; }
.dashboard_payInput__pz6vv,
.dashboard_payTextarea__FdHtp {
  width: 100%;
  padding: 11px 13px;
  border: var(--hairline);
  border-radius: var(--radius-9);
  background: var(--surface-sunken);
  color: var(--text);
  font-size: var(--fs-15);
  font-weight: var(--fw-semibold);
  font-family: inherit;
  box-sizing: border-box;
  color-scheme: dark;
}
.dashboard_payTextarea__FdHtp { font-size: var(--fs-13); font-weight: var(--fw-regular); resize: vertical; margin-top: 8px; }
.dashboard_payInput__pz6vv:focus, .dashboard_payTextarea__FdHtp:focus { outline: none; border-color: var(--accent-strong); }

.dashboard_lightRoot__FPAQ0 .dashboard_payMethodOption__lZQ55 { background: var(--surface-light-sunken); box-shadow: inset 0 0 0 1px var(--ace-stroke); }
.dashboard_lightRoot__FPAQ0 .dashboard_payMethodOption__lZQ55:hover { background: #f0ebe4; }
.dashboard_lightRoot__FPAQ0 .dashboard_payMethodSelected__Vh6iT { background: var(--ace-paper); box-shadow: inset 0 0 0 2px var(--ace-bronze-warm); }
.dashboard_lightRoot__FPAQ0 .dashboard_payMethodTitle__BNG0Q  { color: var(--text-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_payMethodDesc__QFSxc   { color: var(--text-muted-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_payMethodBadgeMuted__dhYBX { color: var(--ace-slate); }
.dashboard_lightRoot__FPAQ0 .dashboard_payMethodBadgeBlue__5T1SN  { color: var(--ace-ar); }
.dashboard_lightRoot__FPAQ0 .dashboard_payMethodBadgeRed__YNnkk   { color: var(--ace-error); }
.dashboard_lightRoot__FPAQ0 .dashboard_payInput__pz6vv,
.dashboard_lightRoot__FPAQ0 .dashboard_payTextarea__FdHtp     { background: var(--surface-light-card); border-color: var(--ace-stroke-ring); color: var(--ace-ink); color-scheme: light;}
.dashboard_lightRoot__FPAQ0 .dashboard_drawerCardSunken__zn2YY { background: var(--ace-band); box-shadow: none; }

/* ── Staff sidebar: grouped by location, with each member's tip for the day ── */
.dashboard_staffGroup__bFD9G { margin-bottom: 14px; }
.dashboard_staffGroupHead__N1vxH {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: var(--fs-9);
  font-weight: var(--fw-bold);
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: var(--text-muted);
  margin: 0 0 7px 2px;
}
.dashboard_staffGroupDot__7OngQ {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}
.dashboard_staffTip__86ZO4 {
  margin-left: auto;
  padding-left: 8px;
  font-size: var(--fs-12);
  font-weight: var(--fw-bold);
  color: var(--success-soft);
  white-space: nowrap;
}
.dashboard_staffTipNone__oGckm {
  margin-left: auto;
  padding-left: 8px;
  font-size: var(--fs-12);
  color: var(--text-faint);
}

.dashboard_lightRoot__FPAQ0 .dashboard_staffGroupHead__N1vxH { color: var(--text-muted-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_staffTip__86ZO4       { color: var(--success-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_staffTipNone__oGckm   { color: var(--text-dim-on-light); }

@media (max-width: 768px) {
  .dashboard_header__tJi3p {
    justify-content: flex-start;
    gap: 10px;
    padding: 10px 14px;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;   /* momentum scrolling on iOS */
    scrollbar-width: none;               /* Firefox */
  }
  .dashboard_header__tJi3p::-webkit-scrollbar { display: none; }

  /* Nothing may shrink, or the items squash to fit instead of scrolling. */
  .dashboard_logo__FiQHq,
  .dashboard_nav__NPHeG,
  .dashboard_headerRight__nzRg8 {
    flex-shrink: 0;
  }

  .dashboard_headerRight__nzRg8 { margin-left: auto; }

  .dashboard_navBtn__8s-Hs {
    white-space: nowrap;
    padding: 7px 12px;
  }

  .dashboard_logoImg__hY6SQ { width: 34px; height: 34px; }
}

/* ── Stats bar tiles: the day's money ─────────────────────────────────────── */
.dashboard_statTile__WjZ2O {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 14px;
  border: var(--hairline);
  border-radius: var(--radius-8);
  background: var(--surface-card);
  flex-shrink: 0;
}
/* The mockup's own values: 9.5px at 0.16em on #6e6a66. */
.dashboard_statTileLabel__oFwTW {
  font-size: 9.5px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--ace-slate);
  font-weight: var(--fw-bold);
}
/* Value and note on one line: the note qualifies the figure ("4 cars,
   excludes tax and tip"), so it belongs beside it, not on a row of its own. */
.dashboard_statTileRow__mz1Zc { margin-top: 4px; display: flex; align-items: baseline; gap: 7px; flex-wrap: wrap; }
.dashboard_statTileValue__UOmMG { font-size: 20px; font-weight: var(--fw-bold); color: var(--text); }
.dashboard_statTileNote__VTX7l { font-size: 11.5px; color: var(--ace-slate); white-space: nowrap; }

/* StatsBar asks for these by name. They were never defined, so every figure
   fell back to the default text colour and collected, due and tips all read
   the same. */
.dashboard_green__gcZzk { color: var(--success); }
.dashboard_red__beEzo   { color: var(--danger-soft); }
.dashboard_blue__IMdwc  { color: var(--info); }
.dashboard_lightRoot__FPAQ0 .dashboard_green__gcZzk { color: var(--success-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_red__beEzo   { color: var(--danger); }
.dashboard_lightRoot__FPAQ0 .dashboard_blue__IMdwc  { color: var(--info-on-light); }

.dashboard_statsLocations__qPfLH { display: flex; gap: 6px; flex-shrink: 0; }
.dashboard_locChip__-BFZo {
  padding: 5px 10px;
  border: var(--hairline);
  border-radius: var(--radius-6);
  background: none;
  color: var(--text-dim);
  font-family: inherit;
  font-size: var(--fs-9);
  font-weight: var(--fw-bold);
  letter-spacing: 1px;
  text-transform: uppercase;
  cursor: pointer;
  white-space: nowrap;
}
.dashboard_locChip__-BFZo.dashboard_active__vzNoh { background: rgba(255,255,255,0.04); }

.dashboard_lightRoot__FPAQ0 .dashboard_statTile__WjZ2O      { background: var(--surface-light-card); border-color: var(--border-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_statTileLabel__oFwTW,
.dashboard_lightRoot__FPAQ0 .dashboard_statTileNote__VTX7l  { color: var(--text-muted-title); }
.dashboard_lightRoot__FPAQ0 .dashboard_statTileValue__UOmMG { color: var(--text-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_locChip__-BFZo       { border-color: var(--border-light); color: var(--text-muted-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_locChip__-BFZo.dashboard_active__vzNoh { background: var(--surface-light-raised); }

/* Camera button: icon plus the number of photos already on the car. */
.dashboard_cameraCount__29aiS { font-size: var(--fs-10); font-weight: var(--fw-bold); line-height: 1; }
.dashboard_checkStep__ZDqjB:disabled { opacity: 0.4; cursor: default; }

/* Subtotal / tax breakdown inside the payment drawer's manual section. */
.dashboard_payBreakdown__sf4Z6 {
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px solid var(--border);
}
.dashboard_payBreakdownRow__\\+WA2y {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 3px 0;
  font-size: var(--fs-12);
  color: var(--text-muted);
}
.dashboard_payBreakdownTotal__zLXr9 {
  margin-top: 4px;
  padding-top: 7px;
  border-top: 1px solid var(--border);
  font-weight: var(--fw-bold);
  color: var(--text);
}
.dashboard_payBreakdownFlag__UYABI { color: var(--accent); }

.dashboard_lightRoot__FPAQ0 .dashboard_payBreakdown__sf4Z6,
.dashboard_lightRoot__FPAQ0 .dashboard_payBreakdownTotal__zLXr9 { border-top-color: var(--border-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_payBreakdownRow__\\+WA2y   { color: var(--text-muted-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_payBreakdownTotal__zLXr9 { color: var(--text-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_payBreakdownFlag__UYABI  { color: #a06a2a; }

/* View-photos button: same shape as the camera, in the "has content" green. */
.dashboard_galleryBtn__OAtz2 {
  background: rgba(122,158,201,0.13);
  border: 1px solid rgba(122,158,201,0.3);
  color: var(--info);
  border-radius: var(--radius-5);
  padding: 3px 8px;
  cursor: pointer;
  font-size: var(--fs-13);
  line-height: 1;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}
.dashboard_galleryBtn__OAtz2:hover { background: rgba(122,158,201,0.2); }

.dashboard_lightRoot__FPAQ0 .dashboard_galleryBtn__OAtz2 {
  background: rgba(122,158,201,0.1);
  border-color: rgba(122,158,201,0.35);
  color: var(--info);
}

/* ── Log a cost modal ─────────────────────────────────────────────────────── */
/* Dark by default like every other overlay; the light variant is the override,
   not the other way round. A hardcoded light background here is what made the
   shell cream while its contents stayed dark. */
.dashboard_costModal__uuBg3 {
  width: min(520px, 94vw);
  max-height: 92vh;
  overflow-y: auto;
  margin: 0;
  max-width: none;
  position: relative;
  padding: 0 0 18px;
  border: var(--hairline);
  border-radius: var(--radius-14);
  background: var(--surface);
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45);
  box-sizing: border-box;
  scrollbar-width: none;            /* Firefox */
  -ms-overflow-style: none;         /* old Edge */
}
.dashboard_costModal__uuBg3::-webkit-scrollbar { display: none; }
.dashboard_costModal__uuBg3 .dashboard_drawerHead__TPMqm {
  padding: 18px 20px 16px;
  border-bottom: none;
  /* Sits a shade apart from the body, and stays put while the form scrolls. */
  background: var(--surface-high);
  border-radius: 14px 14px 0 0;
  position: sticky;
  top: 0;
  z-index: 2;
}
.dashboard_costModal__uuBg3 > *:not(.dashboard_drawerHead__TPMqm) { margin-left: 20px; margin-right: 20px; }
.dashboard_costLine__QX4aQ {
  margin-bottom: 4px;
  margin-top: 15px;
}
.dashboard_costKindRow__Now\\+O { display: flex; gap: 7px; margin: 8px 0 14px; }
.dashboard_costKind__Wi3QD {
  padding: 7px 14px;
  border: var(--hairline);
  border-radius: var(--radius-7);
  background: none;
  color: var(--text-muted);
  font-family: inherit;
  font-size: var(--fs-12);
  cursor: pointer;
}
.dashboard_costKindActive__teKLP { border-color: var(--accent-strong); color: var(--accent); background: rgba(201,149,106,0.1); }

.dashboard_costSelect__58j-z {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 11px;
  border: var(--hairline);
  border-radius: var(--radius-7);
  background: var(--surface-sunken);
  color: var(--text);
  font-family: inherit;
  font-size: var(--fs-13);
  cursor: pointer;
}
/* Expands in flow rather than overlaying: the modal scrolls, and an absolutely
   positioned menu inside a scroll container gets clipped. */
/* Floats on <body> via a portal, positioned from the trigger's rect, so the
   modal's own \`overflow-y: auto\` cannot clip it. */
.dashboard_costMenu__-QZuC {
  position: fixed;
  z-index: 1300;
  display: flex;
  flex-direction: column;
  border: var(--hairline);
  border-radius: var(--radius-8);
  background: var(--surface-raised);
  overflow: hidden;
  box-shadow: 0 18px 44px rgba(0,0,0,0.5);
}
.dashboard_costMenuSearch__CLJea {
  flex: none;
  width: 100%;
  padding: 9px 12px;
  border: none;
  border-bottom: 1px solid var(--border);
  background: var(--surface-sunken);
  color: var(--text);
  font-family: inherit;
  font-size: var(--fs-12);
  box-sizing: border-box;
}
.dashboard_costMenuSearch__CLJea:focus { outline: none; }
/* Caps the roster so the form below stays reachable. */
.dashboard_costMenuList__AIAwo { flex: 1 1; min-height: 0; max-height: 210px; overflow-y: auto; }
.dashboard_costMenuGroup__c\\+FD1 {
  padding: 8px 12px 4px;
  font-size: var(--fs-8);
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: var(--text-muted);
}
.dashboard_costMenuEmpty__u0edH { padding: 12px; font-size: var(--fs-12); color: var(--text-muted); }
.dashboard_costSelect__58j-z:focus,
.dashboard_costSelect__58j-z:focus-visible {
  outline: none;
  border-color: var(--accent-strong);
}
.dashboard_payInput__pz6vv:focus,
.dashboard_payTextarea__FdHtp:focus { outline: none; border-color: var(--accent-strong); }

.dashboard_costMenuItem__EVLqP {
  display: block;
  width: 100%;
  text-align: left;
  padding: 9px 12px;
  border: none;
  background: none;
  color: var(--text-soft);
  font-family: inherit;
  font-size: var(--fs-13);
  cursor: pointer;
}
.dashboard_costMenuItem__EVLqP:hover { background: rgba(255,255,255,0.05); }
.dashboard_costMenuAdd__wH1lg { flex: none; color: var(--accent); border-top: 1px solid var(--border); }

.dashboard_costAddLine__Fs22B {
  width: 100%;
  padding: 11px;
  border: 1px dashed var(--border);
  border-radius: var(--radius-8);
  background: none;
  color: var(--text-muted);
  font-family: inherit;
  font-size: var(--fs-12);
  cursor: pointer;
  margin-bottom: 14px;
}
.dashboard_costAddLine__Fs22B:hover { color: var(--text); border-color: var(--border-strong); }
.dashboard_costFooter__1j1SN {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 14px;
  padding-top: 14px;
  border-top: 1px dashed var(--border);
}

.dashboard_lightRoot__FPAQ0 .dashboard_costModal__uuBg3 .dashboard_drawerHead__TPMqm { background: var(--surface-light-alt); }
.dashboard_lightRoot__FPAQ0 .dashboard_costModal__uuBg3 {
  background: var(--surface-light-background);
  border-color: var(--border-light);
  box-shadow: 0 24px 60px rgba(120, 100, 80, 0.12);
}
.dashboard_lightRoot__FPAQ0 .dashboard_costKind__Wi3QD     { border-color: var(--border-light); color: var(--text-muted-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_costSelect__58j-z   { background: var(--surface-light); border-color: var(--border-light); color: var(--text-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_costMenu__-QZuC     { background: var(--surface-light); border-color: var(--border-light); box-shadow: 0 18px 44px rgba(0,0,0,0.18); }
.dashboard_lightRoot__FPAQ0 .dashboard_costMenuItem__EVLqP { color: var(--text-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_costMenuSearch__CLJea { background: var(--surface-light-alt); border-bottom-color: var(--border-light); color: var(--text-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_costMenuGroup__c\\+FD1,
.dashboard_lightRoot__FPAQ0 .dashboard_costMenuEmpty__u0edH  { color: var(--text-muted-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_costAddLine__Fs22B  { border-color: var(--border-light); color: var(--text-muted-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_costFooter__1j1SN   { border-top-color: var(--border-light); }

/* Log-a-cost trigger on the card, alongside the camera and gallery. */
.dashboard_noteBtn__3FTp0 {
  background: rgba(138,127,116,0.12);
  border: 1px solid rgba(138,127,116,0.3);
  color: #a89c8e;
  border-radius: var(--radius-5);
  padding: 4px 8px;
  cursor: pointer;
  font-size: var(--fs-13);
  line-height: 1;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}
.dashboard_noteBtn__3FTp0:hover { color: var(--text); border-color: var(--border-strong); }
.dashboard_lightRoot__FPAQ0 .dashboard_noteBtn__3FTp0 { border-color: var(--border-light); color: var(--text-muted-on-light); }

/* Invoice capture inside a cost line. */
.dashboard_costInvoice__NEAoT {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
  padding: 13px 14px;
  border: var(--hairline);
  border-radius: var(--radius-9);
  background: var(--surface-raised);
  cursor: pointer;
}
.dashboard_costInvoice__NEAoT:hover { border-color: var(--border-strong); }
.dashboard_costInvoiceIcon__3KAPB {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: var(--radius-8);
  background: rgba(201,149,106,0.12);
  color: var(--accent);
  flex-shrink: 0;
}
.dashboard_costInvoiceTitle__Sp0Yl { display: block; font-size: var(--fs-13); font-weight: var(--fw-semibold); color: var(--text); }
.dashboard_costInvoiceSub__pWxU\\+   { display: block; font-size: var(--fs-11); color: var(--text-muted); margin-top: 2px; }
.dashboard_costChevron__zIqPX { opacity: 0.55; flex-shrink: 0; }

.dashboard_lightRoot__FPAQ0 .dashboard_costInvoice__NEAoT      { background: var(--surface-light-raised); border-color: var(--border-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_costInvoiceTitle__Sp0Yl { color: var(--text-on-light); }
.dashboard_lightRoot__FPAQ0 .dashboard_costInvoiceSub__pWxU\\+   { color: var(--text-muted-on-light); }

/* The chips' own row. \`chipRow\` exists in staff.module.css, but a CSS Module
   class cannot be reached from another module's file, so this drawer needs its
   own. */
.dashboard_reasonChips__WMjHy { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 11px; }

/* A reason chip on the fix-a-clock-time form. Picking one again clears it:
   the reason is optional, so there has to be a way back out of a wrong tap. */
.dashboard_reasonChip__6hp75 {
  padding: 7px 12px; border: none; border-radius: 999px;
  background: var(--surface-high); color: var(--text-muted);
  box-shadow: inset 0 0 0 1px var(--border);
  font-family: inherit; font-size: var(--fs-12-5); cursor: pointer;
}
.dashboard_reasonChipOn__mkm9U {
  background: color-mix(in srgb, var(--ace-bronze-warm) 16%, transparent);
  color: var(--ace-bronze-warm);
  box-shadow: inset 0 0 0 1px var(--ace-bronze-warm);
}
.dashboard_lightRoot__FPAQ0 .dashboard_reasonChip__6hp75 { background: var(--surface-light-sunken); color: var(--ace-slate); box-shadow: inset 0 0 0 1px var(--ace-stroke); }
.dashboard_lightRoot__FPAQ0 .dashboard_reasonChipOn__mkm9U { background: color-mix(in srgb, var(--ace-bronze-warm) 14%, transparent); color: var(--ace-bronze-warm); box-shadow: inset 0 0 0 1px var(--ace-bronze-warm); }

/* ── Header: the 1600px column, and the mobile sheet ─────────────────────── */

/* The bar still spans the window — it carries the background and the rule —
   but its contents sit in the same 1600px column as the page beneath it.
   Padding rather than an inner wrapper, so no markup has to change. */
.dashboard_header__tJi3p { padding-inline: max(26px, calc((100% - var(--page-max)) / 2)); }
/* On the queue the bar's contents run the full width too, so the nav lines up
   with the board under it rather than floating inside a narrower column.
   Before the media queries below, which set \`padding\` outright and still win. */
.dashboard_headerWide__VCuUO { padding-inline: 26px; }

.dashboard_burger__QZkof {
  display: none;
  width: 34px; height: 34px; flex: 0 0 auto;
  place-items: center;
  border: none; border-radius: 9px; background: none;
  color: var(--text-soft); box-shadow: inset 0 0 0 1px var(--border);
  cursor: pointer;
}

/* The bar sheds things in two steps, as the mockup does.
   At 1180 the nav itself no longer fits beside the pill and the controls, so
   it becomes the burger and the sheet. At 860 even the pill and the clock go,
   leaving the logo, the burger and the two switches. */
@media (max-width: 1180px) {
  .dashboard_header__tJi3p { gap: 14px; padding: 13px 18px; }
  .dashboard_burger__QZkof { display: grid; }
  .dashboard_nav__NPHeG { display: none !important; }
  .dashboard_headerClockGroup__c6bbU { display: none; }
  .dashboard_navPill__b6N0D { padding: 10px 12px; }
  .dashboard_hdrClock__mvPlV { padding: 9px 12px; }
}

@media (max-width: 860px) {
  .dashboard_header__tJi3p { gap: 12px; padding: 12px 16px; }
  .dashboard_navPill__b6N0D { display: none !important; }
  /* The clock lives in the sheet and on the shifts page at this width; two
     of them in a 360px bar is one too many. */
  .dashboard_hdrClock__mvPlV { display: none !important; }
  .dashboard_headerRight__nzRg8 { margin-left: auto; gap: 10px; }
  .dashboard_themeSwitchBtn__NzppN { display: none; }
  .dashboard_logoImg__hY6SQ { width: 27px; height: 27px; }
}

.dashboard_navSheet__3VL-m {
  position: fixed;
  top: 0; right: 0; bottom: 0; left: 0;
  width: 100%; max-width: 100%;
  z-index: 90;
  background: var(--surface-sunken);
  overflow-x: hidden; overflow-y: auto;
  overscroll-behavior: contain;
}
.dashboard_navSheetHead__tEXxp {
  display: flex; align-items: center; gap: 14px;
  padding: 15px 18px; border-bottom: 1px solid var(--border);
}
.dashboard_navSheetClose__TElXw {
  margin-left: auto; width: 34px; height: 34px; flex: 0 0 auto;
  display: grid; place-items: center;
  border: none; border-radius: 9px; background: none;
  color: var(--text-soft); box-shadow: inset 0 0 0 1px var(--border); cursor: pointer;
}
.dashboard_navSheetBody__J4Rtk {
  padding: 14px 14px 30px;
  display: flex; flex-direction: column; gap: 20px;
}
.dashboard_navSheetGroup__6-RT8 {
  padding: 0 8px 8px;
  font-family: 'DM Sans', sans-serif; font-size: var(--fs-10-5);
  letter-spacing: 0.16em; text-transform: uppercase; color: var(--text-dim);
}
.dashboard_navSheetItems__cMwyq { display: flex; flex-direction: column; gap: 6px; min-width: 0; }
.dashboard_navSheetItem__FjSRv {
  display: flex; align-items: center; gap: 10px;
  padding: 14px 15px; border-radius: 11px;
  background: var(--surface-card); color: var(--text-soft);
  box-shadow: inset 0 0 0 1px var(--border);
  font-size: var(--fs-16); text-decoration: none;
  min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.dashboard_navSheetItemOn__j4XNZ {
  background: color-mix(in srgb, var(--ace-bronze-warm) 16%, transparent);
  color: var(--ace-champagne);
  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--ace-bronze-warm) 30%, transparent);
}
.dashboard_navSheetBadge__M018Y {
  margin-left: auto; font-family: 'DM Sans', sans-serif;
  font-size: var(--fs-12-5); color: var(--danger-soft);
}
.dashboard_navSheetFoot__lHu2p {
  padding-top: 16px; margin-top: 4px;
  border-top: 1px dotted var(--border);
  display: flex; align-items: center; gap: 12px;
}

.dashboard_headerLight__EZg\\+4 .dashboard_burger__QZkof,
.dashboard_headerLight__EZg\\+4 .dashboard_navSheetClose__TElXw { box-shadow: inset 0 0 0 1px var(--ace-stroke-ring); color: var(--ace-slate); }
/* The sheet carries \`.headerLight\` itself now that it is portalled, so this
   has to match the element as well as a descendant of it. Its children still
   match the descendant form. */
.dashboard_headerLight__EZg\\+4.dashboard_navSheet__3VL-m,
.dashboard_headerLight__EZg\\+4 .dashboard_navSheet__3VL-m { background: var(--surface-light-background); }
.dashboard_headerLight__EZg\\+4 .dashboard_navSheetHead__tEXxp,
.dashboard_headerLight__EZg\\+4 .dashboard_navSheetFoot__lHu2p { border-color: var(--ace-stroke-hair); }
.dashboard_headerLight__EZg\\+4 .dashboard_navSheetGroup__6-RT8 { color: var(--ace-slate); }
.dashboard_headerLight__EZg\\+4 .dashboard_navSheetItem__FjSRv { background: var(--surface-light-card); color: var(--ace-body); box-shadow: inset 0 0 0 1px var(--ace-stroke-hair); }
.dashboard_headerLight__EZg\\+4 .dashboard_navSheetItemOn__j4XNZ { background: var(--ace-tab-active); color: var(--ace-tab-ink); box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--ace-tab-ink) 30%, transparent); }
.dashboard_headerLight__EZg\\+4 .dashboard_navSheetBadge__M018Y { color: var(--ace-error); }

/* The clock as a floating button, for the widths where the bar has dropped it.
   Hidden by default and shown only there, so it never doubles up with the one
   in the header. */
.dashboard_clockFab__DidoN {
  display: none;
  position: fixed; right: 16px; bottom: 18px; z-index: 70;
  align-items: center; gap: 12px;
  padding: 12px 22px 12px 18px; min-height: 58px; box-sizing: border-box;
  border: none; border-radius: 999px;
  background: var(--ace-bronze-warm); color: var(--ace-paper);
  box-shadow: 0 18px 36px -14px rgba(20, 15, 10, 0.5);
  font-family: inherit; text-align: left; cursor: pointer; user-select: none;
}
/* On shift it goes dark and green, so it reads as a status you can end rather
   than an action waiting to be taken. */
.dashboard_clockFabOn__cIMxo { background: var(--ace-ink); color: var(--ace-bone); }
.dashboard_clockFabDot__K-3uB {
  width: 10px; height: 10px; flex: 0 0 auto;
  border-radius: 50%; background: var(--ace-paper);
}
.dashboard_clockFabOn__cIMxo .dashboard_clockFabDot__K-3uB { background: var(--ace-on-shift); }
.dashboard_clockFabText__GiCJc { display: flex; flex-direction: column; line-height: 1.25; min-width: 0; }
.dashboard_clockFabLabel__JbH4d { font-size: var(--fs-16); }
.dashboard_clockFabSub__vbVAI { font-size: var(--fs-12-5); opacity: 0.85; white-space: nowrap; }
.dashboard_clockFab__DidoN:disabled { opacity: 0.7; cursor: default; }

@media (max-width: 860px) {
  .dashboard_clockFab__DidoN { display: flex; }
}
`, "",{"version":3,"sources":["webpack://./src/styles/dashboard.module.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD;EACE,iCAAiC;EACjC,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,kDAAkD;AAClD;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,kCAAkC;EAClC,yBAAyB;EACzB,+BAA+B;EAC/B,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,yCAAyC;EACzC,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,8DAA8D;EAC9D,oBAAoB;AACtB;;AAEA,8EAA8E;AAC9E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;AACvB;AACA,uCAAsB,oBAAoB,EAAE,2BAA2B,EAAE;;AAEzE;kDACkD;AAClD;EACE,oBAAoB;EACpB,UAAU;EACV,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;EAC9B,iBAAiB;EACjB,kCAAkC;EAClC,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;EACrB,yBAAyB;EACzB,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;AACA,qEAAmC,kBAAkB,EAAE;AACvD;EACE,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;oEACoE;AACpE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,+BAA+B;EAC/B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,4BAA4B;AAC9B;AACA,iCAAgB,6DAA6D;EAC3E,yBAAyB;AAC3B;AACA;uCACsB,6DAA6D,EAAE;AACrF,iCAAgB,6DAA6D;EAC3E,0BAA0B;AAC5B;AACA,kCAAiB,6DAA6D,EAAE;AAChF;;qEAEqE;AACrE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,YAAY;EACZ,oBAAoB;EACpB,kCAAkC;EAClC,uBAAuB;EACvB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;AACA,mCAAkB,uCAAuC,EAAE;AAC3D,sCAAqB,YAAY,EAAE,eAAe,EAAE;AACpD;;EAEE,mEAAmE;EACnE,yBAAyB;EACzB,mFAAmF;AACrF;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,mDAAmD;AACnD,8BAAY,kBAAkB,EAAE,oBAAoB,EAAE;;AAEtD,6BAAY,sBAAsB,EAAE,cAAc,EAAE,aAAa,EAAE;;AAEnE;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,gBAAgB;EAChB,+BAA+B;EAC/B,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR;2CACyC;EACzC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;EACrB,6BAA6B;EAC7B,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA,wCAAuB,sBAAsB,EAAE,eAAe,EAAE;;AAEhE;EACE,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA,kDAAkD;AAClD;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,qDAAmB,kBAAkB,EAAE;AACvC,qDAAmB,qBAAqB,EAAE;;AAE1C;EACE,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,gCAAgC;EAChC,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,cAAc;AAChB;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA,kDAAkD;AAClD;+EAC+E;AAC/E;EACE,+BAA+B;EAC/B;;iBAEe;EACf,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,mCAAkB,gDAAgD,EAAE;;AAEpE,mDAAiB,aAAa,EAAE;;AAEhC,qDAAmB,0BAA0B,EAAE;AAC/C,sDAAmB,gCAAgC,EAAE;AACrD,qDAAmB,0BAA0B,EAAE;;AAE/C,+BAAc,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,oBAAoB,EAAE;;AAExG;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,eAAe;EACf,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA,wDAAsB,cAAc,EAAE;;AAEtC;EACE,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA,0DAAwB,gCAAgC,EAAE,cAAc,EAAE,sCAAsC,EAAE;AAClH,2DAAwB,kCAAkC,EAAE,oBAAoB,EAAE,wCAAwC,EAAE;AAC5H,0DAAwB,iCAAiC,EAAE,qBAAqB,EAAE,uCAAuC,EAAE;;AAE3H;EACE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,8BAA8B;EAC9B,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,qBAAqB;EACrB,qBAAqB;AACvB;AACA,mDAAmD;AACnD;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,cAAc;EACd,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,cAAc;EACd,mCAAmC;AACrC;;AAEA;;2EAE2E;AAC3E;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,iDAAiD;EACjD,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,oCAAmB,4CAA4C,EAAE,qBAAqB,EAAE;;AAExF;;iEAEiE;AACjE;;EAEE,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,+BAA+B;EAC/B,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA,4DAAyB,qBAAqB,EAAE;AAChD,2DAAyB,oBAAoB,EAAE;AAC/C,2DAAyB,4BAA4B,EAAE;;AAEvD;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA,yDAAsB,0BAA0B,EAAE;AAClD,wDAAsB,yBAAyB,EAAE;AACjD,wDAAsB,6BAA6B,EAAE;;AAErD,kDAAkD;AAClD;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,8EAA0B,oBAAoB,EAAE;;AAEhD;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,+EAA4B,cAAc,EAAE;;AAE5C,kDAAkD;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA,kDAAgB,oBAAoB,EAAE;;AAEtC;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,0BAA0B;EAC1B,SAAO;AACT;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;AACjB;;AAEA,gDAAc,oBAAoB,EAAE;;AAEpC,mDAAmD;AACnD,+BAAc,gBAAgB,EAAE;;AAEhC;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,8BAA8B;AAChC;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,wDAAsB,qBAAqB,EAAE;AAC7C,wDAAsB,cAAc,EAAE;;AAEtC,kDAAkD;AAClD;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,+BAA+B;EAC/B,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,aAAa;EACb,+BAA+B;EAC/B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,8BAA8B;EAC9B,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,oBAAoB;EACpB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,kDAAkD;AAClD;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA,qCAAoB,2BAA2B,EAAE;AACjD,qCAAoB,2BAA2B,EAAE;;AAEjD,kDAAkD;AAClD;EACE,gCAAgC;EAChC,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;EACvC,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,wCAAwC;EACxC,oBAAoB;EACpB,8BAA8B;EAC9B,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,uBAAuB;EACvB,cAAc;AAChB;AACA,mCAAkB,kCAAkC,EAAE,oCAAoC,EAAE,qBAAqB,EAAE;AACnH,mCAAkB,gCAAgC,IAAI,iCAAiC,IAAI,cAAc,EAAE;;;;AAI3G,kFAAkF;AAClF;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;EAC5B,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,2BAA2B;EAC3B,uCAAuC;EACvC,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;AACA,2CAA0B,YAAY,EAAE,eAAe,EAAE;AACzD,uCAAsB,UAAU,EAAE;AAClC,uCAAsB,WAAW,EAAE;;AAEnC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;EACjC,uCAAuC;EACvC,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iCAAiC;EACjC,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,kDAAkD;AAClD;EACE,oBAAoB;EACpB,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,kDAAkD;AAClD;EACE,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,8BAA8B;EAC9B,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,kDAAkD;AAClD;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA,0EAA0E;AAC1E;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,8BAA8B;AAChC;;AAEA,oCAAmB,kCAAkC,EAAE;;AAEvD;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,+BAA+B;EAC/B,oBAAoB;EACpB,cAAc;AAChB;;AAEA,8BAAa,SAAO,EAAE,YAAY,EAAE;;AAEpC;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,kDAAkD;AAClD;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB,SAAS,YAAY;EAC1C,wBAAwB,MAAM,kBAAkB;AAClD;AACA,wDAAuC,oBAAoB;EACzD,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;AACA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,4BAA4B;EAC5B,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,UAAU;EACV,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA,wCAAuB,2BAA2B,EAAE,oBAAoB,EAAE;;AAE1E,oCAAmB,WAAW,EAAE;AAChC,wEAAsC,eAAe,EAAE;AACvD,uEAAqC,uBAAuB,EAAE;;AAE9D;EACE,iCAAiC;EACjC,iCAAiC;AACnC;AACA,oEAAkC,kCAAkC,EAAE,2BAA2B,EAAE;;AAEnG;EACE,mCAAmC;EACnC,kBAAkB;EAClB,cAAc;AAChB;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE;6CAC2C;EAC3C,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;EACzC,4BAA4B;EAC5B,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;yEACyE;AACzE,iCAAe,2CAA2C,EAAE,wCAAwC,EAAE;AACtG,wDAAqB,2BAA2B,EAAE;AAClD,0DAAuB,iCAAiC,EAAE;AAC1D,8FAA0C,2BAA2B,EAAE,4BAA4B,EAAE;AACrG,gEAA6B,iCAAiC,EAAE,iCAAiC,EAAE;AACnG,sEAAmC,2BAA2B,EAAE,kCAAkC,EAAE;AACpG,6DAA0B,iCAAiC,EAAE;AAC7D,0DAAuB,iCAAiC,EAAE;AAC1D,oGAAgD,2BAA2B,EAAE;AAC7E,gEAA6B,oCAAoC,EAAE,2BAA2B,EAAE;AAChG,gEAA6B,gEAAgE,EAAE,uBAAuB,EAAE;AACxH,gEAA6B,wEAAwE,EAAE,8BAA8B,EAAE;AACvI;mEACmE;AACnE;sEACmC,6DAA6D,EAAE;AAClG,sEAAmC,6DAA6D,EAAE;AAClG;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;mEACgC,uBAAuB,EAAE;AACzD;EACE,YAAY;EACZ,kDAAkD;EAClD,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC;oDACkD;AACpD;AACA,+DAA6B,cAAc,EAAE;AAC7C,gHAA6D,4BAA4B,EAAE,2BAA2B,EAAE;AACxH,qEAAmC,yBAAyB,EAAE,gCAAgC,EAAE;AAChG,uEAAqC,cAAc,EAAE;;AAErD,kDAAkD;AAClD;EACE,UAAU;EACV,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA,kDAAkD;AAClD;EACE,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;EAC5B,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;EACjB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,oBAAoB;EACpB,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,uBAAuB;EACvB,4BAA4B;EAC5B,aAAa;EACb,qDAAqD;EACrD,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;6EAC6E;AAC7E;EACE,aAAa;EACb,SAAO;EACP,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,qDAAmB,2BAA2B,EAAE;AAChD,sDAAoB,iCAAiC,EAAE;;AAEvD,uDAAqB,iCAAiC,EAAE;AACxD;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,2CAA2C;EAC3C,wCAAwC;AAC1C;;AAEA,0DAAwB,iCAAiC,EAAE;AAC3D,0DAAwB,2BAA2B,EAAE;AACrD,iFAA8B,cAAc,EAAE;AAC9C,wDAAsB,iCAAiC,EAAE;;AAEzD,6DAA2B,iCAAiC,EAAE;;AAE9D;8EAC8E;AAC9E;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kDAAkD;AACpD;AACA,+DAA6B,kDAAkD,EAAE;AACjF,+EAA4B,aAAa,EAAE;;AAE3C,yDAAuB,2BAA2B,EAAE;AACpD,yDAAuB,iCAAiC,EAAE;AAC1D,yDAAuB,2BAA2B,EAAE;AACpD,iFAA8B,iCAAiC,EAAE;AACjE;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA,6DAA2B,qCAAqC,EAAE;AAClE,0DAAwB,uBAAuB,EAAE,uBAAuB,EAAE;AAC1E,gEAA8B,8CAA8C,EAAE,qBAAqB,EAAE;AACrG;;EAEE,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;AACA,6DAA2B,cAAc,EAAE;AAC3C,8EAA2B,2BAA2B,EAAE;AACxD,8DAA2B,2BAA2B,EAAE;AACxD,6DAA2B,2BAA2B,EAAE;;AAExD;EACE,gCAAgC;EAChC,iCAAiC;AACnC;AACA,uDAAqB,iCAAiC,EAAE;AACxD,wDAAqB,2BAA2B,EAAE;AAClD,uDAAqB,cAAc,EAAE;;AAErC;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA,4BAA4B;AAC5B;EACE,gCAAgC;EAChC,iCAAiC;AACnC;AACA,4DAA0B,iCAAiC,EAAE;AAC7D,4DAA0B,2BAA2B,EAAE;AACvD,8DAA4B,cAAc,EAAE;AAC5C,4DAA0B,gCAAgC,EAAE,iCAAiC,EAAE;AAC/F,4DAA0B,cAAc,EAAE;AAC1C,4DAA0B,2CAA2C,EAAE,iCAAiC,EAAE,iCAAiC,EAAE;AAC7I,4DAA0B,gCAAgC,EAAE,kCAAkC,EAAE,2BAA2B,EAAE;;AAE7H,gEAA8B,iCAAiC,EAAE;;AAEjE,8DAA4B,2BAA2B,EAAE;;AAEzD,+DAA6B,iCAAiC,EAAE,mCAAmC,EAAE,2BAA2B,EAAE;AAClI,+DAA6B,gCAAgC,GAAG,iCAAiC,GAAG,cAAc,EAAE;AACpH,+DAA6B,+BAA+B,IAAI,kCAAkC,EAAE,cAAc,EAAE;;AAEpH,iEAA+B,cAAc,EAAE;AAC/C,iEAA+B,iCAAiC,EAAE;;AAElE,8DAA4B,iCAAiC,EAAE;AAC/D,8DAA4B,cAAc,EAAE;;AAE5C;EACE,uCAAuC;EACvC,iCAAiC;AACnC;AACA,2DAAyB,iCAAiC,EAAE;AAC5D,4DAAyB,cAAc,EAAE;;AAEzC,iEAA+B,iCAAiC,EAAE,GAAG,uBAAuB;AAC5F,iEAA+B,oBAAoB,EAAE,GAAG,uBAAuB;AAC/E,iEAA+B,uBAAuB,EAAE,iCAAiC,EAAE;AAC3F,iEAA+B,iCAAiC,EAAE;AAClE,kEAA+B,2BAA2B,EAAE;;AAE5D,+DAA6B,uCAAuC,EAAE;AACtE,+DAA6B,2CAA2C,EAAE;AAC1E,+DAA6B,iCAAiC,EAAE;AAChE,+DAA6B,2CAA2C,EAAE;AAC1E,gEAA6B,iCAAiC,EAAE;;AAEhE;EACE,gCAAgC;EAChC,iCAAiC;AACnC;AACA,gEAA8B,sCAAsC,EAAE;AACtE,mEAAiC,cAAc,EAAE;AACjD,mEAAiC,uBAAuB,EAAE,2BAA2B,EAAE;AACvF,mEAAiC,2BAA2B,EAAE;;AAE9D;EACE,2CAA2C;EAC3C,sCAAsC;AACxC;AACA,mEAAiC,wCAAwC,EAAE;AAC3E,mEAAiC,cAAc,EAAE;AACjD,qEAAmC,qCAAqC,EAAE;;AAE1E,gEAA8B,iCAAiC,EAAE;;AAEjE;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA,gEAA8B,+BAA+B,EAAE;;AAE/D;EACE,iCAAiC;EACjC,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;AACA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA,kDAAkD;AAClD;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA,+DAA4B,2BAA2B,EAAE;AACzD,gEAA8B,cAAc,EAAE;;AAE9C;EACE,iCAAiC;EACjC,iCAAiC;AACnC;AACA;EACE,2CAA2C;AAC7C;;AAEA,iEAA8B,2CAA2C,EAAE;;AAE3E;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA,8DAA4B,iCAAiC,EAAE;;AAE/D,4DAA0B,+BAA+B,EAAE;AAC3D,kEAAgC,uBAAuB,EAAE;;AAEzD,gEAA8B,iCAAiC,EAAE;;AAEjE;EACE,cAAc;EACd,uCAAuC;AACzC;;AAEA,mDAAmD;AACnD;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,+BAA+B;EAC/B,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,iCAAiC;EACjC,uBAAuB;EACvB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,oCAAoC;EACpC,iCAAiC;EACjC,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,cAAc;EACd,8BAA8B;EAC9B,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,4BAA4B;EAC5B,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,oBAAoB;EACpB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,4DAA0B,2BAA2B,EAAE;AACvD,+DAA6B,sBAAsB,EAAE;AACrD;EACE,uCAAuC;EACvC,qBAAqB;EACrB,2BAA2B;AAC7B;AACA,+DAA6B,iCAAiC,EAAE,qBAAqB,EAAE;AACvF;EACE,gCAAgC;EAChC,kCAAkC;EAClC,2BAA2B;AAC7B;AACA,gEAA8B,2BAA2B,EAAE;AAC3D,iEAA+B,uCAAuC,EAAE,sBAAsB,EAAE;;AAEhG,gFAAgF;AAChF,qEAAqE;AACrE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA,2BAAU,YAAY,EAAE;AACxB;EACE,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;AAChB;AACA,kCAAgB,0BAA0B,EAAE;AAC5C,iCAAgB,2BAA2B,EAAE;AAC7C,iCAAgB,oBAAoB,EAAE;AACtC,iCAAgB,wBAAwB,EAAE;AAC1C;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,8BAA8B;EAC9B,8BAA8B;EAC9B,wBAAwB;EACxB,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;EACrB,eAAe;AACjB;AACA,oCAAmB,mBAAmB,EAAE;AACxC;EACE,eAAe;EACf,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,yBAAyB;AAC3B;AACA,uEAAuE;AACvE;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,8DAA4B,iCAAiC,EAAE;AAC/D,+DAA4B,8BAA8B,EAAE;AAC5D,8DAA4B,2BAA2B,EAAE;AACzD,8DAA4B,cAAc,EAAE;AAC5C,8DAA4B,iCAAiC,EAAE;AAC/D,8DAA4B,iCAAiC,EAAE;AAC/D,8DAA4B,oBAAoB,EAAE;;AAElD,gFAAgF;AAChF;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,WAAW;AACb;AACA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,0BAA0B;EAC1B,iBAAiB;EACjB,oCAAoC;EACpC,WAAW;EACX,cAAc;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,sCAAsC;AACxC;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,yCAAyC;EACzC,eAAe;EACf,uBAAuB;EACvB,cAAc;AAChB;AACA,sCAAqB,kBAAkB,EAAE,gDAAgD,EAAE;AAC3F;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,SAAS;EACT,UAAU;EACV,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;AAClB;AACA,mCAAkB,sBAAsB,EAAE;;AAE1C;iFACiF;AACjF;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;AACA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,wBAAwB;AAC1B;AACA,+BAAc,cAAc,EAAE;AAC9B;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;AACnB;AACA,kCAAiB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AACpF;2DAC2D;AAC3D,qCAAoB,iCAAiC,EAAE,gBAAgB,EAAE;AACzE;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;AACA,yCAAuB,uCAAuC,EAAE;AAChE;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,gDAAgD;EAChD,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;AACA,0CAAyB,gDAAgD,EAAE;;AAE3E,gEAA8B,2CAA2C,EAAE;AAC3E,gEAA8B,qCAAqC,EAAE,2CAA2C,EAAE;AAClH,gEAA8B,qBAAqB,EAAE;AACrD,gEAA8B,sBAAsB,EAAE;AACtD;;gEAE8B,uBAAuB,EAAE;AACvD,gEAA8B,qCAAqC,EAAE,kDAAkD,EAAE;AACzH;gEAC8B,qBAAqB,EAAE;AACrD;iEAC+B,wCAAwC,EAAE;AACzE;iEAC+B,qBAAqB,EAAE;AACtD;8FAC2C,uBAAuB,EAAE;AACpE,gEAA8B,+BAA+B,EAAE;AAC/D,gEAA8B,sBAAsB,EAAE;AACtD,gEAA8B,uBAAuB,EAAE,kDAAkD,EAAE;AAC3G,kEAAgC,qBAAqB,EAAE,kDAAkD,EAAE;AAC3G,gEAA8B,qBAAqB,EAAE,kDAAkD,EAAE;AACzG,sEAAoC,kDAAkD,EAAE;;AAExF,gFAAgF;AAChF,kCAAiB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AACpF;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;EAC/B,+BAA+B;EAC/B,yCAAyC;EACzC,eAAe;AACjB;AACA,0CAAyB,mBAAmB,EAAE;AAC9C;EACE,+BAA+B;EAC/B,gDAAgD;AAClD;AACA,kCAAiB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,SAAO,EAAE,YAAY,EAAE;AACzF,mCAAkB,uBAAuB,EAAE,+BAA+B,EAAE,kBAAkB,EAAE;AAChG,mCAAkB,yBAAyB,EAAE,wBAAwB,EAAE,gBAAgB,EAAE;AACzF;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;AACA,wCAAuB,wBAAwB,EAAE;AACjD,wCAAuB,kBAAkB,EAAE;AAC3C,wCAAuB,yBAAyB,EAAE;;AAElD,gCAAe,aAAa,EAAE,SAAS,EAAE,mBAAmB,EAAE;AAC9D,6BAAY,SAAO,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,YAAY,EAAE;AACpF;;EAEE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,8BAA8B;EAC9B,iCAAiC;EACjC,kBAAkB;EAClB,uBAAuB;EACvB,+BAA+B;EAC/B,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;AACpB;AACA,gCAAe,uBAAuB,EAAE,8BAA8B,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC3G,wEAAsC,aAAa,EAAE,kCAAkC,EAAE;;AAEzF,gEAA8B,uCAAuC,EAAE,6CAA6C,EAAE;AACtH,sEAAoC,mBAAmB,EAAE;AACzD,kEAAgC,4BAA4B,EAAE,kDAAkD,EAAE;AAClH,gEAA8B,2BAA2B,EAAE;AAC3D,gEAA8B,iCAAiC,EAAE;AACjE,oEAAkC,uBAAuB,EAAE;AAC3D,oEAAkC,oBAAoB,EAAE;AACxD,oEAAkC,uBAAuB,EAAE;AAC3D;gEAC8B,qCAAqC,EAAE,oCAAoC,EAAE,qBAAqB,EAAE,mBAAmB,CAAC;AACtJ,iEAA+B,2BAA2B,EAAE,gBAAgB,EAAE;;AAE9E,iFAAiF;AACjF,+BAAc,mBAAmB,EAAE;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,2BAA2B;EAC3B,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA,+DAA6B,iCAAiC,EAAE;AAChE,+DAA6B,8BAA8B,EAAE;AAC7D,+DAA6B,+BAA+B,EAAE;;AAE9D;EACE;IACE,2BAA2B;IAC3B,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC,IAAI,8BAA8B;IACnE,qBAAqB,gBAAgB,YAAY;EACnD;EACA,8CAA6B,aAAa,EAAE;;EAE5C,yEAAyE;EACzE;;;IAGE,cAAc;EAChB;;EAEA,gCAAe,iBAAiB,EAAE;;EAElC;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA,4BAAW,WAAW,EAAE,YAAY,EAAE;AACxC;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;EAC/B,cAAc;AAChB;AACA,yDAAyD;AACzD;EACE,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;8EAC8E;AAC9E,gCAAe,eAAe,EAAE,aAAa,EAAE,qBAAqB,EAAE,QAAQ,EAAE,eAAe,EAAE;AACjG,kCAAiB,eAAe,EAAE,2BAA2B,EAAE,kBAAkB,EAAE;AACnF,iCAAgB,iBAAiB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;;AAEjF;;cAEc;AACd,0BAAS,qBAAqB,EAAE;AAChC,0BAAS,yBAAyB,EAAE;AACpC,0BAAS,kBAAkB,EAAE;AAC7B,sDAAoB,8BAA8B,EAAE;AACpD,sDAAoB,oBAAoB,EAAE;AAC1C,sDAAoB,2BAA2B,EAAE;;AAEjD,mCAAkB,aAAa,EAAE,QAAQ,EAAE,cAAc,EAAE;AAC3D;EACE,iBAAiB;EACjB,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;AACA,oDAAkB,kCAAkC,EAAE;;AAEtD,8DAA4B,qCAAqC,EAAE,iCAAiC,EAAE;AACtG;8DAC4B,8BAA8B,EAAE;AAC5D,8DAA4B,2BAA2B,EAAE;AACzD,8DAA4B,iCAAiC,EAAE,iCAAiC,EAAE;AAClG,gFAA6B,uCAAuC,EAAE;;AAEtE,sEAAsE;AACtE,gCAAe,uBAAuB,EAAE,2BAA2B,EAAE,cAAc,EAAE;AACrF,uCAAsB,YAAY,EAAE,eAAe,EAAE;;AAErD,yEAAyE;AACzE;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,2BAA2B;EAC3B,kBAAkB;AACpB;AACA,qCAAoB,oBAAoB,EAAE;;AAE1C;kEACgC,qCAAqC,EAAE;AACvE,mEAAgC,iCAAiC,EAAE;AACnE,kEAAgC,2BAA2B,EAAE;AAC7D,kEAAgC,cAAc,EAAE;;AAEhD,8EAA8E;AAC9E;EACE,kCAAkC;EAClC,uCAAuC;EACvC,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA,qCAAoB,iCAAiC,EAAE;;AAEvD;EACE,iCAAiC;EACjC,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA,gFAAgF;AAChF;;gDAEgD;AAChD;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,+BAA+B;EAC/B,0BAA0B;EAC1B,2CAA2C;EAC3C,sBAAsB;EACtB,qBAAqB,aAAa,YAAY;EAC9C,wBAAwB,UAAU,aAAa;AACjD;AACA,iDAAgC,aAAa,EAAE;AAC/C;EACE,uBAAuB;EACvB,mBAAmB;EACnB,4EAA4E;EAC5E,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;AACA,oEAAkC,iBAAiB,EAAE,kBAAkB,EAAE;AACzE;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA,iCAAe,aAAa,EAAE,QAAQ,EAAE,kBAAkB,EAAE;AAC5D;EACE,iBAAiB;EACjB,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;AACjB;AACA,mCAAkB,kCAAkC,EAAE,oBAAoB,EAAE,iCAAiC,EAAE;;AAE/G;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,uBAAuB;EACvB,8BAA8B;EAC9B,iCAAiC;EACjC,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;AACjB;AACA;4DAC4D;AAC5D;mDACmD;AACnD;EACE,eAAe;EACf,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,iCAAiC;EACjC,gBAAgB;EAChB,uCAAuC;AACzC;AACA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,sCAAsC;EACtC,iCAAiC;EACjC,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,sBAAsB;AACxB;AACA,yCAAwB,aAAa,EAAE;AACvC,uDAAuD;AACvD,iCAAgB,SAAO,EAAE,aAAa,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC7E;EACE,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA,kCAAiB,aAAa,EAAE,uBAAuB,EAAE,wBAAwB,EAAE;AACnF;;EAEE,aAAa;EACb,kCAAkC;AACpC;AACA;sCACqB,aAAa,EAAE,kCAAkC,EAAE;;AAExE;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;AACjB;AACA,uCAAsB,kCAAkC,EAAE;AAC1D,gCAAe,UAAU,EAAE,oBAAoB,EAAE,mCAAmC,EAAE;;AAEtF;EACE,WAAW;EACX,aAAa;EACb,gCAAgC;EAChC,8BAA8B;EAC9B,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;AACA,sCAAqB,kBAAkB,EAAE,kCAAkC,EAAE;AAC7E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA,uFAAoC,oCAAoC,EAAE;AAC1E;EACE,2CAA2C;EAC3C,iCAAiC;EACjC,gDAAgD;AAClD;AACA,6DAA2B,iCAAiC,EAAE,iCAAiC,EAAE;AACjG,6DAA2B,gCAAgC,EAAE,iCAAiC,EAAE,2BAA2B,EAAE;AAC7H,6DAA2B,gCAAgC,EAAE,iCAAiC,EAAE,wCAAwC,EAAE;AAC1I,6DAA2B,2BAA2B,EAAE;AACxD,+DAA6B,oCAAoC,EAAE,wCAAwC,EAAE,2BAA2B,EAAE;AAC1I;+DAC6B,iCAAiC,EAAE;AAChE,6DAA2B,iCAAiC,EAAE,iCAAiC,EAAE;AACjG,6DAA2B,qCAAqC,EAAE;;AAElE,sEAAsE;AACtE;EACE,kCAAkC;EAClC,uCAAuC;EACvC,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA,kCAAiB,kBAAkB,EAAE,kCAAkC,EAAE;AACzE,wDAAsB,iCAAiC,EAAE,iCAAiC,EAAE;;AAE5F,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,8BAA8B;EAC9B,iCAAiC;EACjC,eAAe;AACjB;AACA,sCAAqB,kCAAkC,EAAE;AACzD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,kCAAkC;EAClC,oBAAoB;EACpB,cAAc;AAChB;AACA,qCAAoB,cAAc,EAAE,uBAAuB,EAAE,+BAA+B,EAAE,kBAAkB,EAAE;AAClH,sCAAoB,cAAc,EAAE,uBAAuB,EAAE,wBAAwB,EAAE,eAAe,EAAE;AACxG,gCAAe,aAAa,EAAE,cAAc,EAAE;;AAE9C,iEAA+B,uCAAuC,EAAE,iCAAiC,EAAE;AAC3G,iEAA+B,2BAA2B,EAAE;AAC5D,kEAA+B,iCAAiC,EAAE;;AAElE;;SAES;AACT,gCAAe,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,gBAAgB,EAAE;;AAE3E;8EAC8E;AAC9E;EACE,iBAAiB,EAAE,YAAY,EAAE,oBAAoB;EACrD,+BAA+B,EAAE,wBAAwB;EACzD,yCAAyC;EACzC,oBAAoB,EAAE,yBAAyB,EAAE,eAAe;AAClE;AACA;EACE,uEAAuE;EACvE,6BAA6B;EAC7B,kDAAkD;AACpD;AACA,2DAAyB,uCAAuC,EAAE,uBAAuB,EAAE,6CAA6C,EAAE;AAC1I,6DAA2B,uEAAuE,EAAE,6BAA6B,EAAE,kDAAkD,EAAE;;AAEvL,+EAA+E;;AAE/E;;sEAEsE;AACtE,2BAAU,6DAA6D,EAAE;AACzE;;gFAEgF;AAChF,+BAAc,oBAAoB,EAAE;;AAEpC;EACE,aAAa;EACb,WAAW,EAAE,YAAY,EAAE,cAAc;EACzC,mBAAmB;EACnB,YAAY,EAAE,kBAAkB,EAAE,gBAAgB;EAClD,uBAAuB,EAAE,yCAAyC;EAClE,eAAe;AACjB;;AAEA;;;uDAGuD;AACvD;EACE,2BAAU,SAAS,EAAE,kBAAkB,EAAE;EACzC,2BAAU,aAAa,EAAE;EACzB,wBAAO,wBAAwB,EAAE;EACjC,qCAAoB,aAAa,EAAE;EACnC,4BAAW,kBAAkB,EAAE;EAC/B,6BAAY,iBAAiB,EAAE;AACjC;;AAEA;EACE,2BAAU,SAAS,EAAE,kBAAkB,EAAE;EACzC,4BAAW,wBAAwB,EAAE;EACrC;8CAC4C;EAC5C,6BAAY,wBAAwB,EAAE;EACtC,gCAAe,iBAAiB,EAAE,SAAS,EAAE;EAC7C,mCAAkB,aAAa,EAAE;EACjC,4BAAW,WAAW,EAAE,YAAY,EAAE;AACxC;;AAEA;EACE,eAAe;EACf,MAAM,EAAE,QAAQ,EAAE,SAAS,EAAE,OAAO;EACpC,WAAW,EAAE,eAAe;EAC5B,WAAW;EACX,iCAAiC;EACjC,kBAAkB,EAAE,gBAAgB;EACpC,4BAA4B;AAC9B;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,kBAAkB,EAAE,sCAAsC;AAC5D;AACA;EACE,iBAAiB,EAAE,WAAW,EAAE,YAAY,EAAE,cAAc;EAC5D,aAAa,EAAE,mBAAmB;EAClC,YAAY,EAAE,kBAAkB,EAAE,gBAAgB;EAClD,uBAAuB,EAAE,yCAAyC,EAAE,eAAe;AACrF;AACA;EACE,uBAAuB;EACvB,aAAa,EAAE,sBAAsB,EAAE,SAAS;AAClD;AACA;EACE,kBAAkB;EAClB,kCAAkC,EAAE,yBAAyB;EAC7D,sBAAsB,EAAE,yBAAyB,EAAE,sBAAsB;AAC3E;AACA,kCAAiB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,YAAY,EAAE;AAChF;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,kBAAkB,EAAE,mBAAmB;EACvC,+BAA+B,EAAE,uBAAuB;EACxD,yCAAyC;EACzC,uBAAuB,EAAE,qBAAqB;EAC9C,YAAY,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB;AAC9E;AACA;EACE,uEAAuE;EACvE,2BAA2B;EAC3B,uFAAuF;AACzF;AACA;EACE,iBAAiB,EAAE,kCAAkC;EACrD,yBAAyB,EAAE,yBAAyB;AACtD;AACA;EACE,iBAAiB,EAAE,eAAe;EAClC,oCAAoC;EACpC,aAAa,EAAE,mBAAmB,EAAE,SAAS;AAC/C;;AAEA;iEAC8B,kDAAkD,EAAE,uBAAuB,EAAE;AAC3G;;+BAE+B;AAC/B;4DACyB,2CAA2C,EAAE;AACtE;gEAC6B,oCAAoC,EAAE;AACnE,iEAA8B,uBAAuB,EAAE;AACvD,gEAA6B,qCAAqC,EAAE,sBAAsB,EAAE,kDAAkD,EAAE;AAChJ,kEAA+B,iCAAiC,EAAE,yBAAyB,EAAE,mFAAmF,EAAE;AAClL,iEAA8B,uBAAuB,EAAE;;AAEvD;;mBAEmB;AACnB;EACE,aAAa;EACb,eAAe,EAAE,WAAW,EAAE,YAAY,EAAE,WAAW;EACvD,mBAAmB,EAAE,SAAS;EAC9B,4BAA4B,EAAE,gBAAgB,EAAE,sBAAsB;EACtE,YAAY,EAAE,oBAAoB;EAClC,kCAAkC,EAAE,uBAAuB;EAC3D,mDAAmD;EACnD,oBAAoB,EAAE,gBAAgB,EAAE,eAAe,EAAE,iBAAiB;AAC5E;AACA;wCACwC;AACxC,+BAAc,0BAA0B,EAAE,sBAAsB,EAAE;AAClE;EACE,WAAW,EAAE,YAAY,EAAE,cAAc;EACzC,kBAAkB,EAAE,4BAA4B;AAClD;AACA,6DAA2B,+BAA+B,EAAE;AAC5D,iCAAgB,aAAa,EAAE,sBAAsB,EAAE,iBAAiB,EAAE,YAAY,EAAE;AACxF,kCAAiB,uBAAuB,EAAE;AAC1C,gCAAe,yBAAyB,EAAE,aAAa,EAAE,mBAAmB,EAAE;AAC9E,sCAAqB,YAAY,EAAE,eAAe,EAAE;;AAEpD;EACE,6BAAY,aAAa,EAAE;AAC7B","sourcesContent":["/* ── Layout ─────────────────────────────────── */\n.root {\n  background: var(--surface-sunken);\n  color: var(--text);\n  font-family: 'DM Sans', sans-serif;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* ── Header ─────────────────────────────────── */\n.header {\n  background: var(--surface);\n  border-bottom: 1px solid var(--border);\n  padding: 15px 26px;\n  display: flex;\n  align-items: center;\n  gap: 22px;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.logo {\n  font-family: 'Bebas Neue', cursive;\n  color: var(--accent);\n  letter-spacing: 2px;\n  margin-right: 10px;\n}\n\n.logoImg {\n  width: 29px;\n  height: 29px;\n  object-fit: contain;\n  display: block;\n}\n\n.nav {\n  display: flex;\n  gap: 6px;\n  margin-left: 4px;\n  flex-grow: 1;\n}\n\n.navBtn {\n  background: none;\n  border: none;\n  color: var(--text-muted-alt);\n  font-family: 'DM Sans', sans-serif;\n  font-size: var(--fs-11-5);\n  font-weight: var(--fw-semibold);\n  letter-spacing: 0.15em;\n  text-transform: uppercase;\n  padding: 10px 16px;\n  border-radius: var(--radius-9);\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.navBtn.active {\n  background: color-mix(in srgb, var(--accent) 13%, transparent);\n  color: var(--accent);\n}\n\n/* Theme switch: icon only, so it reads as a control rather than a nav item. */\n.themeIconBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  flex: none;\n  border: var(--hairline);\n  border-radius: var(--radius-8);\n  background: none;\n  color: var(--text-muted-alt);\n  cursor: pointer;\n  transition: all 0.15s;\n}\n.themeIconBtn:hover { color: var(--accent); border-color: var(--accent); }\n\n/* Before/after tax. One bordered group, the active half filled — a choice\n   between two states, not two separate buttons. */\n.taxToggle {\n  display: inline-flex;\n  flex: none;\n  border: var(--hairline);\n  border-radius: var(--radius-8);\n  padding: 2px;\n  gap: 2px;\n}\n.taxOpt {\n  background: none;\n  border: none;\n  border-radius: var(--radius-6);\n  padding: 6px 13px;\n  font-family: 'DM Sans', sans-serif;\n  font-size: var(--fs-10);\n  font-weight: var(--fw-semibold);\n  letter-spacing: 1.2px;\n  text-transform: uppercase;\n  color: var(--text-muted-alt);\n  white-space: nowrap;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n.taxOpt:hover:not(.taxOptActive) { color: var(--text); }\n.taxOptActive {\n  background: var(--surface-raised);\n  color: var(--accent);\n}\n\n/* The exception list reads as a status badge, not another nav destination:\n   the count leads, and the tint says whether anything is waiting. */\n.navPill {\n  display: inline-flex;\n  align-items: center;\n  gap: 9px;\n  padding: 10px 16px;\n  border: none;\n  border-radius: var(--radius-9);\n  font-family: 'DM Sans', sans-serif;\n  font-size: var(--fs-10-5);\n  font-weight: var(--fw-semibold);\n  letter-spacing: 0.13em;\n  text-transform: uppercase;\n  text-decoration: none;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.navPillAlert { background: color-mix(in srgb, currentColor 14%, transparent);\n  color: var(--danger-soft);\n}\n.navPillAlert:hover,\n.navPillClear:hover { background: color-mix(in srgb, currentColor 22%, transparent); }\n.navPillClear { background: color-mix(in srgb, currentColor 12%, transparent);\n  color: var(--success-soft);\n}\n.navPillActive { background: color-mix(in srgb, currentColor 16%, transparent); }\n/* The clock, in the header. Bronze and solid while you are off, so it reads as\n   the thing to press; a quiet green tint once you are on, because then it is a\n   status that happens to be tappable rather than a call to action. */\n.hdrClock {\n  display: inline-flex;\n  align-items: center;\n  gap: 9px;\n  padding: 9px 16px 9px 13px;\n  border: none;\n  border-radius: 999px;\n  background: var(--ace-bronze-warm);\n  color: var(--ace-paper);\n  font-family: inherit;\n  font-size: var(--fs-13-5);\n  white-space: nowrap;\n  cursor: pointer;\n}\n.hdrClock:hover { background: var(--ace-bronze-warm-deep); }\n.hdrClock:disabled { opacity: 0.6; cursor: default; }\n.hdrClockOn,\n.hdrClockOn:hover {\n  background: color-mix(in srgb, var(--ace-success) 13%, transparent);\n  color: var(--ace-success);\n  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--ace-success) 35%, transparent);\n}\n.hdrClockDot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: currentColor;\n  flex: none;\n}\n\n.navPillDot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: currentColor;\n  flex: none;\n}\n\n.navBtn:hover:not(.active) {\n  color: var(--text);\n  background: rgba(255,255,255,0.04);\n}\n\n/* ── Grouped nav dropdowns ───────────────────── */\n.navGroup { position: relative; display: inline-flex; }\n\n.navCaret { font-size: var(--fs-9); line-height: 1; opacity: 0.55; }\n\n.navMenu {\n  position: absolute;\n  top: calc(100% + 7px);\n  left: 0;\n  min-width: 216px;\n  background: var(--surface-high);\n  border: none;\n  border-radius: var(--radius-12);\n  padding: 7px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  box-shadow: 0 20px 40px -18px rgba(20, 15, 10, 0.28),\n              inset 0 0 0 1px var(--border);\n  z-index: 30;\n}\n\n.navMenuItem {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 10px 12px;\n  border-radius: var(--radius-8);\n  font-size: var(--fs-13-5);\n  letter-spacing: 0.3px;\n  color: var(--text-muted-warm);\n  text-decoration: none;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.12s, color 0.12s;\n}\n\n.navMenuItem:not(.navMenuItemDisabled):hover {\n  background: rgba(255,255,255,0.05);\n  color: var(--text);\n}\n\n.navMenuItemActive {\n  color: var(--accent);\n  background: rgba(201,149,106,0.1);\n}\n\n.navMenuItemDisabled { color: var(--text-dim); cursor: default; }\n\n.clock {\n  font-size: var(--fs-11);\n  color: var(--text-dim);\n  letter-spacing: 1px;\n  font-variant-numeric: tabular-nums;\n}\n\n/* ── Stats bar ──────────────────────────────── */\n.statsBar {\n  background: var(--surface);\n  border-bottom: 1px solid var(--border);\n  padding: 10px 24px;\n  display: flex;\n  gap: 32px;\n  align-items: center;\n  overflow: scroll;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n.statsBar::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n.statPill {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  align-items: center;\n}\n\n.localPill {\n  border: 1px solid #d4c8ba;\n  padding: 10px 15px;\n  border-radius: var(--radius-10);\n  cursor: pointer;\n  background-color: var(--surface);\n}\n\n.localPill.active {\n  border-color: rgba(109,184,138,0.35);\n  background: #3e3b35;\n}\n\n.noLocations {\n  color: var(--text-dim);\n  font-size: var(--fs-12);\n  padding: 20px 0;\n  width: 100%;\n  text-align: center;\n}\n\n.statLabel {\n  font-size: var(--fs-9);\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  color: var(--text-dim);\n}\n\n.statValue {\n  font-family: 'Bebas Neue', cursive;\n  font-size: var(--fs-24);\n  color: var(--accent);\n  letter-spacing: 1px;\n  line-height: 1;\n}\n\n.statValue.white { color: var(--text); }\n.statValue.green { color: var(--success); }\n\n.liveTag {\n  margin-left: auto;\n  font-size: var(--fs-10);\n  color: var(--text-dim);\n  letter-spacing: 1px;\n}\n\n/* ── Body grid ──────────────────────────────── */\n.body {\n  display: grid;\n  grid-template-columns: 1fr 230px;\n  flex: 1;\n}\n\n.main {\n  padding: 20px 24px;\n  border-right: 1px solid var(--border);\n  overflow-y: auto;\n}\n\n.sidebar {\n  padding: 18px 16px;\n  background: #0f0e0d;\n  overflow-y: auto;\n}\n\n/* ── Section label ──────────────────────────── */\n.sectionLabel {\n  font-size: var(--fs-9);\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  color: var(--text-dim);\n  margin-bottom: 12px;\n}\n\n.sidebarDivider {\n  border: none;\n  border-top: 1px solid var(--border);\n  margin: 18px 0;\n}\n\n/* ── Filter bar ─────────────────────────────── */\n.filterBar {\n  display: flex;\n  gap: 6px;\n  margin-bottom: 16px;\n  align-items: center;\n}\n\n.filterBtn {\n  font-size: var(--fs-10);\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  padding: 4px 11px;\n  border-radius: var(--radius-5);\n  border: var(--hairline);\n  background: none;\n  color: var(--text-dim);\n  cursor: pointer;\n  font-family: 'DM Sans', sans-serif;\n  transition: all 0.15s;\n}\n\n.filterBtn.active {\n  background: rgba(201,149,106,0.13);\n  color: var(--accent);\n  border-color: transparent;\n}\n\n.filterBtn:hover:not(.active) {\n  color: #a09080;\n  border-color: var(--border-strong);\n}\n\n/* ── Appointment card ───────────────────────── */\n/* The mockup's card: 14px radius, edge drawn as an inset ring so nothing\n   competes with the location's left border — the one thing kept from before. */\n.apptCard {\n  background: var(--surface-card);\n  /* `border: none` would kill the left border too: the inline width and colour\n     the card sets have nothing to draw without a style. Only the left side\n     keeps one. */\n  border: 0 none;\n  border-left-style: solid;\n  border-radius: 14px;\n  box-shadow: inset 0 0 0 1px var(--border);\n  margin-bottom: 8px;\n  overflow: hidden;\n  transition: box-shadow 0.2s, opacity 0.3s;\n}\n\n.apptCard:hover { box-shadow: inset 0 0 0 1px var(--border-strong); }\n\n.apptCard.done { opacity: 0.38; }\n\n.apptCard.urgent { border-left-color: #c0392b; }\n.apptCard.high   { border-left-color: var(--accent); }\n.apptCard.medium { border-left-color: #4a8a6a; }\n\n.apptHeader { display: flex; align-items: center; justify-content: space-between; padding: 15px 17px 0; }\n\n.apptTime {\n  font-family: 'DM Sans', sans-serif;\n  font-weight: var(--fw-bold);\n  font-size: 16px;\n  letter-spacing: 0.03em;\n  color: var(--ace-bronze-warm);\n}\n\n.apptDue {\n  font-size: var(--fs-10);\n  color: var(--text-muted-alt);\n  letter-spacing: 0.5px;\n}\n\n.apptDue.urgentText { color: #e05b4e; }\n\n.priorityBadge {\n  font-size: var(--fs-8);\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  padding: 3px 8px;\n  border-radius: var(--radius-4);\n  font-weight: var(--fw-semibold);\n}\n\n.priorityBadge.urgent { background: rgba(192,57,43,0.13); color: #e05b4e; border: 1px solid rgba(192,57,43,0.27); }\n.priorityBadge.high   { background: rgba(201,149,106,0.13); color: var(--accent); border: 1px solid rgba(201,149,106,0.27); }\n.priorityBadge.medium { background: rgba(74,138,110,0.13); color: var(--success); border: 1px solid rgba(74,138,110,0.27); }\n\n.apptInfo {\n  padding: 0 14px 10px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.apptCar {\n  font-size: var(--fs-15);\n  font-weight: var(--fw-medium);\n  color: var(--text);\n  flex: 1;\n  min-width: 120px;\n}\n\n.apptCar.crossed {\n  text-decoration: line-through;\n  color: var(--text-dim);\n}\n\n.apptService {\n  font-size: var(--fs-11);\n  color: var(--text-muted-alt);\n  font-style: italic;\n  display: block;\n  margin-top: 1px;\n}\n\n.apptDetailer {\n  font-size: var(--fs-10);\n  background: var(--border);\n  padding: 2px 9px;\n  border-radius: var(--radius-4);\n  color: #a09080;\n  letter-spacing: 0.5px;\n  white-space: nowrap;\n}\n\n.apptBay {\n  font-size: var(--fs-10);\n  background: #1e2a24;\n  padding: 2px 9px;\n  border-radius: var(--radius-4);\n  color: var(--success);\n  letter-spacing: 0.5px;\n}\n/* ── Controller row ──────────────────────────── */\n.controllerRow {\n  display: flex;\n  gap: 4px;\n  padding: 8px 14px;\n  justify-content: right;\n}\n\n.nextStepBtn {\n  border: 1px solid #1e2a24;\n  background: var(--surface-sunken);\n  color: #a09080;\n  border-radius: var(--radius-4);\n  padding: 4px 12px;\n  cursor: pointer;\n  font-size: var(--fs-10);\n  letter-spacing: 1px;\n  font-family: inherit;\n  text-transform: uppercase;\n}\n\n/* ── Checklist row ──────────────────────────── */\n.checklistRow {\n  display: flex;\n  gap: 6px;\n  padding: 10px 0;\n  margin: 0 14px;\n  border-top: 1px solid var(--border);\n}\n\n/* Geometry and type taken from the Ace mockup's own step buttons: 6px/4px\n   padding, a 7px radius, 9.5px at 0.1em, and a hairline drawn as an inset ring\n   rather than a border so the button does not grow by 2px when selected. */\n.checkStep {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 9.5px;\n  font-weight: var(--fw-bold);\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--ace-slate);\n  cursor: pointer;\n  padding: 6px 4px;\n  border-radius: 7px;\n  border: none;\n  background: transparent;\n  box-shadow: inset 0 0 0 1px rgba(11, 11, 11, 0.1);\n  transition: all 0.15s;\n  user-select: none;\n  white-space: nowrap;\n}\n\n.checkStep:hover { box-shadow: inset 0 0 0 1px var(--ace-slate); color: var(--ace-ink); }\n\n/* Selected: solid dark green. The mockup tints it at 12% with green text; a\n   filled chip was asked for instead, so the colour is the mockup's own\n   C.paid (#4f6b4c) rather than a brighter green invented here. */\n.checkStep.done,\n.checkStep.done:hover {\n  color: var(--ace-paper);\n  background: var(--ace-success);\n  box-shadow: none;\n}\n\n.checkDot {\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  border: 1.5px solid currentColor;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--fs-9);\n  font-weight: var(--fw-bold);\n  line-height: 1;\n}\n\n.checkStep.done .checkDot {\n  background: rgba(255,255,255,0.25);\n  border-color: rgba(255,255,255,0.5);\n}\n\n/* ── Sidebar — Staff ────────────────────────── */\n.staffItem {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.staffAvatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: var(--border);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--fs-11);\n  font-weight: var(--fw-semibold);\n  color: var(--accent);\n  flex-shrink: 0;\n}\n\n.staffName {\n  font-size: var(--fs-12);\n  font-weight: var(--fw-medium);\n  color: var(--border-light);\n}\n\n.staffStatus {\n  font-size: var(--fs-9);\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  margin-top: 1px;\n}\n\n.staffStatus.available { color: var(--success); }\n.staffStatus.busy      { color: var(--accent); }\n.staffStatus.break     { color: var(--text-muted-alt); }\n\n.staffDot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.staffDot.available { background: var(--success); }\n.staffDot.busy      { background: var(--accent); }\n.staffDot.break     { background: var(--text-faint); }\n\n/* ── Sidebar — Bays ─────────────────────────── */\n.bayGrid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 6px;\n  margin-top: 8px;\n}\n\n.bayCell {\n  background: var(--surface-high);\n  border: var(--hairline);\n  border-radius: var(--radius-6);\n  padding: 8px 4px;\n  text-align: center;\n  transition: all 0.2s;\n}\n\n.bayCell.active {\n  border-color: rgba(201,149,106,0.27);\n  background: rgba(201,149,106,0.07);\n}\n\n.bayNum {\n  font-family: 'Bebas Neue', cursive;\n  font-size: var(--fs-17);\n  color: var(--text-dim);\n}\n\n.bayCell.active .bayNum { color: var(--accent); }\n\n.bayLabel {\n  font-size: var(--fs-7);\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  color: var(--border-strong);\n  margin-top: 1px;\n}\n\n.bayCell.active .bayLabel { color: #7a6e62; }\n\n/* ── Sidebar — Rankings ─────────────────────── */\n.rankItem {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 7px;\n  padding: 6px 8px;\n  background: var(--surface-high);\n  border-radius: var(--radius-6);\n  border: var(--hairline);\n}\n\n.rankNum {\n  font-family: 'Bebas Neue', cursive;\n  font-size: var(--fs-14);\n  color: var(--border-strong);\n  width: 16px;\n  text-align: center;\n  flex-shrink: 0;\n}\n\n.rankNum.gold { color: var(--accent); }\n\n.rankName {\n  font-size: var(--fs-11);\n  font-weight: var(--fw-medium);\n  color: var(--border-light);\n  flex: 1;\n}\n\n.rankPts {\n  font-size: var(--fs-11);\n  color: var(--accent);\n  font-weight: var(--fw-semibold);\n}\n\n/* ── Analytics tab ──────────────────────────── */\n.analyticsGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.analyticsCard {\n  background: var(--surface-high);\n  border: var(--hairline);\n  border-radius: var(--radius-8);\n  padding: 14px;\n}\n\n.aLabel {\n  font-size: var(--fs-9);\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  color: var(--text-dim);\n  margin-bottom: 4px;\n}\n\n.aValue {\n  font-family: 'Bebas Neue', cursive;\n  font-size: var(--fs-30);\n  color: var(--accent);\n  letter-spacing: 1px;\n  line-height: 1;\n}\n\n.aValue span {\n  font-size: var(--fs-14);\n  color: var(--text-muted-alt);\n}\n\n.aSub {\n  font-size: var(--fs-10);\n  color: var(--success);\n  margin-top: 3px;\n}\n\n.aSub.amber { color: var(--accent); }\n\n/* ── Workload bars ───────────────────────────── */\n.effBarWrap { margin-top: 10px; }\n\n.effLabel {\n  display: flex;\n  justify-content: space-between;\n  font-size: var(--fs-9);\n  color: var(--text-dim);\n  letter-spacing: 0.5px;\n  margin-bottom: 4px;\n}\n\n.effBarBg {\n  background: var(--border);\n  border-radius: var(--radius-4);\n  height: 4px;\n  overflow: hidden;\n}\n\n.effBarFill {\n  height: 100%;\n  border-radius: var(--radius-4);\n}\n\n/* ── Full rankings list ─────────────────────── */\n.rankItemFull {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 8px;\n  padding: 10px 14px;\n  background: var(--surface-high);\n  border-radius: var(--radius-8);\n  border: var(--hairline);\n}\n\n.rankDelta {\n  font-size: var(--fs-10);\n}\n\n.rankDelta.positive { color: var(--success); }\n.rankDelta.negative { color: #e05b4e; }\n\n/* ── QR Modal ───────────────────────────────── */\n.qrOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.85);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.qrPanel {\n  background: var(--surface-high);\n  border: var(--hairline);\n  border-radius: var(--radius-16);\n  padding: 28px;\n  max-width: 340px;\n  width: 90%;\n  text-align: center;\n}\n\n.qrEyebrow {\n  font-size: var(--fs-10);\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  color: var(--text-dim);\n  margin-bottom: 6px;\n}\n\n.qrCarName {\n  font-size: var(--fs-16);\n  font-weight: var(--fw-semibold);\n  color: var(--text);\n  margin-bottom: 4px;\n}\n\n.qrServiceName {\n  font-size: var(--fs-12);\n  color: var(--text-muted-alt);\n  margin-bottom: 20px;\n}\n\n.qrCodeWrap {\n  display: inline-block;\n  background: var(--surface-high);\n  padding: 12px;\n  border-radius: var(--radius-10);\n  border: var(--hairline);\n  margin-bottom: 16px;\n}\n\n.qrHint {\n  font-size: var(--fs-13);\n  color: var(--text-muted-alt);\n  margin-bottom: 20px;\n  line-height: 1.5;\n}\n\n.qrUrlBox {\n  background: var(--surface-sunken);\n  border: var(--hairline);\n  border-radius: var(--radius-8);\n  padding: 8px 12px;\n  font-size: var(--fs-10);\n  color: var(--text-dim);\n  word-break: break-all;\n  margin-bottom: 16px;\n  text-align: left;\n}\n\n.qrCloseBtn {\n  background: #c9956a22;\n  border: 1px solid #c9956a44;\n  color: var(--accent);\n  border-radius: var(--radius-8);\n  padding: 10px 24px;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: var(--fs-13);\n  letter-spacing: 1px;\n  text-transform: uppercase;\n}\n\n/* ── Photo strip ────────────────────────────── */\n.photoStripWrap {\n  margin: 0 14px 10px;\n}\n\n.photoStripLabel {\n  font-size: var(--fs-8);\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  color: var(--text-dim);\n  margin-bottom: 6px;\n}\n\n.photoStripRow {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.photoThumb {\n  width: 48px;\n  height: 48px;\n  object-fit: cover;\n  border-radius: var(--radius-6);\n}\n\n.photoThumbBefore { border: 2px solid #5b8fa866; }\n.photoThumbAfter  { border: 2px solid #6db88a66; }\n\n/* ── Appointment card internals ─────────────── */\n.urgentBanner {\n  background: rgba(180,30,30,0.85);\n  padding: 4px 14px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.urgentLabel {\n  font-family: 'Bebas Neue', cursive;\n  font-size: var(--fs-28);\n  color: #ffcccc;\n  letter-spacing: 4px;\n}\n\n.urgentChangeBtn {\n  background: rgba(255,255,255,0.15);\n  border: 1px solid rgba(255,200,200,0.3);\n  color: #ffcccc;\n  border-radius: var(--radius-4);\n  padding: 2px 8px;\n  cursor: pointer;\n  font-size: var(--fs-9);\n  letter-spacing: 1px;\n  font-family: inherit;\n  text-transform: uppercase;\n}\n\n.cardAmountTag {\n  font-size: var(--fs-12);\n  color: var(--accent);\n  font-weight: var(--fw-medium);\n}\n\n.cameraBtn {\n  background: rgba(201,149,106,0.1);\n  border: 1px solid rgba(201,149,106,0.25);\n  color: var(--accent);\n  border-radius: var(--radius-5);\n  padding: 4px 8px;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  cursor: pointer;\n  font-size: var(--fs-13);\n  line-height: 1;\n}\n.cameraBtnDone  { background: rgba(109,184,138,0.15); border-color: rgba(109,184,138,0.35); color: var(--success); }\n.cameraBtnError { background: rgba(224,48,48,0.13);   border-color: rgba(224,48,48,0.3);   color: #e05050; }\n\n\n\n/* ── Photo Carousel Modal ───────────────────────────────────────────────────── */\n.carouselOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.92);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1100;\n}\n\n.carouselPanel {\n  background: var(--surface-high);\n  border: var(--hairline);\n  border-radius: var(--radius-16);\n  padding: 20px;\n  width: min(92vw, 680px);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.carouselHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.carouselCar {\n  font-size: var(--fs-15);\n  font-weight: var(--fw-semibold);\n  color: var(--text);\n}\n\n.carouselService {\n  font-size: var(--fs-11);\n  color: var(--text-muted-alt);\n  margin-top: 2px;\n}\n\n.carouselClose {\n  background: none;\n  border: var(--hairline);\n  color: var(--text-muted-alt);\n  border-radius: var(--radius-6);\n  width: 28px;\n  height: 28px;\n  cursor: pointer;\n  font-size: var(--fs-13);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.carouselImgWrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--surface-sunken);\n  border-radius: var(--radius-10);\n  overflow: hidden;\n  min-height: 300px;\n}\n\n.carouselImg {\n  max-width: 100%;\n  max-height: 60vh;\n  object-fit: contain;\n  display: block;\n}\n\n.carouselArrow {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background: rgba(0,0,0,0.5);\n  border: 1px solid rgba(255,255,255,0.1);\n  color: var(--text);\n  border-radius: 50%;\n  width: 36px;\n  height: 36px;\n  font-size: var(--fs-22);\n  line-height: 1;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1;\n}\n.carouselArrow:disabled { opacity: 0.2; cursor: default; }\n.carouselArrowLeft  { left: 10px; }\n.carouselArrowRight { right: 10px; }\n\n.carouselMeta {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.carouselPhase {\n  font-size: var(--fs-9);\n  letter-spacing: 2px;\n  color: var(--info);\n  background: rgba(122,158,201,0.1);\n  border: 1px solid rgba(122,158,201,0.2);\n  padding: 2px 8px;\n  border-radius: var(--radius-4);\n}\n\n.carouselCount {\n  font-size: var(--fs-11);\n  color: var(--text-dim);\n}\n\n.carouselDots {\n  display: flex;\n  gap: 6px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.carouselDot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--border);\n  border: none;\n  cursor: pointer;\n  padding: 0;\n}\n\n.carouselDotActive {\n  background: var(--info);\n}\n\n.carouselLoading {\n  text-align: center;\n  color: var(--text-dim);\n  padding: 40px 0;\n  font-size: var(--fs-13);\n}\n\n.serviceList {\n  margin: 0 14px 8px;\n}\n\n.serviceRow {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n}\n\n.serviceBullet {\n  font-size: var(--fs-9);\n  margin-top: 2px;\n  flex-shrink: 0;\n  opacity: 0.8;\n}\n\n.serviceText {\n  font-size: var(--fs-11);\n  color: #c8bfb4;\n  line-height: 1.4;\n}\n\n.serviceTextDone {\n  color: var(--text-dim);\n  text-decoration: line-through;\n}\n\n.assignedRow {\n  margin: 0 14px 8px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.assignedLabel {\n  font-size: var(--fs-8);\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  color: var(--text-dim);\n}\n\n.assignedHint {\n  font-size: var(--fs-8);\n  color: var(--border-strong);\n}\n\n.dropTarget {\n  margin: 0 14px 8px;\n  padding: 6px;\n  border-radius: var(--radius-4);\n  text-align: center;\n  font-size: var(--fs-10);\n  letter-spacing: 1px;\n}\n\n.notesBox {\n  margin: 0 14px 8px;\n  padding: 6px 10px;\n  background: var(--surface-sunken);\n  border: var(--hairline);\n  border-radius: var(--radius-4);\n}\n\n.notesLabel {\n  font-size: var(--fs-8);\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  color: var(--text-dim);\n  margin-bottom: 3px;\n}\n\n.notesText {\n  font-size: var(--fs-11);\n  color: #a09080;\n  line-height: 1.5;\n  white-space: pre-wrap;\n}\n\n/* ── Booked-by line ─────────────────────────── */\n.bookedInfo {\n  padding: 0 14px 10px;\n  font-size: var(--fs-11);\n  letter-spacing: 0.3px;\n  margin-top: 6px;\n  color: #8a7f74;\n}\n.bookedInfoUrgent {\n  color: #e08a8a;\n}\n\n/* ── Booked amount box ──────────────────────── */\n.bookedBox {\n  margin: 8px 14px 12px;\n  padding: 8px 12px;\n  border: var(--hairline);\n  border-radius: var(--radius-8);\n  background: transparent;\n}\n.bookedBoxLabel {\n  font-size: var(--fs-8);\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  color: var(--text-dim);\n  margin-bottom: 3px;\n}\n.bookedBoxAmount {\n  font-size: var(--fs-15);\n  font-weight: var(--fw-bold);\n  color: var(--text);\n}\n\n/* ── Location column ────────────────────────── */\n.locationCol {\n  flex: 1 0 320px;\n  min-width: 320px;\n  max-width: 50%;\n  border-right: 1px solid var(--border);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.locationHeader {\n  background: var(--surface);\n  padding: 10px 14px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-shrink: 0;\n}\n\n/* The mockup sets these in the display face at 0.1em, not Bebas at 2px. */\n.locationName {\n  font-family: 'DM Sans', sans-serif;\n  font-weight: var(--fw-heavy);\n  font-size: 16px;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n}\n\n.locationMeta {\n  margin-top: 5px;\n  font-size: 10px;\n  letter-spacing: 0.11em;\n  text-transform: uppercase;\n  color: var(--ace-slate);\n}\n\n.locationUrgentCount {\n  color: #e05050;\n  margin-left: 6px;\n}\n\n.locationCount {\n  font-family: 'DM Sans', sans-serif;\n  font-weight: var(--fw-bold);\n  font-size: 18px;\n}\n\n.locationBody {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 12px 10px;\n}\n\n.locationLoading {\n  font-size: var(--fs-12);\n  padding: 20px 0;\n  text-align: center;\n  letter-spacing: 1px;\n}\n\n.locationError {\n  color: #e05b4e;\n  font-size: var(--fs-11);\n  padding: 20px 0;\n  text-align: center;\n}\n\n.locationEmpty {\n  color: var(--text-dim);\n  font-size: var(--fs-12);\n  padding: 20px 0;\n  text-align: center;\n}\n\n/* ── Staff member card ──────────────────────── */\n.staffCard {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 6px;\n  padding: 6px 8px;\n  background: var(--surface-high);\n  border: var(--hairline);\n  border-radius: var(--radius-7);\n  cursor: grab;\n  transition: border-color 0.15s;\n}\n\n.staffCard:hover { border-color: var(--border-strong); }\n\n.staffDragHandle {\n  font-size: var(--fs-10);\n  color: var(--border-strong);\n  flex-shrink: 0;\n}\n\n.staffInitialBubble {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: var(--border);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--fs-9);\n  font-weight: var(--fw-semibold);\n  color: var(--accent);\n  flex-shrink: 0;\n}\n\n.staffInfo { flex: 1; min-width: 0; }\n\n.staffNameText {\n  font-size: var(--fs-11);\n  font-weight: var(--fw-medium);\n  color: var(--border-light);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.staffStatusBtn {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 1px;\n}\n\n.staffStatusDot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n}\n\n.staffStatusText {\n  font-size: var(--fs-8);\n  letter-spacing: 1.2px;\n  text-transform: uppercase;\n}\n\n/* ── Sidebar ────────────────────────────────── */\n.sidebarPanel {\n  width: 210px;\n  flex-shrink: 0;\n  background: #0f0e0d;\n  border-left: 1px solid var(--border);\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.sidebarTopSection {\n  padding: 14px 16px 8px;\n  flex-shrink: 0;\n  border-bottom: 1px solid var(--border);\n}\n\n.sidebarHint {\n  font-size: var(--fs-8);\n  color: var(--border-strong);\n  letter-spacing: 1px;\n  text-transform: uppercase;\n}\n\n.sidebarStaffList {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 10px 12px;\n  scrollbar-width: none;        /* Firefox */\n  -ms-overflow-style: none;     /* IE / old Edge */\n}\n.sidebarStaffList::-webkit-scrollbar { /* Chrome / Safari */\n  display: none;\n}\n\n/* Collapsible STAFF panel */\n.sidebarHeaderRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n.sidebarToggle {\n  background: transparent;\n  border: var(--hairline);\n  color: var(--text-muted-alt);\n  border-radius: var(--radius-6);\n  width: 22px;\n  height: 22px;\n  padding: 0;\n  line-height: 1;\n  font-size: var(--fs-13);\n  cursor: pointer;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.sidebarToggle:hover { border-color: var(--accent); color: var(--accent); }\n\n.sidebarPanelMin { width: 44px; }\n.sidebarPanelMin .sidebarTopSection { padding: 12px 0; }\n.sidebarPanelMin .sidebarHeaderRow { justify-content: center; }\n\n.lightRoot .sidebarToggle {\n  border-color: var(--border-light);\n  color: var(--text-muted-on-light);\n}\n.lightRoot .sidebarToggle:hover { border-color: var(--accent-strong); color: var(--accent-strong); }\n\n.sidebarBottomSection {\n  border-top: 1px solid var(--border);\n  padding: 12px 16px;\n  flex-shrink: 0;\n}\n\n/* ── Header controls ────────────────────────── */\n.headerRight {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 14px;\n  margin-left: auto;\n}\n\n.headerClockGroup {\n  /* A little air before the status block, so the controls to its left read as\n     one group rather than running into it. */\n  margin-left: 6px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.headerLiveLabel {\n  font-size: var(--fs-10);\n  color: var(--text-muted-alt);\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  line-height: 1.6;\n}\n\n.headerSyncLabel {\n  font-size: var(--fs-10);\n  color: var(--text-muted-alt);\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  line-height: 1.6;\n  opacity: 0.62;\n}\n\n.themeSwitchBtn {\n  background: none;\n  border: none;\n  box-shadow: inset 0 0 0 1px var(--border);\n  color: var(--text-muted-alt);\n  border-radius: var(--radius-9);\n  padding: 9px 16px;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: var(--fs-10-5);\n  letter-spacing: 0.13em;\n  text-transform: uppercase;\n}\n\n/* Self-contained light theme for the shared Header, so it works on pages that\n   don't wrap their content in `.lightRoot` (Transactions/Staff/Admin). */\n.headerLight { background: var(--surface-light-background); border-bottom-color: var(--border-light); }\n.headerLight .logo { color: var(--accent-strong); }\n.headerLight .navBtn { color: var(--text-muted-on-light); }\n.headerLight .navBtn:hover:not(.active) { color: var(--text-on-light); background: rgba(0,0,0,0.05); }\n.headerLight .themeIconBtn { border-color: var(--border-light); color: var(--text-muted-on-light); }\n.headerLight .themeIconBtn:hover { color: var(--accent-strong); border-color: var(--accent-strong); }\n.headerLight .taxToggle { border-color: var(--border-light); }\n.headerLight .taxOpt { color: var(--text-muted-on-light); }\n.headerLight .taxOpt:hover:not(.taxOptActive) { color: var(--text-on-light); }\n.headerLight .taxOptActive { background: var(--accent-background); color: var(--accent-strong); }\n.headerLight .navPillAlert { background: color-mix(in srgb, var(--ace-error) 9%, transparent); color: var(--ace-error); }\n.headerLight .navPillClear { background: color-mix(in srgb, var(--success-on-light) 10%, transparent); color: var(--success-on-light); }\n/* The light scope sets the pill's colour at two-class specificity, so the hover\n   and active tints have to be stated here too or they never win. */\n.headerLight .navPillAlert:hover,\n.headerLight .navPillClear:hover { background: color-mix(in srgb, currentColor 22%, transparent); }\n.headerLight .navPillActive      { background: color-mix(in srgb, currentColor 16%, transparent); }\n.headerLight .navBtn.active {\n  background: var(--ace-tab-active);\n  color: var(--ace-tab-ink);\n}\n.headerLight .headerLiveLabel,\n.headerLight .headerSyncLabel { color: var(--ace-slate); }\n.headerLight .themeSwitchBtn {\n  border: none;\n  box-shadow: inset 0 0 0 1px var(--ace-stroke-ring);\n  color: var(--ace-slate);\n}\n\n.navMenuLight {\n  background: var(--surface-light-card);\n  box-shadow: 0 20px 40px -18px rgba(20, 15, 10, 0.28),\n              inset 0 0 0 1px var(--ace-stroke-hair);\n}\n.navMenuLight .navMenuItem { color: #6a5c4e; }\n.navMenuLight .navMenuItem:not(.navMenuItemDisabled):hover { background: rgba(0,0,0,0.05); color: var(--text-on-light); }\n.navMenuLight .navMenuItemActive { color: var(--ace-tab-ink); background: var(--ace-menu-item); }\n.navMenuLight .navMenuItemDisabled { color: #b0a394; }\n\n/* ── Stats bar divider ──────────────────────── */\n.statsBarDivider {\n  width: 1px;\n  background: var(--border);\n  margin: 0 8px;\n  align-self: stretch;\n}\n\n/* ── Date nav ───────────────────────────────── */\n.dateNavBtn {\n  background: none;\n  border: var(--hairline);\n  color: var(--text-muted-alt);\n  border-radius: var(--radius-5);\n  padding: 4px 10px;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: var(--fs-13);\n}\n\n.dateNavDisplay {\n  font-family: 'Bebas Neue', cursive;\n  font-size: var(--fs-16);\n  letter-spacing: 1.5px;\n  padding: 4px 12px;\n  border-radius: var(--radius-5);\n  cursor: pointer;\n  min-width: 100px;\n  text-align: center;\n}\n\n.dateNavDisplayToday {\n  color: var(--accent);\n  border: 1px solid transparent;\n  background: var(--accent-wash);\n}\n\n.dateNavDisplayOther {\n  border: var(--hairline);\n  background: none;\n}\n\n.dateNavHiddenInput {\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n}\n\n.dateNavTodayBtn {\n  background: #c9956a22;\n  border: 1px solid #c9956a44;\n  color: var(--accent);\n  border-radius: var(--radius-5);\n  padding: 4px 10px;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: var(--fs-10);\n  letter-spacing: 1px;\n  text-transform: uppercase;\n}\n\n.uploadPickerOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.45);\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  z-index: 1200;\n}\n\n.uploadPickerPanel {\n  width: min(420px, calc(100vw - 20px));\n  background: var(--surface);\n  border: var(--hairline);\n  border-radius: 12px 12px 0 0;\n  padding: 10px;\n  margin-bottom: max(10px, env(safe-area-inset-bottom));\n  box-shadow: 0 -8px 24px rgba(0,0,0,0.35);\n}\n\n.uploadPickerItem {\n  width: 100%;\n  border: var(--hairline);\n  background: var(--surface-high);\n  color: var(--text);\n  border-radius: var(--radius-8);\n  padding: 12px 14px;\n  font-family: inherit;\n  font-size: var(--fs-12);\n  letter-spacing: 0.8px;\n  cursor: pointer;\n  margin-bottom: 8px;\n}\n\n.uploadPickerItem:last-child {\n  margin-bottom: 0;\n}\n\n.uploadPickerCancel {\n  color: #b8a898;\n}\n\n/* No 1600px column here. The queue is a board — four garage lanes and the\n   staff rail — and every pixel taken off its width comes out of the cards. */\n.mainContent {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n  min-width: 0;\n  overflow-x: auto;\n  overflow-y: hidden;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n.mainContent::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n.locationsGrid {\n  display: flex;\n  flex: 1;\n  min-width: 320px;\n  overflow: scroll;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.lightRoot {\n  background: var(--surface-light-alt);\n  color: var(--text-on-light);\n}\n\n.lightRoot .logo { color: var(--accent-strong); }\n.lightRoot .clock { color: var(--text-muted-on-light); }\n\n.lightRoot .navBtn { color: var(--text-muted-on-light); }\n.lightRoot .navBtn:hover:not(.active) {\n  color: var(--text-on-light);\n  background: rgba(0,0,0,0.05);\n}\n.lightRoot .navBtn.active {\n  background: rgba(176,120,64,0.12);\n  color: var(--accent-strong);\n  border-color: rgba(176,120,64,0.3);\n}\n\n.lightRoot .statsBar {\n  background: var(--surface-light-background);\n  border-bottom-color: var(--border-light);\n}\n\n.lightRoot .statLabel { color: var(--text-muted-on-light); }\n.lightRoot .statValue { color: var(--accent-strong); }\n.lightRoot .statValue.green { color: #3a8a5a; }\n.lightRoot .liveTag { color: var(--text-muted-on-light); }\n\n.lightRoot .sectionLabel { color: var(--text-muted-on-light); }\n\n/* The mockup's card: a 14px radius on #fcfaf6 with its edge drawn as an inset\n   ring, so the coloured left border is the only real border on the element. */\n.lightRoot .apptCard {\n  background: #fcfaf6;\n  border-color: transparent;\n  border-radius: 14px;\n  box-shadow: inset 0 0 0 1px rgba(11, 11, 11, 0.08);\n}\n.lightRoot .apptCard:hover { box-shadow: inset 0 0 0 1px rgba(11, 11, 11, 0.18); }\n.lightRoot .apptCard.done { opacity: 0.45; }\n\n.lightRoot .apptTime { color: var(--accent-strong); }\n.lightRoot .apptDue  { color: var(--text-muted-on-light); }\n.lightRoot .apptCar  { color: var(--text-on-light); }\n.lightRoot .apptCar.crossed { color: var(--text-muted-on-light); }\n.lightRoot .apptDetailer {\n  background: var(--text);\n  color: #7a6e62;\n}\n\n.lightRoot .checklistRow { border-top-color: var(--border-light); }\n.lightRoot .checkStep { color: var(--ace-slate); background: transparent; }\n.lightRoot .checkStep:hover { box-shadow: inset 0 0 0 1px var(--ace-success); color: var(--ace-ink); }\n.lightRoot .checkStep.done,\n.lightRoot .checkStep.done:hover {\n  color: var(--ace-paper);\n  background: var(--ace-success);\n  box-shadow: none;\n}\n\n.lightRoot .rankItem {\n  background: var(--surface-light);\n  border-color: var(--border-light);\n}\n.lightRoot .rankNum      { color: #c4b4a4; }\n.lightRoot .rankNum.gold { color: var(--accent-strong); }\n.lightRoot .rankName     { color: var(--text-on-light); }\n.lightRoot .rankPts      { color: var(--accent-strong); }\n\n.lightRoot .analyticsCard {\n  background: var(--surface-light);\n  border-color: var(--border-light);\n}\n.lightRoot .aLabel { color: var(--text-muted-on-light); }\n.lightRoot .aValue { color: var(--accent-strong); }\n.lightRoot .aSub   { color: #3a8a5a; }\n\n.lightRoot .rankItemFull {\n  background: var(--surface-light);\n  border-color: var(--border-light);\n}\n\n/* lightRoot — new classes */\n.lightRoot .qrPanel {\n  background: var(--surface-light);\n  border-color: var(--border-light);\n}\n.lightRoot .qrEyebrow   { color: var(--text-muted-on-light); }\n.lightRoot .qrCarName   { color: var(--text-on-light); }\n.lightRoot .qrServiceName { color: #7a6e62; }\n.lightRoot .qrCodeWrap  { background: var(--surface-light); border-color: var(--border-light); }\n.lightRoot .qrHint      { color: #7a6e62; }\n.lightRoot .qrUrlBox    { background: var(--surface-light-background); border-color: var(--border-light); color: var(--text-muted-on-light); }\n.lightRoot .qrCloseBtn  { background: rgba(176,120,64,0.1); border-color: rgba(176,120,64,0.3); color: var(--accent-strong); }\n\n.lightRoot .photoStripLabel { color: var(--text-muted-on-light); }\n\n.lightRoot .cardAmountTag { color: var(--accent-strong); }\n\n.lightRoot .cameraBtn      { background: rgba(176,120,64,0.08); border-color: rgba(176,120,64,0.25); color: var(--accent-strong); }\n.lightRoot .cameraBtnDone  { background: rgba(58,138,90,0.12);  border-color: rgba(58,138,90,0.3);  color: #3a8a5a; }\n.lightRoot .cameraBtnError { background: rgba(200,40,40,0.1);   border-color: rgba(200,40,40,0.25); color: #c02020; }\n\n.lightRoot .serviceText      { color: #4a3a2a; }\n.lightRoot .serviceTextDone  { color: var(--text-muted-on-light); }\n\n.lightRoot .assignedLabel { color: var(--text-muted-on-light); }\n.lightRoot .assignedHint  { color: #c4b4a4; }\n\n.lightRoot .notesBox {\n  background: var(--surface-light-raised);\n  border-color: var(--border-light);\n}\n.lightRoot .notesLabel { color: var(--text-muted-on-light); }\n.lightRoot .notesText  { color: #6a5c4e; }\n\n.lightRoot .bookedInfo       { color: var(--text-muted-on-light); }  /* light mode, normal */\n.lightRoot .bookedInfoUrgent { color: var(--danger); }  /* light mode, urgent */\n.lightRoot .bookedBox        { background: transparent; border-color: var(--border-light); }\n.lightRoot .bookedBoxLabel   { color: var(--text-muted-on-light); }\n.lightRoot .bookedBoxAmount  { color: var(--text-on-light); }\n\n.lightRoot .locationCol    { border-right-color: var(--border-light); }\n.lightRoot .locationHeader { background: var(--surface-light-background); }\n.lightRoot .locationMeta   { color: var(--text-muted-on-light); }\n.lightRoot .locationBody   { background: var(--surface-light-background); }\n.lightRoot .locationEmpty  { color: var(--text-muted-on-light); }\n\n.lightRoot .staffCard {\n  background: var(--surface-light);\n  border-color: var(--border-light);\n}\n.lightRoot .staffCard:hover { border-color: var(--text-dim-on-light); }\n.lightRoot .staffDragHandle    { color: #c4b4a4; }\n.lightRoot .staffInitialBubble { background: var(--text); color: var(--accent-strong); }\n.lightRoot .staffNameText      { color: var(--text-on-light); }\n\n.lightRoot .sidebarPanel {\n  background: var(--surface-light-background);\n  border-left-color: var(--border-light);\n}\n.lightRoot .sidebarTopSection  { border-bottom-color: var(--border-light); }\n.lightRoot .sidebarHint        { color: #c4b4a4; }\n.lightRoot .sidebarBottomSection { border-top-color: var(--border-light); }\n\n.lightRoot .headerSyncLabel { color: var(--text-muted-on-light); }\n\n.lightRoot .themeSwitchBtn {\n  border-color: var(--border-light);\n  color: #7a6e62;\n}\n\n.lightRoot .statsBarDivider { background: var(--border-light); }\n\n.lightRoot .dateNavBtn {\n  border-color: var(--border-light);\n  color: #7a6e62;\n}\n.lightRoot .dateNavDisplayOther {\n  color: var(--text-on-light);\n  border-color: var(--border-light);\n}\n.lightRoot .dateNavTodayBtn {\n  background: rgba(176,120,64,0.1);\n  border-color: rgba(176,120,64,0.3);\n  color: var(--accent-strong);\n}\n\n.lightRoot .uploadPickerPanel {\n  background: var(--surface-light-background);\n  border-color: var(--border-light);\n}\n\n.lightRoot .uploadPickerItem {\n  background: var(--surface-light);\n  border-color: var(--border-light);\n  color: var(--text-on-light);\n}\n\n.lightRoot .uploadPickerCancel {\n  color: #7a6e62;\n}\n\n.lightRoot .localPill {\n  background: var(--surface-light-background);\n}\n\n.lightRoot .localPill.active {\n  border-color: rgba(109,184,138,0.35);\n  background: #f5f0eb;\n}\n\n/* ── Carousel — light mode ──────────────────── */\n.lightRoot .carouselOverlay {\n  background: rgba(0,0,0,0.65);\n}\n\n.lightRoot .carouselPanel {\n  background: var(--surface-light);\n  border-color: var(--border-light);\n}\n\n.lightRoot .carouselCar   { color: var(--text-on-light); }\n.lightRoot .carouselService { color: #7a6e62; }\n\n.lightRoot .carouselClose {\n  border-color: var(--border-light);\n  color: var(--text-muted-on-light);\n}\n.lightRoot .carouselClose:hover {\n  background: var(--surface-light-background);\n}\n\n.lightRoot .carouselImgWrap { background: var(--surface-light-background); }\n\n.lightRoot .carouselArrow {\n  background: rgba(255,255,255,0.75);\n  border-color: rgba(0,0,0,0.12);\n  color: var(--text-on-light);\n}\n\n.lightRoot .carouselPhase {\n  color: #5a7a9a;\n  background: rgba(90,122,154,0.1);\n  border-color: rgba(90,122,154,0.25);\n}\n\n.lightRoot .carouselCount { color: var(--text-muted-on-light); }\n\n.lightRoot .carouselDot { background: var(--border-light); }\n.lightRoot .carouselDotActive { background: var(--info); }\n\n.lightRoot .carouselLoading { color: var(--text-muted-on-light); }\n\n.lightRoot .controllerRow .nextStepBtn {\n  color: #1e2a24;\n  background: var(--surface-light-raised);\n}\n\n/* ── Next Step modal ─────────────────────────── */\n.nextStepPanel {\n  background: var(--surface-high);\n  border: var(--hairline);\n  border-radius: var(--radius-16);\n  padding: 24px;\n  max-width: 380px;\n  width: 90%;\n  text-align: left;\n}\n\n.nextStepEyebrow {\n  font-size: var(--fs-10);\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  color: var(--accent);\n  margin-bottom: 6px;\n}\n\n.nextStepCar {\n  font-size: var(--fs-16);\n  font-weight: var(--fw-semibold);\n  color: var(--text);\n  margin-bottom: 10px;\n}\n\n.nextStepPrompt {\n  font-size: var(--fs-14);\n  color: #a09080;\n  line-height: 1.5;\n  margin-bottom: 14px;\n}\n\n.nextStepTextarea {\n  width: 100%;\n  box-sizing: border-box;\n  background: var(--surface-sunken);\n  border: var(--hairline);\n  border-radius: var(--radius-8);\n  padding: 10px;\n  color: var(--text);\n  font-family: inherit;\n  font-size: var(--fs-13);\n  resize: vertical;\n  margin-bottom: 16px;\n}\n\n.nextStepTextarea:focus {\n  outline: none;\n  border-color: #c9956a66;\n}\n\n.nextStepPhotoHead {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.nextStepPhotoLabel {\n  font-size: var(--fs-9);\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  color: var(--text-dim);\n}\n\n.nextStepPhotoOk {\n  font-size: var(--fs-11);\n  font-weight: var(--fw-semibold);\n  color: var(--success);\n}\n\n.nextStepPhotoNeed {\n  font-size: var(--fs-11);\n  font-weight: var(--fw-semibold);\n  color: var(--accent);\n}\n\n.nextStepThumbs {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n}\n\n.nextStepThumbWrap {\n  position: relative;\n  width: 56px;\n  height: 56px;\n}\n\n.nextStepThumb {\n  width: 56px;\n  height: 56px;\n  object-fit: cover;\n  border-radius: var(--radius-8);\n  border: var(--hairline);\n}\n\n.nextStepThumbX {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: none;\n  background: #a01e1e;\n  color: #fff;\n  font-size: var(--fs-10);\n  line-height: 1;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.nextStepAddPhoto {\n  width: 56px;\n  height: 56px;\n  border-radius: var(--radius-8);\n  border: 1px dashed var(--text-faint);\n  background: var(--surface-sunken);\n  color: #a09080;\n  font-size: var(--fs-11);\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.nextStepAddPhoto:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.nextStepError {\n  background: rgba(160,30,30,0.13);\n  border: 1px solid rgba(160,30,30,0.4);\n  color: #e03030;\n  border-radius: var(--radius-8);\n  padding: 8px 10px;\n  font-size: var(--fs-12);\n  margin-bottom: 12px;\n}\n\n.nextStepActions {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n.nextStepCancel {\n  background: transparent;\n  border: var(--hairline);\n  color: var(--text-muted-alt);\n  border-radius: var(--radius-8);\n  padding: 10px 18px;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: var(--fs-13);\n}\n\n.nextStepConfirm {\n  background: #c9956a22;\n  border: 1px solid #c9956a44;\n  color: var(--accent);\n  border-radius: var(--radius-8);\n  padding: 10px 22px;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: var(--fs-13);\n  letter-spacing: 0.5px;\n}\n\n.nextStepConfirm:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.nextStepHint {\n  font-size: var(--fs-11);\n  color: var(--text-dim);\n  text-align: right;\n  margin-top: 8px;\n}\n\n.lightRoot .nextStepPanel {\n  background: #fff;\n  border-color: #e8e0d4;\n}\n\n.lightRoot .nextStepCar { color: var(--text-on-light); }\n.lightRoot .nextStepPrompt { color: var(--text-dim); }\n.lightRoot .nextStepTextarea {\n  background: var(--surface-light-raised);\n  border-color: #e8e0d4;\n  color: var(--text-on-light);\n}\n.lightRoot .nextStepCancel { color: var(--text-muted-on-light); border-color: #e8e0d4; }\n.lightRoot .nextStepConfirm {\n  background: rgba(176,120,64,0.1);\n  border-color: rgba(176,120,64,0.3);\n  color: var(--accent-strong);\n}\n.lightRoot .nextStepEyebrow { color: var(--accent-strong); }\n.lightRoot .nextStepAddPhoto { background: var(--surface-light-raised); color: var(--text-dim); }\n\n/* ── Payment summary on the appointment card ──────────────────────────────── */\n/* Booked -> collected, shown inside the existing .bookedBox frame. */\n.payRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.payCol { min-width: 0; }\n.payArrow {\n  color: var(--text-dim);\n  font-size: var(--fs-13);\n  flex-shrink: 0;\n}\n.payCollected { color: var(--success-soft); }\n.payUnpaid    { color: var(--accent-strong); }\n.payReceivable{ color: var(--accent); }\n.payNoCharge  { color: var(--text-muted); }\n.payAction {\n  margin-left: auto;\n  flex-shrink: 0;\n  padding: 4px 12px;\n  border: none;\n  border-radius: var(--radius-6);\n  background: var(--accent-deep);\n  color: var(--accent-ink);\n  font-size: var(--fs-10);\n  font-weight: var(--fw-bold);\n  letter-spacing: 0.4px;\n  cursor: pointer;\n}\n.payAction:hover { background: #9a6a35; }\n.payTip {\n  margin-top: 6px;\n  font-size: var(--fs-10);\n  color: var(--text-muted);\n}\n.payVariance {\n  margin-top: 5px;\n  font-size: var(--fs-10);\n  color: var(--danger-soft);\n}\n/* Method badge in the card header, e.g. PAID / INVOICED / HOTEL A/R. */\n.payBadge {\n  padding: 2px 7px;\n  border-radius: var(--radius-5);\n  font-size: var(--fs-8);\n  font-weight: var(--fw-bold);\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  border: 1px solid currentColor;\n  white-space: nowrap;\n}\n\n.lightRoot .payArrow      { color: var(--text-muted-on-light); }\n.lightRoot .payCollected  { color: var(--success-on-light); }\n.lightRoot .payUnpaid     { color: var(--accent-strong); }\n.lightRoot .payReceivable { color: #a06a2a; }\n.lightRoot .payNoCharge   { color: var(--text-muted-on-light); }\n.lightRoot .payTip        { color: var(--text-muted-on-light); }\n.lightRoot .payVariance   { color: var(--danger); }\n\n/* ── Appointment drawer ───────────────────────────────────────────────────── */\n.drawerScrim {\n  position: fixed;\n  inset: 0;\n  background: var(--ace-scrim);\n  z-index: 60;\n}\n.drawer {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: min(452px, 100vw);\n  background: var(--surface);\n  border-left: none;\n  box-shadow: var(--ace-drawer-shadow);\n  z-index: 61;\n  overflow: auto;\n}\n.drawerHead {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 20px 22px;\n  background: var(--surface-card);\n  border-bottom: 1px solid var(--border);\n}\n.drawerEyebrow {\n  font-size: 9.5px;\n  letter-spacing: 0.15em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n.drawerTitle {\n  margin-top: 7px;\n  font-size: 20px;\n  font-weight: var(--fw-bold);\n  color: var(--text);\n}\n.drawerSub {\n  margin-top: 5px;\n  font-size: 13px;\n  color: var(--text-soft);\n  line-height: 1.45;\n}\n.drawerClose {\n  margin-left: auto;\n  flex: 0 0 auto;\n  width: 30px;\n  height: 30px;\n  display: grid;\n  place-items: center;\n  border: none;\n  border-radius: 8px;\n  background: none;\n  color: var(--text-muted);\n  box-shadow: inset 0 0 0 1px var(--border);\n  cursor: pointer;\n  font-size: var(--fs-15);\n  line-height: 1;\n}\n.drawerClose:hover { color: var(--text); box-shadow: inset 0 0 0 1px var(--border-strong); }\n.drawerBody {\n  padding: 18px 22px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 13px;\n}\n.drawerCard {\n  padding: 16px 18px;\n  border: none;\n  border-radius: 12px;\n  background: var(--surface-card);\n  box-shadow: inset 0 0 0 1px var(--border);\n}\n.drawerCardHead {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  margin-bottom: 11px;\n}\n.drawerCardLabel {\n  font-size: 9.5px;\n  letter-spacing: 0.15em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n.drawerCardValue {\n  margin-left: auto;\n  font-size: 17px;\n  font-weight: var(--fw-bold);\n  color: var(--text);\n}\n.drawerRow {\n  display: flex;\n  gap: 12px;\n  padding: 0;\n  font-size: 13px;\n}\n.drawerRowKey {\n  width: 112px;\n  flex: 0 0 112px;\n  color: var(--text-muted);\n}\n.drawerRowVal {\n  flex: 1;\n  color: var(--text);\n  text-align: left;\n}\n.drawerRowMuted { color: var(--text-dim); }\n\n/* Costs logged against the booking. Sits inside the Appointment card, under a\n   rule, so the money reads as one story: booked, collected, then what it cost. */\n.drawerCosts {\n  margin-top: 14px;\n  padding-top: 14px;\n  border-top: 1px solid var(--border);\n}\n.drawerCosts .drawerCardValue {\n  font-size: var(--fs-11);\n  font-weight: var(--fw-medium);\n  color: var(--text-muted);\n}\n.drawerCost { padding: 7px 0; }\n.drawerCostTop {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n}\n.drawerCostName {\n  font-size: var(--fs-13);\n  font-weight: var(--fw-semibold);\n  color: var(--text);\n  min-width: 0;\n}\n.drawerCostAmt {\n  font-size: var(--fs-13);\n  font-weight: var(--fw-semibold);\n  color: var(--text);\n  white-space: nowrap;\n}\n.drawerCostMeta {\n  margin-top: 3px;\n  font-size: var(--fs-11);\n  color: var(--text-muted);\n  line-height: 1.45;\n}\n.drawerCostTotals {\n  margin-top: 10px;\n  padding-top: 10px;\n  border-top: 1px solid var(--border);\n}\n.drawerNote {\n  margin-top: 9px;\n  font-size: var(--fs-13);\n  color: var(--text-soft);\n  line-height: 1.55;\n}\n.drawerActions { display: flex; flex-direction: column; gap: 9px; margin-top: 14px; }\n/* The manual-entry block sits a shade below the cards around it and carries\n   no ring, so the fields read as sunken into the drawer. */\n.drawerCardSunken { background: var(--surface-sunken); box-shadow: none; }\n.drawerPrimary {\n  padding: 12px;\n  border: none;\n  border-radius: 9px;\n  background: var(--ace-bronze-warm);\n  color: var(--ace-paper);\n  font-family: inherit;\n  font-size: 13px;\n  text-align: center;\n  cursor: pointer;\n}\n.drawerPrimary:hover { background: var(--ace-bronze-warm-deep); }\n.drawerSecondary {\n  padding: 12px;\n  border: none;\n  border-radius: 9px;\n  background: transparent;\n  color: var(--text);\n  box-shadow: inset 0 0 0 1px var(--border-strong);\n  font-family: inherit;\n  font-size: 13px;\n  text-align: center;\n  cursor: pointer;\n}\n.drawerSecondary:hover { box-shadow: inset 0 0 0 1px var(--border-strong); }\n\n.lightRoot .drawer          { background: var(--surface-light-background); }\n.lightRoot .drawerHead      { background: var(--surface-light-card); border-bottom-color: var(--ace-stroke-hair); }\n.lightRoot .drawerTitle     { color: var(--ace-ink); }\n.lightRoot .drawerSub       { color: var(--ace-body); }\n.lightRoot .drawerEyebrow,\n.lightRoot .drawerCardLabel,\n.lightRoot .drawerRowKey    { color: var(--ace-slate); }\n.lightRoot .drawerCard      { background: var(--surface-light-card); box-shadow: inset 0 0 0 1px var(--ace-stroke-hair); }\n.lightRoot .drawerCardValue,\n.lightRoot .drawerRowVal    { color: var(--ace-ink); }\n.lightRoot .drawerCosts,\n.lightRoot .drawerCostTotals { border-top-color: var(--ace-stroke-hair); }\n.lightRoot .drawerCostName,\n.lightRoot .drawerCostAmt    { color: var(--ace-ink); }\n.lightRoot .drawerCostMeta,\n.lightRoot .drawerCosts .drawerCardValue { color: var(--ace-slate); }\n.lightRoot .drawerRowMuted  { color: var(--text-dim-on-light); }\n.lightRoot .drawerNote      { color: var(--ace-body); }\n.lightRoot .drawerClose     { color: var(--ace-slate); box-shadow: inset 0 0 0 1px var(--ace-stroke-ring); }\n.lightRoot .drawerClose:hover { color: var(--ace-ink); box-shadow: inset 0 0 0 1px var(--ace-stroke-firm); }\n.lightRoot .drawerSecondary { color: var(--ace-ink); box-shadow: inset 0 0 0 1px var(--ace-stroke-firm); }\n.lightRoot .drawerSecondary:hover { box-shadow: inset 0 0 0 2px var(--ace-stroke-firm); }\n\n/* ── Set payment method modal ─────────────────────────────────────────────── */\n.payMethodList { display: flex; flex-direction: column; gap: 7px; margin-top: 12px; }\n.payMethodOption {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  width: 100%;\n  text-align: left;\n  padding: 12px 14px;\n  border: none;\n  border-radius: var(--radius-10);\n  background: var(--surface-high);\n  box-shadow: inset 0 0 0 1px var(--border);\n  cursor: pointer;\n}\n.payMethodOption:hover { background: #211d19; }\n.payMethodSelected {\n  background: var(--surface-card);\n  box-shadow: inset 0 0 0 2px var(--accent-strong);\n}\n.payMethodText { display: flex; flex-direction: column; gap: 3px; flex: 1; min-width: 0; }\n.payMethodTitle { font-size: var(--fs-14); font-weight: var(--fw-semibold); color: var(--text); }\n.payMethodDesc  { font-size: var(--fs-12-5); color: var(--text-muted); line-height: 1.4; }\n.payMethodBadge {\n  font-size: var(--fs-9);\n  font-weight: var(--fw-bold);\n  letter-spacing: 0.13em;\n  text-transform: uppercase;\n  white-space: nowrap;\n  margin-top: 2px;\n}\n.payMethodBadgeMuted { color: var(--text-muted); }\n.payMethodBadgeBlue  { color: var(--info); }\n.payMethodBadgeRed   { color: var(--danger-soft); }\n\n.payFieldRow { display: flex; gap: 12px; margin-bottom: 10px; }\n.payField { flex: 1; display: flex; flex-direction: column; gap: 6px; min-width: 0; }\n.payInput,\n.payTextarea {\n  width: 100%;\n  padding: 11px 13px;\n  border: var(--hairline);\n  border-radius: var(--radius-9);\n  background: var(--surface-sunken);\n  color: var(--text);\n  font-size: var(--fs-15);\n  font-weight: var(--fw-semibold);\n  font-family: inherit;\n  box-sizing: border-box;\n  color-scheme: dark;\n}\n.payTextarea { font-size: var(--fs-13); font-weight: var(--fw-regular); resize: vertical; margin-top: 8px; }\n.payInput:focus, .payTextarea:focus { outline: none; border-color: var(--accent-strong); }\n\n.lightRoot .payMethodOption { background: var(--surface-light-sunken); box-shadow: inset 0 0 0 1px var(--ace-stroke); }\n.lightRoot .payMethodOption:hover { background: #f0ebe4; }\n.lightRoot .payMethodSelected { background: var(--ace-paper); box-shadow: inset 0 0 0 2px var(--ace-bronze-warm); }\n.lightRoot .payMethodTitle  { color: var(--text-on-light); }\n.lightRoot .payMethodDesc   { color: var(--text-muted-on-light); }\n.lightRoot .payMethodBadgeMuted { color: var(--ace-slate); }\n.lightRoot .payMethodBadgeBlue  { color: var(--ace-ar); }\n.lightRoot .payMethodBadgeRed   { color: var(--ace-error); }\n.lightRoot .payInput,\n.lightRoot .payTextarea     { background: var(--surface-light-card); border-color: var(--ace-stroke-ring); color: var(--ace-ink); color-scheme: light;}\n.lightRoot .drawerCardSunken { background: var(--ace-band); box-shadow: none; }\n\n/* ── Staff sidebar: grouped by location, with each member's tip for the day ── */\n.staffGroup { margin-bottom: 14px; }\n.staffGroupHead {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: var(--fs-9);\n  font-weight: var(--fw-bold);\n  letter-spacing: 1.2px;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  margin: 0 0 7px 2px;\n}\n.staffGroupDot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n.staffTip {\n  margin-left: auto;\n  padding-left: 8px;\n  font-size: var(--fs-12);\n  font-weight: var(--fw-bold);\n  color: var(--success-soft);\n  white-space: nowrap;\n}\n.staffTipNone {\n  margin-left: auto;\n  padding-left: 8px;\n  font-size: var(--fs-12);\n  color: var(--text-faint);\n}\n\n.lightRoot .staffGroupHead { color: var(--text-muted-on-light); }\n.lightRoot .staffTip       { color: var(--success-on-light); }\n.lightRoot .staffTipNone   { color: var(--text-dim-on-light); }\n\n@media (max-width: 768px) {\n  .header {\n    justify-content: flex-start;\n    gap: 10px;\n    padding: 10px 14px;\n    overflow-x: auto;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;   /* momentum scrolling on iOS */\n    scrollbar-width: none;               /* Firefox */\n  }\n  .header::-webkit-scrollbar { display: none; }\n\n  /* Nothing may shrink, or the items squash to fit instead of scrolling. */\n  .logo,\n  .nav,\n  .headerRight {\n    flex-shrink: 0;\n  }\n\n  .headerRight { margin-left: auto; }\n\n  .navBtn {\n    white-space: nowrap;\n    padding: 7px 12px;\n  }\n\n  .logoImg { width: 34px; height: 34px; }\n}\n\n/* ── Stats bar tiles: the day's money ─────────────────────────────────────── */\n.statTile {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 8px 14px;\n  border: var(--hairline);\n  border-radius: var(--radius-8);\n  background: var(--surface-card);\n  flex-shrink: 0;\n}\n/* The mockup's own values: 9.5px at 0.16em on #6e6a66. */\n.statTileLabel {\n  font-size: 9.5px;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--ace-slate);\n  font-weight: var(--fw-bold);\n}\n/* Value and note on one line: the note qualifies the figure (\"4 cars,\n   excludes tax and tip\"), so it belongs beside it, not on a row of its own. */\n.statTileRow { margin-top: 4px; display: flex; align-items: baseline; gap: 7px; flex-wrap: wrap; }\n.statTileValue { font-size: 20px; font-weight: var(--fw-bold); color: var(--text); }\n.statTileNote { font-size: 11.5px; color: var(--ace-slate); white-space: nowrap; }\n\n/* StatsBar asks for these by name. They were never defined, so every figure\n   fell back to the default text colour and collected, due and tips all read\n   the same. */\n.green { color: var(--success); }\n.red   { color: var(--danger-soft); }\n.blue  { color: var(--info); }\n.lightRoot .green { color: var(--success-on-light); }\n.lightRoot .red   { color: var(--danger); }\n.lightRoot .blue  { color: var(--info-on-light); }\n\n.statsLocations { display: flex; gap: 6px; flex-shrink: 0; }\n.locChip {\n  padding: 5px 10px;\n  border: var(--hairline);\n  border-radius: var(--radius-6);\n  background: none;\n  color: var(--text-dim);\n  font-family: inherit;\n  font-size: var(--fs-9);\n  font-weight: var(--fw-bold);\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.locChip.active { background: rgba(255,255,255,0.04); }\n\n.lightRoot .statTile      { background: var(--surface-light-card); border-color: var(--border-light); }\n.lightRoot .statTileLabel,\n.lightRoot .statTileNote  { color: var(--text-muted-title); }\n.lightRoot .statTileValue { color: var(--text-on-light); }\n.lightRoot .locChip       { border-color: var(--border-light); color: var(--text-muted-on-light); }\n.lightRoot .locChip.active { background: var(--surface-light-raised); }\n\n/* Camera button: icon plus the number of photos already on the car. */\n.cameraCount { font-size: var(--fs-10); font-weight: var(--fw-bold); line-height: 1; }\n.checkStep:disabled { opacity: 0.4; cursor: default; }\n\n/* Subtotal / tax breakdown inside the payment drawer's manual section. */\n.payBreakdown {\n  margin-top: 12px;\n  padding-top: 10px;\n  border-top: 1px solid var(--border);\n}\n.payBreakdownRow {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 3px 0;\n  font-size: var(--fs-12);\n  color: var(--text-muted);\n}\n.payBreakdownTotal {\n  margin-top: 4px;\n  padding-top: 7px;\n  border-top: 1px solid var(--border);\n  font-weight: var(--fw-bold);\n  color: var(--text);\n}\n.payBreakdownFlag { color: var(--accent); }\n\n.lightRoot .payBreakdown,\n.lightRoot .payBreakdownTotal { border-top-color: var(--border-light); }\n.lightRoot .payBreakdownRow   { color: var(--text-muted-on-light); }\n.lightRoot .payBreakdownTotal { color: var(--text-on-light); }\n.lightRoot .payBreakdownFlag  { color: #a06a2a; }\n\n/* View-photos button: same shape as the camera, in the \"has content\" green. */\n.galleryBtn {\n  background: rgba(122,158,201,0.13);\n  border: 1px solid rgba(122,158,201,0.3);\n  color: var(--info);\n  border-radius: var(--radius-5);\n  padding: 3px 8px;\n  cursor: pointer;\n  font-size: var(--fs-13);\n  line-height: 1;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n.galleryBtn:hover { background: rgba(122,158,201,0.2); }\n\n.lightRoot .galleryBtn {\n  background: rgba(122,158,201,0.1);\n  border-color: rgba(122,158,201,0.35);\n  color: var(--info);\n}\n\n/* ── Log a cost modal ─────────────────────────────────────────────────────── */\n/* Dark by default like every other overlay; the light variant is the override,\n   not the other way round. A hardcoded light background here is what made the\n   shell cream while its contents stayed dark. */\n.costModal {\n  width: min(520px, 94vw);\n  max-height: 92vh;\n  overflow-y: auto;\n  margin: 0;\n  max-width: none;\n  position: relative;\n  padding: 0 0 18px;\n  border: var(--hairline);\n  border-radius: var(--radius-14);\n  background: var(--surface);\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45);\n  box-sizing: border-box;\n  scrollbar-width: none;            /* Firefox */\n  -ms-overflow-style: none;         /* old Edge */\n}\n.costModal::-webkit-scrollbar { display: none; }\n.costModal .drawerHead {\n  padding: 18px 20px 16px;\n  border-bottom: none;\n  /* Sits a shade apart from the body, and stays put while the form scrolls. */\n  background: var(--surface-high);\n  border-radius: 14px 14px 0 0;\n  position: sticky;\n  top: 0;\n  z-index: 2;\n}\n.costModal > *:not(.drawerHead) { margin-left: 20px; margin-right: 20px; }\n.costLine {\n  margin-bottom: 4px;\n  margin-top: 15px;\n}\n.costKindRow { display: flex; gap: 7px; margin: 8px 0 14px; }\n.costKind {\n  padding: 7px 14px;\n  border: var(--hairline);\n  border-radius: var(--radius-7);\n  background: none;\n  color: var(--text-muted);\n  font-family: inherit;\n  font-size: var(--fs-12);\n  cursor: pointer;\n}\n.costKindActive { border-color: var(--accent-strong); color: var(--accent); background: rgba(201,149,106,0.1); }\n\n.costSelect {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 9px 11px;\n  border: var(--hairline);\n  border-radius: var(--radius-7);\n  background: var(--surface-sunken);\n  color: var(--text);\n  font-family: inherit;\n  font-size: var(--fs-13);\n  cursor: pointer;\n}\n/* Expands in flow rather than overlaying: the modal scrolls, and an absolutely\n   positioned menu inside a scroll container gets clipped. */\n/* Floats on <body> via a portal, positioned from the trigger's rect, so the\n   modal's own `overflow-y: auto` cannot clip it. */\n.costMenu {\n  position: fixed;\n  z-index: 1300;\n  display: flex;\n  flex-direction: column;\n  border: var(--hairline);\n  border-radius: var(--radius-8);\n  background: var(--surface-raised);\n  overflow: hidden;\n  box-shadow: 0 18px 44px rgba(0,0,0,0.5);\n}\n.costMenuSearch {\n  flex: none;\n  width: 100%;\n  padding: 9px 12px;\n  border: none;\n  border-bottom: 1px solid var(--border);\n  background: var(--surface-sunken);\n  color: var(--text);\n  font-family: inherit;\n  font-size: var(--fs-12);\n  box-sizing: border-box;\n}\n.costMenuSearch:focus { outline: none; }\n/* Caps the roster so the form below stays reachable. */\n.costMenuList { flex: 1; min-height: 0; max-height: 210px; overflow-y: auto; }\n.costMenuGroup {\n  padding: 8px 12px 4px;\n  font-size: var(--fs-8);\n  letter-spacing: 1.2px;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n.costMenuEmpty { padding: 12px; font-size: var(--fs-12); color: var(--text-muted); }\n.costSelect:focus,\n.costSelect:focus-visible {\n  outline: none;\n  border-color: var(--accent-strong);\n}\n.payInput:focus,\n.payTextarea:focus { outline: none; border-color: var(--accent-strong); }\n\n.costMenuItem {\n  display: block;\n  width: 100%;\n  text-align: left;\n  padding: 9px 12px;\n  border: none;\n  background: none;\n  color: var(--text-soft);\n  font-family: inherit;\n  font-size: var(--fs-13);\n  cursor: pointer;\n}\n.costMenuItem:hover { background: rgba(255,255,255,0.05); }\n.costMenuAdd { flex: none; color: var(--accent); border-top: 1px solid var(--border); }\n\n.costAddLine {\n  width: 100%;\n  padding: 11px;\n  border: 1px dashed var(--border);\n  border-radius: var(--radius-8);\n  background: none;\n  color: var(--text-muted);\n  font-family: inherit;\n  font-size: var(--fs-12);\n  cursor: pointer;\n  margin-bottom: 14px;\n}\n.costAddLine:hover { color: var(--text); border-color: var(--border-strong); }\n.costFooter {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin: 14px;\n  padding-top: 14px;\n  border-top: 1px dashed var(--border);\n}\n\n.lightRoot .costModal .drawerHead { background: var(--surface-light-alt); }\n.lightRoot .costModal {\n  background: var(--surface-light-background);\n  border-color: var(--border-light);\n  box-shadow: 0 24px 60px rgba(120, 100, 80, 0.12);\n}\n.lightRoot .costKind     { border-color: var(--border-light); color: var(--text-muted-on-light); }\n.lightRoot .costSelect   { background: var(--surface-light); border-color: var(--border-light); color: var(--text-on-light); }\n.lightRoot .costMenu     { background: var(--surface-light); border-color: var(--border-light); box-shadow: 0 18px 44px rgba(0,0,0,0.18); }\n.lightRoot .costMenuItem { color: var(--text-on-light); }\n.lightRoot .costMenuSearch { background: var(--surface-light-alt); border-bottom-color: var(--border-light); color: var(--text-on-light); }\n.lightRoot .costMenuGroup,\n.lightRoot .costMenuEmpty  { color: var(--text-muted-on-light); }\n.lightRoot .costAddLine  { border-color: var(--border-light); color: var(--text-muted-on-light); }\n.lightRoot .costFooter   { border-top-color: var(--border-light); }\n\n/* Log-a-cost trigger on the card, alongside the camera and gallery. */\n.noteBtn {\n  background: rgba(138,127,116,0.12);\n  border: 1px solid rgba(138,127,116,0.3);\n  color: #a89c8e;\n  border-radius: var(--radius-5);\n  padding: 4px 8px;\n  cursor: pointer;\n  font-size: var(--fs-13);\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n.noteBtn:hover { color: var(--text); border-color: var(--border-strong); }\n.lightRoot .noteBtn { border-color: var(--border-light); color: var(--text-muted-on-light); }\n\n/* Invoice capture inside a cost line. */\n.costInvoice {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 8px;\n  padding: 13px 14px;\n  border: var(--hairline);\n  border-radius: var(--radius-9);\n  background: var(--surface-raised);\n  cursor: pointer;\n}\n.costInvoice:hover { border-color: var(--border-strong); }\n.costInvoiceIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: var(--radius-8);\n  background: rgba(201,149,106,0.12);\n  color: var(--accent);\n  flex-shrink: 0;\n}\n.costInvoiceTitle { display: block; font-size: var(--fs-13); font-weight: var(--fw-semibold); color: var(--text); }\n.costInvoiceSub   { display: block; font-size: var(--fs-11); color: var(--text-muted); margin-top: 2px; }\n.costChevron { opacity: 0.55; flex-shrink: 0; }\n\n.lightRoot .costInvoice      { background: var(--surface-light-raised); border-color: var(--border-light); }\n.lightRoot .costInvoiceTitle { color: var(--text-on-light); }\n.lightRoot .costInvoiceSub   { color: var(--text-muted-on-light); }\n\n/* The chips' own row. `chipRow` exists in staff.module.css, but a CSS Module\n   class cannot be reached from another module's file, so this drawer needs its\n   own. */\n.reasonChips { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 11px; }\n\n/* A reason chip on the fix-a-clock-time form. Picking one again clears it:\n   the reason is optional, so there has to be a way back out of a wrong tap. */\n.reasonChip {\n  padding: 7px 12px; border: none; border-radius: 999px;\n  background: var(--surface-high); color: var(--text-muted);\n  box-shadow: inset 0 0 0 1px var(--border);\n  font-family: inherit; font-size: var(--fs-12-5); cursor: pointer;\n}\n.reasonChipOn {\n  background: color-mix(in srgb, var(--ace-bronze-warm) 16%, transparent);\n  color: var(--ace-bronze-warm);\n  box-shadow: inset 0 0 0 1px var(--ace-bronze-warm);\n}\n.lightRoot .reasonChip { background: var(--surface-light-sunken); color: var(--ace-slate); box-shadow: inset 0 0 0 1px var(--ace-stroke); }\n.lightRoot .reasonChipOn { background: color-mix(in srgb, var(--ace-bronze-warm) 14%, transparent); color: var(--ace-bronze-warm); box-shadow: inset 0 0 0 1px var(--ace-bronze-warm); }\n\n/* ── Header: the 1600px column, and the mobile sheet ─────────────────────── */\n\n/* The bar still spans the window — it carries the background and the rule —\n   but its contents sit in the same 1600px column as the page beneath it.\n   Padding rather than an inner wrapper, so no markup has to change. */\n.header { padding-inline: max(26px, calc((100% - var(--page-max)) / 2)); }\n/* On the queue the bar's contents run the full width too, so the nav lines up\n   with the board under it rather than floating inside a narrower column.\n   Before the media queries below, which set `padding` outright and still win. */\n.headerWide { padding-inline: 26px; }\n\n.burger {\n  display: none;\n  width: 34px; height: 34px; flex: 0 0 auto;\n  place-items: center;\n  border: none; border-radius: 9px; background: none;\n  color: var(--text-soft); box-shadow: inset 0 0 0 1px var(--border);\n  cursor: pointer;\n}\n\n/* The bar sheds things in two steps, as the mockup does.\n   At 1180 the nav itself no longer fits beside the pill and the controls, so\n   it becomes the burger and the sheet. At 860 even the pill and the clock go,\n   leaving the logo, the burger and the two switches. */\n@media (max-width: 1180px) {\n  .header { gap: 14px; padding: 13px 18px; }\n  .burger { display: grid; }\n  .nav { display: none !important; }\n  .headerClockGroup { display: none; }\n  .navPill { padding: 10px 12px; }\n  .hdrClock { padding: 9px 12px; }\n}\n\n@media (max-width: 860px) {\n  .header { gap: 12px; padding: 12px 16px; }\n  .navPill { display: none !important; }\n  /* The clock lives in the sheet and on the shifts page at this width; two\n     of them in a 360px bar is one too many. */\n  .hdrClock { display: none !important; }\n  .headerRight { margin-left: auto; gap: 10px; }\n  .themeSwitchBtn { display: none; }\n  .logoImg { width: 27px; height: 27px; }\n}\n\n.navSheet {\n  position: fixed;\n  top: 0; right: 0; bottom: 0; left: 0;\n  width: 100%; max-width: 100%;\n  z-index: 90;\n  background: var(--surface-sunken);\n  overflow-x: hidden; overflow-y: auto;\n  overscroll-behavior: contain;\n}\n.navSheetHead {\n  display: flex; align-items: center; gap: 14px;\n  padding: 15px 18px; border-bottom: 1px solid var(--border);\n}\n.navSheetClose {\n  margin-left: auto; width: 34px; height: 34px; flex: 0 0 auto;\n  display: grid; place-items: center;\n  border: none; border-radius: 9px; background: none;\n  color: var(--text-soft); box-shadow: inset 0 0 0 1px var(--border); cursor: pointer;\n}\n.navSheetBody {\n  padding: 14px 14px 30px;\n  display: flex; flex-direction: column; gap: 20px;\n}\n.navSheetGroup {\n  padding: 0 8px 8px;\n  font-family: 'DM Sans', sans-serif; font-size: var(--fs-10-5);\n  letter-spacing: 0.16em; text-transform: uppercase; color: var(--text-dim);\n}\n.navSheetItems { display: flex; flex-direction: column; gap: 6px; min-width: 0; }\n.navSheetItem {\n  display: flex; align-items: center; gap: 10px;\n  padding: 14px 15px; border-radius: 11px;\n  background: var(--surface-card); color: var(--text-soft);\n  box-shadow: inset 0 0 0 1px var(--border);\n  font-size: var(--fs-16); text-decoration: none;\n  min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\n}\n.navSheetItemOn {\n  background: color-mix(in srgb, var(--ace-bronze-warm) 16%, transparent);\n  color: var(--ace-champagne);\n  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--ace-bronze-warm) 30%, transparent);\n}\n.navSheetBadge {\n  margin-left: auto; font-family: 'DM Sans', sans-serif;\n  font-size: var(--fs-12-5); color: var(--danger-soft);\n}\n.navSheetFoot {\n  padding-top: 16px; margin-top: 4px;\n  border-top: 1px dotted var(--border);\n  display: flex; align-items: center; gap: 12px;\n}\n\n.headerLight .burger,\n.headerLight .navSheetClose { box-shadow: inset 0 0 0 1px var(--ace-stroke-ring); color: var(--ace-slate); }\n/* The sheet carries `.headerLight` itself now that it is portalled, so this\n   has to match the element as well as a descendant of it. Its children still\n   match the descendant form. */\n.headerLight.navSheet,\n.headerLight .navSheet { background: var(--surface-light-background); }\n.headerLight .navSheetHead,\n.headerLight .navSheetFoot { border-color: var(--ace-stroke-hair); }\n.headerLight .navSheetGroup { color: var(--ace-slate); }\n.headerLight .navSheetItem { background: var(--surface-light-card); color: var(--ace-body); box-shadow: inset 0 0 0 1px var(--ace-stroke-hair); }\n.headerLight .navSheetItemOn { background: var(--ace-tab-active); color: var(--ace-tab-ink); box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--ace-tab-ink) 30%, transparent); }\n.headerLight .navSheetBadge { color: var(--ace-error); }\n\n/* The clock as a floating button, for the widths where the bar has dropped it.\n   Hidden by default and shown only there, so it never doubles up with the one\n   in the header. */\n.clockFab {\n  display: none;\n  position: fixed; right: 16px; bottom: 18px; z-index: 70;\n  align-items: center; gap: 12px;\n  padding: 12px 22px 12px 18px; min-height: 58px; box-sizing: border-box;\n  border: none; border-radius: 999px;\n  background: var(--ace-bronze-warm); color: var(--ace-paper);\n  box-shadow: 0 18px 36px -14px rgba(20, 15, 10, 0.5);\n  font-family: inherit; text-align: left; cursor: pointer; user-select: none;\n}\n/* On shift it goes dark and green, so it reads as a status you can end rather\n   than an action waiting to be taken. */\n.clockFabOn { background: var(--ace-ink); color: var(--ace-bone); }\n.clockFabDot {\n  width: 10px; height: 10px; flex: 0 0 auto;\n  border-radius: 50%; background: var(--ace-paper);\n}\n.clockFabOn .clockFabDot { background: var(--ace-on-shift); }\n.clockFabText { display: flex; flex-direction: column; line-height: 1.25; min-width: 0; }\n.clockFabLabel { font-size: var(--fs-16); }\n.clockFabSub { font-size: var(--fs-12-5); opacity: 0.85; white-space: nowrap; }\n.clockFab:disabled { opacity: 0.7; cursor: default; }\n\n@media (max-width: 860px) {\n  .clockFab { display: flex; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `dashboard_root__7n11a`,
	"header": `dashboard_header__tJi3p`,
	"logo": `dashboard_logo__FiQHq`,
	"logoImg": `dashboard_logoImg__hY6SQ`,
	"nav": `dashboard_nav__NPHeG`,
	"navBtn": `dashboard_navBtn__8s-Hs`,
	"active": `dashboard_active__vzNoh`,
	"themeIconBtn": `dashboard_themeIconBtn__CuYtN`,
	"taxToggle": `dashboard_taxToggle__gbyYB`,
	"taxOpt": `dashboard_taxOpt__n41Wx`,
	"taxOptActive": `dashboard_taxOptActive__aBGJN`,
	"navPill": `dashboard_navPill__b6N0D`,
	"navPillAlert": `dashboard_navPillAlert__RP-3G`,
	"navPillClear": `dashboard_navPillClear__4gJY7`,
	"navPillActive": `dashboard_navPillActive__pjcK-`,
	"hdrClock": `dashboard_hdrClock__mvPlV`,
	"hdrClockOn": `dashboard_hdrClockOn__9pR1d`,
	"hdrClockDot": `dashboard_hdrClockDot__6PGGM`,
	"navPillDot": `dashboard_navPillDot__eWB1v`,
	"navGroup": `dashboard_navGroup__sM3+P`,
	"navCaret": `dashboard_navCaret__00Jwi`,
	"navMenu": `dashboard_navMenu__vEjGy`,
	"navMenuItem": `dashboard_navMenuItem__3ggHt`,
	"navMenuItemDisabled": `dashboard_navMenuItemDisabled__jA9tp`,
	"navMenuItemActive": `dashboard_navMenuItemActive__6aVTA`,
	"clock": `dashboard_clock__ekbmx`,
	"statsBar": `dashboard_statsBar__HpGzu`,
	"statPill": `dashboard_statPill__FgM1Z`,
	"localPill": `dashboard_localPill__YzA0l`,
	"noLocations": `dashboard_noLocations__64fM2`,
	"statLabel": `dashboard_statLabel__VIF4h`,
	"statValue": `dashboard_statValue__fLcAt`,
	"white": `dashboard_white__O4hUb`,
	"green": `dashboard_green__gcZzk`,
	"liveTag": `dashboard_liveTag__cyCch`,
	"body": `dashboard_body__BGH0z`,
	"main": `dashboard_main__vd7bF`,
	"sidebar": `dashboard_sidebar__PJFLv`,
	"sectionLabel": `dashboard_sectionLabel__GOGrU`,
	"sidebarDivider": `dashboard_sidebarDivider__Ortfl`,
	"filterBar": `dashboard_filterBar__5eSUy`,
	"filterBtn": `dashboard_filterBtn__1NQCe`,
	"apptCard": `dashboard_apptCard__McZhz`,
	"done": `dashboard_done__BAtuD`,
	"urgent": `dashboard_urgent__-zq6I`,
	"high": `dashboard_high__bxk+i`,
	"medium": `dashboard_medium__bLM8L`,
	"apptHeader": `dashboard_apptHeader__vAjmu`,
	"apptTime": `dashboard_apptTime__haZ81`,
	"apptDue": `dashboard_apptDue__atI4f`,
	"urgentText": `dashboard_urgentText__C2t-b`,
	"priorityBadge": `dashboard_priorityBadge__1VLWz`,
	"apptInfo": `dashboard_apptInfo__1kcBv`,
	"apptCar": `dashboard_apptCar__yqv9e`,
	"crossed": `dashboard_crossed__YFmFd`,
	"apptService": `dashboard_apptService__a6HSE`,
	"apptDetailer": `dashboard_apptDetailer__3Nnev`,
	"apptBay": `dashboard_apptBay__kVq1y`,
	"controllerRow": `dashboard_controllerRow__D7Ckf`,
	"nextStepBtn": `dashboard_nextStepBtn__5WnLX`,
	"checklistRow": `dashboard_checklistRow__YwBKJ`,
	"checkStep": `dashboard_checkStep__ZDqjB`,
	"checkDot": `dashboard_checkDot__c1Kqw`,
	"staffItem": `dashboard_staffItem__UBsUt`,
	"staffAvatar": `dashboard_staffAvatar__dqnL3`,
	"staffName": `dashboard_staffName__LhBYt`,
	"staffStatus": `dashboard_staffStatus__vDuwL`,
	"available": `dashboard_available__LJp+Y`,
	"busy": `dashboard_busy__BwOQv`,
	"break": `dashboard_break__NSqYU`,
	"staffDot": `dashboard_staffDot__GTuem`,
	"bayGrid": `dashboard_bayGrid__WkAwz`,
	"bayCell": `dashboard_bayCell__0pWgC`,
	"bayNum": `dashboard_bayNum__z1+Ij`,
	"bayLabel": `dashboard_bayLabel__4qevV`,
	"rankItem": `dashboard_rankItem__P9gU9`,
	"rankNum": `dashboard_rankNum__UdyOd`,
	"gold": `dashboard_gold__JsivS`,
	"rankName": `dashboard_rankName__0MxB+`,
	"rankPts": `dashboard_rankPts__5VshC`,
	"analyticsGrid": `dashboard_analyticsGrid__6VukR`,
	"analyticsCard": `dashboard_analyticsCard__aJZaH`,
	"aLabel": `dashboard_aLabel__777jO`,
	"aValue": `dashboard_aValue__Dz+tc`,
	"aSub": `dashboard_aSub__wHg9t`,
	"amber": `dashboard_amber__iuMjC`,
	"effBarWrap": `dashboard_effBarWrap__A0hOP`,
	"effLabel": `dashboard_effLabel__krjGs`,
	"effBarBg": `dashboard_effBarBg__OMCBa`,
	"effBarFill": `dashboard_effBarFill__IwLuI`,
	"rankItemFull": `dashboard_rankItemFull__gbkiY`,
	"rankDelta": `dashboard_rankDelta__u878A`,
	"positive": `dashboard_positive__Q-Qkl`,
	"negative": `dashboard_negative__85QmB`,
	"qrOverlay": `dashboard_qrOverlay__alteC`,
	"qrPanel": `dashboard_qrPanel__wAWbW`,
	"qrEyebrow": `dashboard_qrEyebrow__cPt9-`,
	"qrCarName": `dashboard_qrCarName__KFNVc`,
	"qrServiceName": `dashboard_qrServiceName__rmPVZ`,
	"qrCodeWrap": `dashboard_qrCodeWrap__7hAE5`,
	"qrHint": `dashboard_qrHint__S28iP`,
	"qrUrlBox": `dashboard_qrUrlBox__B9PjK`,
	"qrCloseBtn": `dashboard_qrCloseBtn__Hh5K2`,
	"photoStripWrap": `dashboard_photoStripWrap__rONuW`,
	"photoStripLabel": `dashboard_photoStripLabel__kFMTx`,
	"photoStripRow": `dashboard_photoStripRow__XbQ8t`,
	"photoThumb": `dashboard_photoThumb__ZcVqh`,
	"photoThumbBefore": `dashboard_photoThumbBefore__4sDH7`,
	"photoThumbAfter": `dashboard_photoThumbAfter__E5DK-`,
	"urgentBanner": `dashboard_urgentBanner__yQRJW`,
	"urgentLabel": `dashboard_urgentLabel__HhCW3`,
	"urgentChangeBtn": `dashboard_urgentChangeBtn__YZFwz`,
	"cardAmountTag": `dashboard_cardAmountTag__Ued0H`,
	"cameraBtn": `dashboard_cameraBtn__roaIi`,
	"cameraBtnDone": `dashboard_cameraBtnDone__Zf96B`,
	"cameraBtnError": `dashboard_cameraBtnError__JMcV4`,
	"carouselOverlay": `dashboard_carouselOverlay__9423d`,
	"carouselPanel": `dashboard_carouselPanel__LzWbi`,
	"carouselHeader": `dashboard_carouselHeader__uNdbg`,
	"carouselCar": `dashboard_carouselCar__vtz+E`,
	"carouselService": `dashboard_carouselService__hs4Sy`,
	"carouselClose": `dashboard_carouselClose__DJEh1`,
	"carouselImgWrap": `dashboard_carouselImgWrap__8WI+n`,
	"carouselImg": `dashboard_carouselImg__i97QJ`,
	"carouselArrow": `dashboard_carouselArrow__PHaH5`,
	"carouselArrowLeft": `dashboard_carouselArrowLeft__t4nXQ`,
	"carouselArrowRight": `dashboard_carouselArrowRight__DOUYZ`,
	"carouselMeta": `dashboard_carouselMeta__J7LEX`,
	"carouselPhase": `dashboard_carouselPhase__eSqrg`,
	"carouselCount": `dashboard_carouselCount__KVJE4`,
	"carouselDots": `dashboard_carouselDots__hLZFy`,
	"carouselDot": `dashboard_carouselDot__5YYo7`,
	"carouselDotActive": `dashboard_carouselDotActive__QIvOn`,
	"carouselLoading": `dashboard_carouselLoading__z-lgF`,
	"serviceList": `dashboard_serviceList__2Ailh`,
	"serviceRow": `dashboard_serviceRow__9iDUP`,
	"serviceBullet": `dashboard_serviceBullet__kLemu`,
	"serviceText": `dashboard_serviceText__YnkRZ`,
	"serviceTextDone": `dashboard_serviceTextDone__IUfHy`,
	"assignedRow": `dashboard_assignedRow__z-gHK`,
	"assignedLabel": `dashboard_assignedLabel__GJYO0`,
	"assignedHint": `dashboard_assignedHint__dTMD3`,
	"dropTarget": `dashboard_dropTarget__7Lq8r`,
	"notesBox": `dashboard_notesBox__ZcddT`,
	"notesLabel": `dashboard_notesLabel__XmdSB`,
	"notesText": `dashboard_notesText__NDeH+`,
	"bookedInfo": `dashboard_bookedInfo__ckG30`,
	"bookedInfoUrgent": `dashboard_bookedInfoUrgent__p4SUz`,
	"bookedBox": `dashboard_bookedBox__M655a`,
	"bookedBoxLabel": `dashboard_bookedBoxLabel__JxyNs`,
	"bookedBoxAmount": `dashboard_bookedBoxAmount__Gdv+Z`,
	"locationCol": `dashboard_locationCol__v72Xn`,
	"locationHeader": `dashboard_locationHeader__AJwkK`,
	"locationName": `dashboard_locationName__vv67p`,
	"locationMeta": `dashboard_locationMeta__Mx07W`,
	"locationUrgentCount": `dashboard_locationUrgentCount__9u8OS`,
	"locationCount": `dashboard_locationCount__-vHeC`,
	"locationBody": `dashboard_locationBody__zHAjO`,
	"locationLoading": `dashboard_locationLoading__hj5dL`,
	"locationError": `dashboard_locationError__k4ypv`,
	"locationEmpty": `dashboard_locationEmpty__YD+CT`,
	"staffCard": `dashboard_staffCard__QfSbr`,
	"staffDragHandle": `dashboard_staffDragHandle__OC04h`,
	"staffInitialBubble": `dashboard_staffInitialBubble__0Dast`,
	"staffInfo": `dashboard_staffInfo__szU0J`,
	"staffNameText": `dashboard_staffNameText__Eel1M`,
	"staffStatusBtn": `dashboard_staffStatusBtn__KIXGu`,
	"staffStatusDot": `dashboard_staffStatusDot__t3+jx`,
	"staffStatusText": `dashboard_staffStatusText__CPRoq`,
	"sidebarPanel": `dashboard_sidebarPanel__T7jLN`,
	"sidebarTopSection": `dashboard_sidebarTopSection__UUaPQ`,
	"sidebarHint": `dashboard_sidebarHint__f1eGc`,
	"sidebarStaffList": `dashboard_sidebarStaffList__GpQvb`,
	"sidebarHeaderRow": `dashboard_sidebarHeaderRow__pPpOy`,
	"sidebarToggle": `dashboard_sidebarToggle__3j-PG`,
	"sidebarPanelMin": `dashboard_sidebarPanelMin__EHYrd`,
	"lightRoot": `dashboard_lightRoot__FPAQ0`,
	"sidebarBottomSection": `dashboard_sidebarBottomSection__WRA87`,
	"headerRight": `dashboard_headerRight__nzRg8`,
	"headerClockGroup": `dashboard_headerClockGroup__c6bbU`,
	"headerLiveLabel": `dashboard_headerLiveLabel__9mSlr`,
	"headerSyncLabel": `dashboard_headerSyncLabel__EJtL0`,
	"themeSwitchBtn": `dashboard_themeSwitchBtn__NzppN`,
	"headerLight": `dashboard_headerLight__EZg+4`,
	"navMenuLight": `dashboard_navMenuLight__orTLd`,
	"statsBarDivider": `dashboard_statsBarDivider__5Edvw`,
	"dateNavBtn": `dashboard_dateNavBtn__a+qPH`,
	"dateNavDisplay": `dashboard_dateNavDisplay__Nyie-`,
	"dateNavDisplayToday": `dashboard_dateNavDisplayToday__ezi+1`,
	"dateNavDisplayOther": `dashboard_dateNavDisplayOther__-SRgU`,
	"dateNavHiddenInput": `dashboard_dateNavHiddenInput__VbJdc`,
	"dateNavTodayBtn": `dashboard_dateNavTodayBtn__9FsMV`,
	"uploadPickerOverlay": `dashboard_uploadPickerOverlay__KS7qw`,
	"uploadPickerPanel": `dashboard_uploadPickerPanel__CVGGP`,
	"uploadPickerItem": `dashboard_uploadPickerItem__fPadF`,
	"uploadPickerCancel": `dashboard_uploadPickerCancel__1Y820`,
	"mainContent": `dashboard_mainContent__Ckbpb`,
	"locationsGrid": `dashboard_locationsGrid__gYvxk`,
	"nextStepPanel": `dashboard_nextStepPanel__oPwsA`,
	"nextStepEyebrow": `dashboard_nextStepEyebrow__41YqY`,
	"nextStepCar": `dashboard_nextStepCar__T9cbx`,
	"nextStepPrompt": `dashboard_nextStepPrompt__gGGEj`,
	"nextStepTextarea": `dashboard_nextStepTextarea__vD2Q0`,
	"nextStepPhotoHead": `dashboard_nextStepPhotoHead__1SXpw`,
	"nextStepPhotoLabel": `dashboard_nextStepPhotoLabel__JqyAW`,
	"nextStepPhotoOk": `dashboard_nextStepPhotoOk__LkMXL`,
	"nextStepPhotoNeed": `dashboard_nextStepPhotoNeed__BaPfZ`,
	"nextStepThumbs": `dashboard_nextStepThumbs__B9aWN`,
	"nextStepThumbWrap": `dashboard_nextStepThumbWrap__P+YGH`,
	"nextStepThumb": `dashboard_nextStepThumb__0mMY8`,
	"nextStepThumbX": `dashboard_nextStepThumbX__0lJsZ`,
	"nextStepAddPhoto": `dashboard_nextStepAddPhoto__zguQ3`,
	"nextStepError": `dashboard_nextStepError__XujqA`,
	"nextStepActions": `dashboard_nextStepActions__zr275`,
	"nextStepCancel": `dashboard_nextStepCancel__8nxIN`,
	"nextStepConfirm": `dashboard_nextStepConfirm__aazNX`,
	"nextStepHint": `dashboard_nextStepHint__Hp08K`,
	"payRow": `dashboard_payRow__RxLXi`,
	"payCol": `dashboard_payCol__F7CI8`,
	"payArrow": `dashboard_payArrow__09be-`,
	"payCollected": `dashboard_payCollected__q9+TE`,
	"payUnpaid": `dashboard_payUnpaid__Bp7ON`,
	"payReceivable": `dashboard_payReceivable__upMOM`,
	"payNoCharge": `dashboard_payNoCharge__bSmZK`,
	"payAction": `dashboard_payAction__C7yh0`,
	"payTip": `dashboard_payTip__wrQeX`,
	"payVariance": `dashboard_payVariance__8z7We`,
	"payBadge": `dashboard_payBadge__CbGul`,
	"drawerScrim": `dashboard_drawerScrim__BBfpI`,
	"drawer": `dashboard_drawer__UR5GR`,
	"drawerHead": `dashboard_drawerHead__TPMqm`,
	"drawerEyebrow": `dashboard_drawerEyebrow__2FVKa`,
	"drawerTitle": `dashboard_drawerTitle__6wzgf`,
	"drawerSub": `dashboard_drawerSub__9M2Rj`,
	"drawerClose": `dashboard_drawerClose__Dk15n`,
	"drawerBody": `dashboard_drawerBody__8bgSm`,
	"drawerCard": `dashboard_drawerCard__mVhHE`,
	"drawerCardHead": `dashboard_drawerCardHead__EWzcf`,
	"drawerCardLabel": `dashboard_drawerCardLabel__iQv64`,
	"drawerCardValue": `dashboard_drawerCardValue__qvHka`,
	"drawerRow": `dashboard_drawerRow__QvO+z`,
	"drawerRowKey": `dashboard_drawerRowKey__s4Rlg`,
	"drawerRowVal": `dashboard_drawerRowVal__cLlVk`,
	"drawerRowMuted": `dashboard_drawerRowMuted__P5GLj`,
	"drawerCosts": `dashboard_drawerCosts__DX6HL`,
	"drawerCost": `dashboard_drawerCost__fK5qx`,
	"drawerCostTop": `dashboard_drawerCostTop__AoHcA`,
	"drawerCostName": `dashboard_drawerCostName__IBa4F`,
	"drawerCostAmt": `dashboard_drawerCostAmt__7r0Vk`,
	"drawerCostMeta": `dashboard_drawerCostMeta__A9JSG`,
	"drawerCostTotals": `dashboard_drawerCostTotals__owk1D`,
	"drawerNote": `dashboard_drawerNote__G7FP5`,
	"drawerActions": `dashboard_drawerActions__5Ev3h`,
	"drawerCardSunken": `dashboard_drawerCardSunken__zn2YY`,
	"drawerPrimary": `dashboard_drawerPrimary__D+ujT`,
	"drawerSecondary": `dashboard_drawerSecondary__u5LIT`,
	"payMethodList": `dashboard_payMethodList__k-tQU`,
	"payMethodOption": `dashboard_payMethodOption__lZQ55`,
	"payMethodSelected": `dashboard_payMethodSelected__Vh6iT`,
	"payMethodText": `dashboard_payMethodText__TC4TD`,
	"payMethodTitle": `dashboard_payMethodTitle__BNG0Q`,
	"payMethodDesc": `dashboard_payMethodDesc__QFSxc`,
	"payMethodBadge": `dashboard_payMethodBadge__4CaCh`,
	"payMethodBadgeMuted": `dashboard_payMethodBadgeMuted__dhYBX`,
	"payMethodBadgeBlue": `dashboard_payMethodBadgeBlue__5T1SN`,
	"payMethodBadgeRed": `dashboard_payMethodBadgeRed__YNnkk`,
	"payFieldRow": `dashboard_payFieldRow__g0PCx`,
	"payField": `dashboard_payField__mceOv`,
	"payInput": `dashboard_payInput__pz6vv`,
	"payTextarea": `dashboard_payTextarea__FdHtp`,
	"staffGroup": `dashboard_staffGroup__bFD9G`,
	"staffGroupHead": `dashboard_staffGroupHead__N1vxH`,
	"staffGroupDot": `dashboard_staffGroupDot__7OngQ`,
	"staffTip": `dashboard_staffTip__86ZO4`,
	"staffTipNone": `dashboard_staffTipNone__oGckm`,
	"statTile": `dashboard_statTile__WjZ2O`,
	"statTileLabel": `dashboard_statTileLabel__oFwTW`,
	"statTileRow": `dashboard_statTileRow__mz1Zc`,
	"statTileValue": `dashboard_statTileValue__UOmMG`,
	"statTileNote": `dashboard_statTileNote__VTX7l`,
	"red": `dashboard_red__beEzo`,
	"blue": `dashboard_blue__IMdwc`,
	"statsLocations": `dashboard_statsLocations__qPfLH`,
	"locChip": `dashboard_locChip__-BFZo`,
	"cameraCount": `dashboard_cameraCount__29aiS`,
	"payBreakdown": `dashboard_payBreakdown__sf4Z6`,
	"payBreakdownRow": `dashboard_payBreakdownRow__+WA2y`,
	"payBreakdownTotal": `dashboard_payBreakdownTotal__zLXr9`,
	"payBreakdownFlag": `dashboard_payBreakdownFlag__UYABI`,
	"galleryBtn": `dashboard_galleryBtn__OAtz2`,
	"costModal": `dashboard_costModal__uuBg3`,
	"costLine": `dashboard_costLine__QX4aQ`,
	"costKindRow": `dashboard_costKindRow__Now+O`,
	"costKind": `dashboard_costKind__Wi3QD`,
	"costKindActive": `dashboard_costKindActive__teKLP`,
	"costSelect": `dashboard_costSelect__58j-z`,
	"costMenu": `dashboard_costMenu__-QZuC`,
	"costMenuSearch": `dashboard_costMenuSearch__CLJea`,
	"costMenuList": `dashboard_costMenuList__AIAwo`,
	"costMenuGroup": `dashboard_costMenuGroup__c+FD1`,
	"costMenuEmpty": `dashboard_costMenuEmpty__u0edH`,
	"costMenuItem": `dashboard_costMenuItem__EVLqP`,
	"costMenuAdd": `dashboard_costMenuAdd__wH1lg`,
	"costAddLine": `dashboard_costAddLine__Fs22B`,
	"costFooter": `dashboard_costFooter__1j1SN`,
	"noteBtn": `dashboard_noteBtn__3FTp0`,
	"costInvoice": `dashboard_costInvoice__NEAoT`,
	"costInvoiceIcon": `dashboard_costInvoiceIcon__3KAPB`,
	"costInvoiceTitle": `dashboard_costInvoiceTitle__Sp0Yl`,
	"costInvoiceSub": `dashboard_costInvoiceSub__pWxU+`,
	"costChevron": `dashboard_costChevron__zIqPX`,
	"reasonChips": `dashboard_reasonChips__WMjHy`,
	"reasonChip": `dashboard_reasonChip__6hp75`,
	"reasonChipOn": `dashboard_reasonChipOn__mkm9U`,
	"headerWide": `dashboard_headerWide__VCuUO`,
	"burger": `dashboard_burger__QZkof`,
	"navSheet": `dashboard_navSheet__3VL-m`,
	"navSheetHead": `dashboard_navSheetHead__tEXxp`,
	"navSheetClose": `dashboard_navSheetClose__TElXw`,
	"navSheetBody": `dashboard_navSheetBody__J4Rtk`,
	"navSheetGroup": `dashboard_navSheetGroup__6-RT8`,
	"navSheetItems": `dashboard_navSheetItems__cMwyq`,
	"navSheetItem": `dashboard_navSheetItem__FjSRv`,
	"navSheetItemOn": `dashboard_navSheetItemOn__j4XNZ`,
	"navSheetBadge": `dashboard_navSheetBadge__M018Y`,
	"navSheetFoot": `dashboard_navSheetFoot__lHu2p`,
	"clockFab": `dashboard_clockFab__DidoN`,
	"clockFabOn": `dashboard_clockFabOn__cIMxo`,
	"clockFabDot": `dashboard_clockFabDot__K-3uB`,
	"clockFabText": `dashboard_clockFabText__GiCJc`,
	"clockFabLabel": `dashboard_clockFabLabel__JbH4d`,
	"clockFabSub": `dashboard_clockFabSub__vbVAI`
};
export default ___CSS_LOADER_EXPORT___;
